/* eslint-disable */
import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
import * as Operations from '../operation';
import * as Urql from 'urql';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type Omit<T, K extends keyof T> = Pick<T, Exclude<keyof T, K>>;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  /** 住所 */
  Address: any;
  /** RFC 822 で定義されている local@example.com 形式のメールアドレス */
  Email: any;
  /** IPv4 もしくは IPv6 アドレスを表します */
  IPAddress: string;
  /** 任意の JSON */
  JSON: any;
  /**
   * 郵便番号
   *
   * xxx-xxxx 形式であること
   */
  PostalCode: any;
  /** ナノ秒までを保持する 2006-01-02T15:04:05.999999999Z07:00 形式の文字列です */
  Time: string;
  /** RFC 1738 に準じた URL を表します */
  URL: string;
  /** 16進法による UUID 文字列 */
  UUID: any;
  Upload: any;
};

/** Eメールアドレス変更受付失敗 */
export type AcceptChangeEmailFailed = {
  __typename?: 'AcceptChangeEmailFailed';
  reason?: Maybe<Scalars['String']>;
};

/** Eメールアドレス変更受付インプット */
export type AcceptChangeEmailInput = {
  newEmail: Scalars['Email'];
};

/** Eメールアドレス変更受付結果 */
export type AcceptChangeEmailResult = AcceptChangeEmailFailed | AcceptChangeEmailSuccess;

/** Eメールアドレス変更受付成功 */
export type AcceptChangeEmailSuccess = {
  __typename?: 'AcceptChangeEmailSuccess';
  message?: Maybe<Scalars['String']>;
};

export type AcceptPasswordResetFailure = {
  __typename?: 'AcceptPasswordResetFailure';
  message: Scalars['String'];
};

export type AcceptPasswordResetInput = {
  userId: Scalars['String'];
};

export type AcceptPasswordResetResult = AcceptPasswordResetFailure | AcceptPasswordResetSuccess;

export type AcceptPasswordResetSuccess = {
  __typename?: 'AcceptPasswordResetSuccess';
  message: Scalars['String'];
};

export type AddImageFailed = {
  __typename?: 'AddImageFailed';
  reason?: Maybe<Scalars['String']>;
};

export type AddImageInput = {
  /** 画像名 */
  name: Scalars['String'];
  /** 画像URL */
  src: Scalars['URL'];
};

export type AddImageResult = AddImageFailed | AddImageSuccess;

export type AddImageSuccess = {
  __typename?: 'AddImageSuccess';
  image: Image;
};

export type AddIngressIpAddressFailed = {
  __typename?: 'AddIngressIPAddressFailed';
  reason: Scalars['String'];
};

export type AddIngressIpAddressInput = {
  /** 対象カンパニー */
  company: Scalars['ID'];
  /** IP アドレス */
  ipAddress: Scalars['IPAddress'];
  /** 通信許可IPアドレス設定名 */
  name: Scalars['String'];
  /** 備考 */
  remark?: InputMaybe<Scalars['String']>;
};

export type AddIngressIpAddressResult = AddIngressIpAddressFailed | AddIngressIpAddressSuccess;

export type AddIngressIpAddressSuccess = {
  __typename?: 'AddIngressIPAddressSuccess';
  ingressIPAddress: IngressIpAddress;
};

export type AddLoginWhitelistFailed = {
  __typename?: 'AddLoginWhitelistFailed';
  reason: Scalars['String'];
};

export type AddLoginWhitelistInput = {
  /** 無制限にログインが許可されている IP アドレス */
  ipAddress: Scalars['IPAddress'];
  /** ホワイトリスト名 */
  name: Scalars['String'];
};

export type AddLoginWhitelistResult = AddLoginWhitelistFailed | AddLoginWhitelistSuccess;

export type AddLoginWhitelistSuccess = {
  __typename?: 'AddLoginWhitelistSuccess';
  /** 作成したログインホワイトリスト */
  loginWhitelist: LoginWhitelist;
};

/** スピーチ失敗 */
export type AddSpeechFailed = {
  __typename?: 'AddSpeechFailed';
  reason?: Maybe<Scalars['String']>;
};

/** スピーチ追加インプット */
export type AddSpeechInput = {
  /** スピーチ名 */
  name: Scalars['String'];
  /** 再生時間（秒） */
  playTime?: InputMaybe<Scalars['Int']>;
  /** 備考 */
  remark?: InputMaybe<Scalars['String']>;
  /** スピーチURL */
  src: Scalars['URL'];
  /** スピーチVal */
  value: Scalars['String'];
};

/** スピーチ追加結果 */
export type AddSpeechResult = AddSpeechFailed | AddSpeechSuccess;

/** スピーチ追加成功 */
export type AddSpeechSuccess = {
  __typename?: 'AddSpeechSuccess';
  speech: Speech;
};

/** 動画追加失敗 */
export type AddVideoFailed = {
  __typename?: 'AddVideoFailed';
  /** 理由 */
  reason?: Maybe<Scalars['String']>;
};

/** 動画追加インプット */
export type AddVideoInput = {
  /** 動画名 */
  name: Scalars['String'];
  /** 再生時間（秒） */
  playTime?: InputMaybe<Scalars['Int']>;
  /** 備考 */
  remark?: InputMaybe<Scalars['String']>;
  /** 動画URL */
  src: Scalars['URL'];
  /** 動画Val */
  value: Scalars['String'];
};

/** 動画追加結果 */
export type AddVideoResult = AddVideoFailed | AddVideoSuccess;

/** 動画追加成功 */
export type AddVideoSuccess = {
  __typename?: 'AddVideoSuccess';
  /** 追加した動画 */
  video: Video;
};

/**
 * 分析項目集計結果
 *
 * 指定期間における接客情報のうち、特定の分析項目が選択された回数を集計します。
 */
export type AggregateByAnalyticalInfo = {
  __typename?: 'AggregateByAnalyticalInfo';
  /** 分析項目名 */
  analyticalInfoName: Scalars['String'];
  /** 合計数 */
  count: Scalars['Int'];
  /**
   * 割合
   *
   * 指定期間中に選択さた分析項目のうち、何パーセントを占めるかを表します。
   */
  percentage: Scalars['Int'];
};

/**
 * 分析アクション
 *
 * 接客中の操作情報を表します。
 */
export type AnAction = AnActionImage | AnActionMemo | AnActionSpeech | AnActionVideo;

/** 分析アクション 画像 */
export type AnActionImage = Node & {
  __typename?: 'AnActionImage';
  /** アクション日時 */
  actionAt: Scalars['Time'];
  /** データストアID */
  datastoreId: Scalars['String'];
  /** オブジェクトID */
  id: Scalars['ID'];
  /** 画像 */
  image?: Maybe<Image>;
};

export type AnActionInput = {
  /** 画像 */
  image?: InputMaybe<Scalars['ID']>;
  /** メモ */
  memo?: InputMaybe<Scalars['ID']>;
  /** スピーチ */
  speech?: InputMaybe<Scalars['ID']>;
  /** アクション日時 */
  time?: InputMaybe<Scalars['Time']>;
  /** ファイルパス */
  url?: InputMaybe<Scalars['URL']>;
  /** アクション値 */
  val: Scalars['String'];
  /** 動画 */
  video?: InputMaybe<Scalars['ID']>;
};

/** 分析アクション メモ */
export type AnActionMemo = Node & {
  __typename?: 'AnActionMemo';
  /** アクション日時 */
  actionAt: Scalars['Time'];
  /** データストアID */
  datastoreId: Scalars['String'];
  /** オブジェクトID */
  id: Scalars['ID'];
  /** メモ */
  memo?: Maybe<Memo>;
};

/** 分析アクション スピーチ */
export type AnActionSpeech = Node & {
  __typename?: 'AnActionSpeech';
  /** アクション日時 */
  actionAt: Scalars['Time'];
  /** データストアID */
  datastoreId: Scalars['String'];
  /** オブジェクトID */
  id: Scalars['ID'];
  /** スピーチ */
  speech?: Maybe<Speech>;
};

/** 分析アクション 動画 */
export type AnActionVideo = Node & {
  __typename?: 'AnActionVideo';
  /** アクション日時 */
  actionAt: Scalars['Time'];
  /** データストアID */
  datastoreId: Scalars['String'];
  /** オブジェクトID */
  id: Scalars['ID'];
  /** 動画 */
  video?: Maybe<Video>;
};

/**
 * 接客分析項目
 *
 * 接客時に選択された分析項目
 */
export type AnAnalyticalInfo = Node & {
  __typename?: 'AnAnalyticalInfo';
  /** 分析項目 */
  analyticalInfo?: Maybe<AnalyticalInfo>;
  /** 分析項目種別 */
  analyticalInfoType?: Maybe<AnalyticalInfoType>;
  /** データストアID */
  datastoreId: Scalars['String'];
  /** オブジェクトID */
  id: Scalars['ID'];
};

/** 接客分析項目インプット */
export type AnAnalyticalInfoInput = {
  /** 分析項目ID */
  analyticalInfoId: Scalars['ID'];
  /** 日時 */
  time?: InputMaybe<Scalars['Time']>;
};

/** 棒グラフ */
export type AnBarGraph = {
  __typename?: 'AnBarGraph';
  /** 分析グラフ設定 */
  anGraph: AnGraph;
  /** 分析項目種別 */
  analyticalInfoType: AnalyticalInfoType;
  /** 日別分析項目集計結果一覧 */
  dailyAggregateByAnalyticalInfoList: Array<DailyAggregateByAnalyticalInfo>;
  /** 総接客回数 */
  servedCount: Scalars['Int'];
};

/** 分析グラフ設定 */
export type AnGraph = Node & {
  __typename?: 'AnGraph';
  /** 分析項目一覧 */
  analyticalInfoList: Array<Maybe<AnalyticalInfo>>;
  /** 分析項目種別 */
  analyticalInfoType?: Maybe<AnalyticalInfoType>;
  /** カンパニー */
  company: Company;
  /** データストアID */
  datastoreId: Scalars['String'];
  /** 分析グラフ設定ID */
  id: Scalars['ID'];
  /** グラフ種別 */
  type: AnGraphType;
};

/** 分析グラフ種別 */
export enum AnGraphType {
  /** 棒グラフ */
  Bar = 'BAR',
  /** 線グラフ */
  Line = 'LINE',
  /** 円グラフ */
  Pie = 'PIE'
}

/** 線グラフ */
export type AnLineGraph = {
  __typename?: 'AnLineGraph';
  /** 分析グラフ設定 */
  anGraph: AnGraph;
  /** 分析項目種別 */
  analyticalInfoType: AnalyticalInfoType;
  /** 日別分析項目集計結果一覧 */
  dailyAggregateByAnalyticalInfoList: Array<DailyAggregateByAnalyticalInfo>;
};

/** 分析写真 */
export type AnPicture = Node & {
  __typename?: 'AnPicture';
  /** カメラID */
  cameraId: Scalars['String'];
  /** カンパニーID */
  companyId: Scalars['String'];
  /** データストアID */
  datastoreId: Scalars['String'];
  /** ファイルパス */
  fileName?: Maybe<Scalars['URL']>;
  /** オブジェクトID */
  id: Scalars['ID'];
  /** PC ID */
  pcId: Scalars['String'];
  /** 店舗名 */
  pcName: Scalars['String'];
  /** ファイルパス (署名付きURL) */
  presignedFileName?: Maybe<Scalars['URL']>;
  /** アップロード日時 */
  uploadedAt: Scalars['Time'];
};

export type AnPictureConnection = Connection & {
  __typename?: 'AnPictureConnection';
  /** エッジ一覧 */
  edges: Array<AnPictureEdge>;
  /** ノード一覧 */
  nodes: Array<AnPicture>;
  /** ページ情報 */
  pageInfo: PageInfo;
  /** 総件数 */
  totalCount: Scalars['Int'];
};

export type AnPictureEdge = Edge & {
  __typename?: 'AnPictureEdge';
  /** カーソル */
  cursor: Scalars['String'];
  /** ノード */
  node: AnPicture;
};

export enum AnPictureField {
  /** アップロード日時 */
  UploadedAt = 'UPLOADED_AT'
}

/** 分析写真ソート条件 */
export type AnPictureOrder = {
  /** ソート順 */
  direction: OrderDirection;
  /** ソート対象フィールド */
  field: AnPictureField;
};

/** 円グラフ */
export type AnPieGraph = {
  __typename?: 'AnPieGraph';
  /** 分析項目集計結果一覧 */
  aggregateByAnalyticalInfoList: Array<AggregateByAnalyticalInfo>;
  /** 分析グラフ設定 */
  anGraph: AnGraph;
  /** 分析項目種別 */
  analyticalInfoType: AnalyticalInfoType;
  /**
   * 総接客回数
   *
   * 「日別分析項目集計結果一覧」の
   */
  servedCount: Scalars['Int'];
};

/** 分析グラフ */
export type AnalysisGraph = AnBarGraph | AnLineGraph | AnPieGraph;

/** 分析項目のソート可能フィールド */
export enum AnalyticalField {
  /** 優先度 */
  Priority = 'PRIORITY'
}

/** 分析項目 */
export type AnalyticalInfo = Node & {
  __typename?: 'AnalyticalInfo';
  /** 所属する分析項目グループ */
  analyticalInfoGroup?: Maybe<AnalyticalInfoGroup>;
  /** 分析項目種別 */
  analyticalInfoType?: Maybe<AnalyticalInfoType>;
  /** 分析種別 */
  analyticalType: AnalyticalType;
  /** カンパニー */
  company: Company;
  /** データストアID */
  datastoreId: Scalars['String'];
  /** アイコン名 */
  icon?: Maybe<Scalars['String']>;
  /** オブジェクトID */
  id: Scalars['ID'];
  /** 分析項目名 */
  name: Scalars['String'];
  /** 優先度 */
  priority: Scalars['Int'];
  /** 備考 */
  remark?: Maybe<Scalars['String']>;
  /** 分析タイミング */
  timing: AnalyticalTiming;
  /** 分析項目値 */
  value: Scalars['String'];
};

/** 分析項目コネクション */
export type AnalyticalInfoConnection = Connection & {
  __typename?: 'AnalyticalInfoConnection';
  /** エッジ一覧 */
  edges: Array<AnalyticalInfoEdge>;
  /** ノード一覧 */
  nodes: Array<AnalyticalInfo>;
  /** ページ情報 */
  pageInfo: PageInfo;
  /** 総件数 */
  totalCount: Scalars['Int'];
};

/** 分析項目エッジ */
export type AnalyticalInfoEdge = Edge & {
  __typename?: 'AnalyticalInfoEdge';
  /** カーソル */
  cursor: Scalars['String'];
  /** ノード */
  node: AnalyticalInfo;
};

/** 分析項目グループ */
export type AnalyticalInfoGroup = Node & {
  __typename?: 'AnalyticalInfoGroup';
  /** グループに属する分析項目の一覧 */
  analyticalButtons?: Maybe<Array<AnalyticalInfo>>;
  /** データストアID */
  datastoreId: Scalars['String'];
  /** オブジェクトID */
  id: Scalars['ID'];
  /** グループ名 */
  name: Scalars['String'];
  /** グループ所有者 */
  owner: Company;
  /** 優先度 */
  priority: Scalars['Int'];
};


/** 分析項目グループ */
export type AnalyticalInfoGroupAnalyticalButtonsArgs = {
  orderBy?: InputMaybe<AnalyticalOrder>;
};

/** 分析項目種別 */
export type AnalyticalInfoType = Node & {
  __typename?: 'AnalyticalInfoType';
  /** 分析項目一覧 */
  analyticalInfoList?: Maybe<Array<AnalyticalInfo>>;
  /** 分析種別 */
  analyticalType: AnalyticalType;
  /** データストアID */
  datastoreId: Scalars['String'];
  /** オブジェクトID */
  id: Scalars['ID'];
  /** 分析項目種別の所有者 */
  owner: Company;
  /** 分析項目種別名 */
  text: Scalars['String'];
};

/** 分析項目種別コネクション */
export type AnalyticalInfoTypeConnection = Connection & {
  __typename?: 'AnalyticalInfoTypeConnection';
  /** エッジ一覧 */
  edges: Array<AnalyticalInfoTypeEdge>;
  /** ノード一覧 */
  nodes: Array<AnalyticalInfoType>;
  /** ページ情報 */
  pageInfo: PageInfo;
  /** 総件数 */
  totalCount: Scalars['Int'];
};

/** 分析項目種別エッジ */
export type AnalyticalInfoTypeEdge = Edge & {
  __typename?: 'AnalyticalInfoTypeEdge';
  /** カーソル */
  cursor: Scalars['String'];
  /** ノード */
  node: AnalyticalInfoType;
};

/** メディアのソート条件 */
export type AnalyticalOrder = {
  /** ソート順 */
  direction: OrderDirection;
  /** ソート対象フィールド */
  field: AnalyticalField;
};

/** 分析タイミング */
export enum AnalyticalTiming {
  /** 接客後 */
  After = 'AFTER',
  /** 接客中 */
  During = 'DURING'
}

/** 分析種別 */
export enum AnalyticalType {
  /** コンテンツ */
  Contents = 'CONTENTS',
  /** 感情 */
  Emotion = 'EMOTION'
}

/** 店鋪設定反映失敗 */
export type ApplyPreferencesForPcListFailed = {
  __typename?: 'ApplyPreferencesForPcListFailed';
  reason: Scalars['String'];
};

/** 店鋪設定反映インプット */
export type ApplyPreferencesForPcListInput = {
  /** 反映対象店鋪一覧 */
  pcList: Array<Scalars['ID']>;
};

/** 店鋪設定反映結果 */
export type ApplyPreferencesForPcListResult = ApplyPreferencesForPcListFailed | ApplyPreferencesForPcListSuccess;

/** 店鋪設定反映成功 */
export type ApplyPreferencesForPcListSuccess = {
  __typename?: 'ApplyPreferencesForPcListSuccess';
  pcList: Array<Pc>;
};

export type AttachAnalyticalInfoToPcFailed = {
  __typename?: 'AttachAnalyticalInfoToPcFailed';
  reason: Scalars['String'];
};

export type AttachAnalyticalInfoToPcInput = {
  analyticalInfo: Scalars['ID'];
  pc: Scalars['ID'];
};

export type AttachAnalyticalInfoToPcResult = AttachAnalyticalInfoToPcFailed | AttachAnalyticalInfoToPcSuccess;

export type AttachAnalyticalInfoToPcSuccess = {
  __typename?: 'AttachAnalyticalInfoToPcSuccess';
  pc: Pc;
};

/** 画像グループと画像の紐付け失敗 */
export type AttachImageGroupToImageFailed = {
  __typename?: 'AttachImageGroupToImageFailed';
  /** 失敗理由 */
  reason: Scalars['String'];
};

export type AttachImageGroupToImageInput = {
  /** 画像 */
  image: Scalars['ID'];
  /** 紐付け先の画像グループ */
  imageGroup: Scalars['ID'];
};

/** 画像グループと画像の紐付け結果 */
export type AttachImageGroupToImageResult = AttachImageGroupToImageFailed | AttachImageGroupToImageSuccess;

/** 画像グループと画像の紐付け成功 */
export type AttachImageGroupToImageSuccess = {
  __typename?: 'AttachImageGroupToImageSuccess';
  /** 画像 */
  image: Image;
};

export type AttachImageToPcFailed = {
  __typename?: 'AttachImageToPcFailed';
  reason: Scalars['String'];
};

export type AttachImageToPcInput = {
  image: Scalars['ID'];
  pc: Scalars['ID'];
};

export type AttachImageToPcResult = AttachImageToPcFailed | AttachImageToPcSuccess;

export type AttachImageToPcSuccess = {
  __typename?: 'AttachImageToPcSuccess';
  pc: Pc;
};

/** メディア・イベント紐付け失敗 */
export type AttachMediaEventFailed = {
  __typename?: 'AttachMediaEventFailed';
  /** 理由 */
  reason?: Maybe<Scalars['String']>;
};

/** メディア・イベント紐付けインプット */
export type AttachMediaEventInput = {
  /** イベント */
  event: MediaEventType;
  /** 紐付け対象メディア */
  media: Scalars['ID'];
  /** 紐付け先 */
  owner: Scalars['ID'];
};

/** メディア・イベント紐付け結果 */
export type AttachMediaEventResult = AttachMediaEventFailed | AttachMediaEventSuccess;

/** メディア・イベント紐付け成功 */
export type AttachMediaEventSuccess = {
  __typename?: 'AttachMediaEventSuccess';
  /** メディア・イベント */
  mediaEvent: MediaEvent;
};

/** 店舗メディア・イベント登録失敗 */
export type AttachMediaEventToPcFailed = {
  __typename?: 'AttachMediaEventToPcFailed';
  /** 理由 */
  reason?: Maybe<Scalars['String']>;
};

/** 店舗メディア・イベント登録インプット */
export type AttachMediaEventToPcInput = {
  /** イベント */
  event: MediaEventType;
  /** 紐付け対象メディア */
  media: Scalars['ID'];
  /** 紐付け先 PC */
  pcId: Scalars['ID'];
};

/** 店舗メディア・イベント登録結果 */
export type AttachMediaEventToPcResult = AttachMediaEventToPcFailed | AttachMediaEventToPcSuccess;

/** 店舗メディア・イベント登録成功 */
export type AttachMediaEventToPcSuccess = {
  __typename?: 'AttachMediaEventToPcSuccess';
  /** メディア・イベント */
  mediaEvent: MediaEvent;
};

export type AttachNotificationToPcFailed = {
  __typename?: 'AttachNotificationToPcFailed';
  reason: Scalars['String'];
};

export type AttachNotificationToPcInput = {
  notification: Scalars['ID'];
  pc: Scalars['ID'];
};

export type AttachNotificationToPcResult = AttachNotificationToPcFailed | AttachNotificationToPcSuccess;

export type AttachNotificationToPcSuccess = {
  __typename?: 'AttachNotificationToPcSuccess';
  pc: Pc;
};

export type AttachScenarioToPcFailed = {
  __typename?: 'AttachScenarioToPcFailed';
  reason: Scalars['String'];
};

export type AttachScenarioToPcInput = {
  /** 紐付け先 PC */
  pc: Scalars['ID'];
  /** 紐付け対象シナリオ */
  scenario: Scalars['ID'];
};

export type AttachScenarioToPcResult = AttachScenarioToPcFailed | AttachScenarioToPcSuccess;

export type AttachScenarioToPcSuccess = {
  __typename?: 'AttachScenarioToPcSuccess';
  pc: Pc;
  scenario: Scenario;
};

export type AttachSoundToPcFailed = {
  __typename?: 'AttachSoundToPcFailed';
  reason: Scalars['String'];
};

export type AttachSoundToPcInput = {
  pc: Scalars['ID'];
  soundEventType: SoundEventType;
  soundId: Scalars['ID'];
};

export type AttachSoundToPcResult = AttachSoundToPcFailed | AttachSoundToPcSuccess;

export type AttachSoundToPcSuccess = {
  __typename?: 'AttachSoundToPcSuccess';
  pc: Pc;
};

export type AttachSpeechToPcFailed = {
  __typename?: 'AttachSpeechToPcFailed';
  reason: Scalars['String'];
};

export type AttachSpeechToPcInput = {
  pc: Scalars['ID'];
  speech: Scalars['ID'];
};

export type AttachSpeechToPcResult = AttachSpeechToPcFailed | AttachSpeechToPcSuccess;

export type AttachSpeechToPcSuccess = {
  __typename?: 'AttachSpeechToPcSuccess';
  pc: Pc;
};

export type AttachUserGroupsToNotificationFailed = {
  __typename?: 'AttachUserGroupsToNotificationFailed';
  reason: Scalars['String'];
};

export type AttachUserGroupsToNotificationInput = {
  /**
   * 対象カンパニー
   *
   * タイムリープに所属するユーザーのみカンパニーの指定が可能です。
   */
  company?: InputMaybe<Scalars['ID']>;
  /** 対象の通知 */
  notificationId: Scalars['ID'];
  /** 通知対象としたいUserGroupの一覧 */
  userGroups: Array<Scalars['ID']>;
};

export type AttachUserGroupsToNotificationResult = AttachUserGroupsToNotificationFailed | AttachUserGroupsToNotificationSuccess;

export type AttachUserGroupsToNotificationSuccess = {
  __typename?: 'AttachUserGroupsToNotificationSuccess';
  /** ユーザーグループを紐付けた通知 */
  notification: Notification;
};

export type AttachVideoGroupToVideoFailed = {
  __typename?: 'AttachVideoGroupToVideoFailed';
  reason: Scalars['String'];
};

export type AttachVideoGroupToVideoInput = {
  videoGroupId: Scalars['ID'];
  videoId: Scalars['ID'];
};

export type AttachVideoGroupToVideoResult = AttachVideoGroupToVideoFailed | AttachVideoGroupToVideoSuccess;

export type AttachVideoGroupToVideoSuccess = {
  __typename?: 'AttachVideoGroupToVideoSuccess';
  videoGroup: VideoGroup;
};

/** PC 動画紐付け登録失敗 */
export type AttachVideoToPcFailed = {
  __typename?: 'AttachVideoToPcFailed';
  reason?: Maybe<Scalars['String']>;
};

/** PC 動画紐付け登録インプット */
export type AttachVideoToPcInput = {
  /** 紐付け先PC */
  pcId: Scalars['ID'];
  /** 紐付け対象動画 */
  videoId: Scalars['ID'];
};

/** PC 動画紐付け登録結果 */
export type AttachVideoToPcResult = AttachVideoToPcFailed | AttachVideoToPcSuccess;

/** PC 動画紐付け登録成功 */
export type AttachVideoToPcSuccess = {
  __typename?: 'AttachVideoToPcSuccess';
  message?: Maybe<Scalars['String']>;
};

/** 接客アバター */
export type Avatar = Node & {
  __typename?: 'Avatar';
  /**
   * アバターを所有するカンパニー
   *
   * 当フィールドが null の場合は全てのカンパニーが利用できるアバターです。
   */
  company?: Maybe<Company>;
  /** データストアID */
  datastoreId: Scalars['String'];
  /** オブジェクトID */
  id: Scalars['ID'];
  /** モーション一覧 */
  motions: Array<Motion>;
  /** アバター名 */
  name: Scalars['String'];
};

export type AvatarConnection = Connection & {
  __typename?: 'AvatarConnection';
  /** エッジ一覧 */
  edges: Array<AvatarEdge>;
  /** ノード一覧 */
  nodes: Array<Avatar>;
  /** ページ情報 */
  pageInfo: PageInfo;
  /** 総件数 */
  totalCount: Scalars['Int'];
};

export type AvatarEdge = Edge & {
  __typename?: 'AvatarEdge';
  /** カーソル */
  cursor: Scalars['String'];
  /** ノード */
  node: Avatar;
};

export type BackGroundMedia = Image | Video;

/** 背景メディア種別 */
export enum BackGroundMediaType {
  /** 画像 */
  Image = 'IMAGE',
  /** 動画 */
  Video = 'VIDEO'
}

/** 支店 */
export type Branch = Node & {
  __typename?: 'Branch';
  /** 住所 */
  address?: Maybe<Scalars['String']>;
  /** 分析ボタン一覧 */
  analyticalInfos?: Maybe<Array<AnalyticalInfo>>;
  /** 支店が属するカンパニー */
  company: Company;
  /** データストアID */
  datastoreId: Scalars['UUID'];
  /** オブジェクトID */
  id: Scalars['ID'];
  /** 画像一覧 */
  images?: Maybe<Array<Image>>;
  /** メディア・イベント一覧 */
  mediaEvents?: Maybe<Array<MediaEvent>>;
  /** メモ一覧 */
  memos?: Maybe<Array<Memo>>;
  /** 支店名 */
  name: Scalars['String'];
  /** 通知一覧 */
  notifications?: Maybe<Array<Notification>>;
  /** PC 一覧 */
  pcs?: Maybe<Array<Pc>>;
  /** 郵便番号 */
  postalCode?: Maybe<Scalars['PostalCode']>;
  /** 備考 */
  remark?: Maybe<Scalars['String']>;
  /** サウンド・イベント一覧 */
  soundEvents?: Maybe<Array<SoundEvent>>;
  /** 音声一覧 */
  speeches?: Maybe<Array<Speech>>;
  /** 電話番号 */
  tel?: Maybe<Scalars['String']>;
  /** 動画一覧 */
  videos?: Maybe<Array<Video>>;
};


/** 支店 */
export type BranchAnalyticalInfosArgs = {
  orderBy?: InputMaybe<AnalyticalOrder>;
};


/** 支店 */
export type BranchImagesArgs = {
  orderBy?: InputMaybe<MediaOrder>;
};


/** 支店 */
export type BranchMemosArgs = {
  orderBy?: InputMaybe<MemoOrder>;
};


/** 支店 */
export type BranchNotificationsArgs = {
  orderBy?: InputMaybe<NotificationOrder>;
};


/** 支店 */
export type BranchSpeechesArgs = {
  orderBy?: InputMaybe<MediaOrder>;
};


/** 支店 */
export type BranchVideosArgs = {
  orderBy?: InputMaybe<MediaOrder>;
};

/**
 * ブランチアカウント
 *
 * ブランチアカウントは、以下「認証方式」によってagasaからtokenを得ること(「認証」)で、agasaのQuery, Mutationを利用するための「認可」を受けることができるようになる。(= ログイン)
 *
 * ブランチアカウント における「認証方式」は、以下のいずれかが許可されている
 * - カンパニーID, ブランチアカウントID, IPアドレス によるもの
 * - カンパニーID, ブランチアカウントID, パスワード によるもの
 *
 * Userアカウントとの違いは以下2点である。
 * - カンパニー内でユニークなIDを定義することが可能である点
 * - 1つ目の「認証方式」であれば、ユーザーはブランチアカウントID(例えば、拠点毎に異なる店舗番号やエリアコード)の入力のみで「認証」「認可」を受けられる点
 * - ブランチアカウントを利用する拠点やエリアのグローバルIPアドレスが固定される条件を満たす必要がある。
 * - SIMルータなどは上記制約を満たすことが難しい場合は2つ目の「認証方式」を用いる。
 *
 * ここでの「認可」とは、ヘッダに付与されたtokenを用いた以下の検証である。
 * - tokenが期限内であることの確認
 * - ブランチアカウントの識別
 *
 * type UserにuserTypeをSYSTEM, roleをADMINとして使って実現ができるが、Userアカウントとは「認証方式」が異なるためテーブルやモデルを分ける判断とした。
 * またブランチアカウントの全ては、暗黙的にuserType: SYSTEM, role: ADMINである。
 */
export type BranchAccount = Node & {
  __typename?: 'BranchAccount';
  /** 支店 */
  branch: Branch;
  /**
   * カンパニー内で支店ごとにユニークなID
   *
   * e.g) 店舗番号
   */
  branchUniqueId: Scalars['String'];
  /** ブランチアカウントの所属先カンパニー */
  company: Company;
  /** データストアID */
  datastoreId: Scalars['UUID'];
  /** オブジェクトID */
  id: Scalars['ID'];
  /**
   * お客様のLANのIPアドレス
   *
   * IPアドレスが設定されている場合、設定されている IP アドレスからのリクエストのみ許可されます。
   * @deprecated ipAddresses フィールドを使用してください
   */
  ipAddress?: Maybe<Scalars['String']>;
  /**
   * お客様のLANのIPアドレス一覧
   *
   * IPアドレスが設定されている場合、設定されている IP アドレスからのリクエストのみ許可されます。
   */
  ipAddresses?: Maybe<Array<Scalars['IPAddress']>>;
  /** ブランチアカウント名 */
  name: Scalars['String'];
  /** 備考 */
  remark?: Maybe<Scalars['String']>;
  /** 認証用トークンの有効期限 */
  tokenExpiration: Scalars['Time'];
};

/** BranchAccount コネクション */
export type BranchAccountConnection = Connection & {
  __typename?: 'BranchAccountConnection';
  /** エッジ一覧 */
  edges: Array<BranchAccountEdge>;
  /** ノード一覧 */
  nodes: Array<BranchAccount>;
  /** ページ情報 */
  pageInfo: PageInfo;
  /** 総件数 */
  totalCount: Scalars['Int'];
};

/** BranchAccount エッジ */
export type BranchAccountEdge = Edge & {
  __typename?: 'BranchAccountEdge';
  /** カーソル */
  cursor: Scalars['String'];
  /** ノード */
  node: BranchAccount;
};

/** 支店アカウントのソート条件 */
export type BranchAccountOrder = {
  /** ソート順 */
  direction: OrderDirection;
  /** ソート対象フィールド */
  field: BranchAccountOrderField;
};

/** 支店のソート可能フィールド */
export enum BranchAccountOrderField {
  /** 支店アカウントID */
  BranchAccountId = 'BRANCH_ACCOUNT_ID'
}

export type BranchConnection = Connection & {
  __typename?: 'BranchConnection';
  /** エッジ一覧 */
  edges: Array<BranchEdge>;
  /** ノード一覧 */
  nodes: Array<Branch>;
  /** ページ情報 */
  pageInfo: PageInfo;
  /** 総件数 */
  totalCount: Scalars['Int'];
};

export type BranchEdge = Edge & {
  __typename?: 'BranchEdge';
  /** カーソル */
  cursor: Scalars['String'];
  /** ノード */
  node: Branch;
};

/** RURAブラウザ状態 */
export enum BrowserStatus {
  /** 命令:再起動/更新する */
  Reboot = 'REBOOT',
  /** 命令:起動する */
  Start = 'START',
  /** 状態:起動中 */
  Starting = 'STARTING',
  /** 命令:停止する */
  Stop = 'STOP',
  /** 状態:停止中 */
  Stopped = 'STOPPED'
}

/** ボタン配置 */
export enum ButtonsPosition {
  /** 下段 */
  Bottom = 'BOTTOM',
  /** 中段 */
  Center = 'CENTER',
  /** 上段 */
  Top = 'TOP'
}

export type ChangePasswordFailed = {
  __typename?: 'ChangePasswordFailed';
  reason?: Maybe<Scalars['String']>;
};

export type ChangePasswordInput = {
  password: Scalars['String'];
  passwordResetToken: Scalars['String'];
};

export type ChangePasswordResult = ChangePasswordFailed | ChangePasswordSuccess;

export type ChangePasswordSuccess = {
  __typename?: 'ChangePasswordSuccess';
  message?: Maybe<Scalars['String']>;
  /** パスワード再設定を行ったユーザーのロール */
  role: Role;
};

/** ボタン列数 */
export enum ColsButtonsArrangement {
  /** 2列 */
  Double = 'DOUBLE',
  /** 3列 */
  Triple = 'TRIPLE'
}

/** カンパニー */
export type Company = Node & {
  __typename?: 'Company';
  /** データストアにおけるID */
  datastoreId: Scalars['String'];
  /** 拡張アプリ */
  extensionApps?: Maybe<Array<ExtensionApp>>;
  /** 機能トグル一覧 */
  featureToggles: Array<FeatureToggle>;
  /** オブジェクトID */
  id: Scalars['ID'];
  /**
   * IP アドレスの制限がかかっているか
   *
   * true の場合、特定 IP からのリクエストしか許可しません。
   */
  isIPRestraint: Scalars['Boolean'];
  /** カンパニー名 */
  name: Scalars['String'];
  /** レコードフラグ */
  recordFlg?: Maybe<Scalars['Boolean']>;
};


/** カンパニー */
export type CompanyExtensionAppsArgs = {
  activeOnly?: InputMaybe<Scalars['Boolean']>;
};

/** カンパニーコネクション */
export type CompanyConnection = Connection & {
  __typename?: 'CompanyConnection';
  /** エッジ一覧 */
  edges: Array<CompanyEdge>;
  /** ノード一覧 */
  nodes: Array<Company>;
  /** ページ情報 */
  pageInfo: PageInfo;
  /** 総件数 */
  totalCount: Scalars['Int'];
};

/** カンパニーエッジ */
export type CompanyEdge = Edge & {
  __typename?: 'CompanyEdge';
  /** カーソル */
  cursor: Scalars['String'];
  /** ノード */
  node: Company;
};

/** カンパニーに関する情報 */
export type CompanyOverview = {
  __typename?: 'CompanyOverview';
  /** カンパニーにおける店舗数(pcs Queryの許可ロールはADMIN, OWNERのため、合計数を取得可能なスキーマを別途定義) */
  pcsCount: Scalars['Int'];
  /** カンパニーにおける登録スタッフ数(users Queryの許可ロールはADMIN, OWNERのため、合計数を取得可能なスキーマを別途定義) */
  staffsCount: Scalars['Int'];
};


/** カンパニーに関する情報 */
export type CompanyOverviewStaffsCountArgs = {
  types?: InputMaybe<Array<UserType>>;
};

/** Relay Cursor Connection */
export type Connection = {
  /** エッジ一覧 */
  edges: Array<Edge>;
  /** ノード一覧 */
  nodes: Array<Node>;
  /** ページ情報 */
  pageInfo: PageInfo;
  /** 総件数 */
  totalCount: Scalars['Int'];
};

export type CopyScenarioFailed = {
  __typename?: 'CopyScenarioFailed';
  reason: Scalars['String'];
};

export type CopyScenarioInput = {
  /** コピー元シナリオID */
  baseScenario: Scalars['ID'];
  /**
   * コピー対象カンパニー
   *
   * 原則として認証ユーザーが属するカンパニーのシナリオ、シナリオビュー、シナリオボタンをコピー可能ですが、
   * 当引数で指定されたカンパニーのシナリオ、シナリオビュー、シナリオボタンを更新対象とします。
   */
  company?: InputMaybe<Scalars['ID']>;
};

export type CopyScenarioResult = CopyScenarioFailed | CopyScenarioSuccess;

export type CopyScenarioSuccess = {
  __typename?: 'CopyScenarioSuccess';
  scenario: Scenario;
};

export type CopyScenarioViewFailed = {
  __typename?: 'CopyScenarioViewFailed';
  reason: Scalars['String'];
};

export type CopyScenarioViewInput = {
  /** コピー元シナリオビューID */
  baseScenarioView: Scalars['ID'];
  /**
   * コピー対象カンパニー
   *
   * 原則として認証ユーザーが属するカンパニーのシナリオ、シナリオビュー、シナリオボタンをコピー可能ですが、
   * 当引数で指定されたカンパニーのシナリオビュー、シナリオボタンを更新対象とします。
   */
  company?: InputMaybe<Scalars['ID']>;
};

export type CopyScenarioViewResult = CopyScenarioViewFailed | CopyScenarioViewSuccess;

export type CopyScenarioViewSuccess = {
  __typename?: 'CopyScenarioViewSuccess';
  scenarioView: ScenarioView;
};

/** 分析グラフ設定作成失敗 */
export type CreateAnGraphFailed = {
  __typename?: 'CreateAnGraphFailed';
  /** 失敗理由 */
  reason: Scalars['String'];
};

/** 分析グラフ設定作成インプット */
export type CreateAnGraphInput = {
  /** 分析項目一覧 */
  analyticalInfoList: Array<Scalars['ID']>;
  /** 分析項目種別 */
  analyticalInfoType: Scalars['ID'];
  /** グラフ種別 */
  type: AnGraphType;
};

/** 分析グラフ設定作成結果 */
export type CreateAnGraphResult = CreateAnGraphFailed | CreateAnGraphSuccess;

/** 分析グラフ設定作成成功 */
export type CreateAnGraphSuccess = {
  __typename?: 'CreateAnGraphSuccess';
  /** 分析グラフ設定 */
  anGraph: AnGraph;
};

export type CreateAnalyticalInfoFailed = {
  __typename?: 'CreateAnalyticalInfoFailed';
  reason: Scalars['String'];
};

export type CreateAnalyticalInfoInput = {
  /** 分析項目種別 */
  analyticalInfoType?: InputMaybe<Scalars['ID']>;
  /** 分析種別 */
  analyticalType: AnalyticalType;
  /** アイコン名 */
  icon?: InputMaybe<Scalars['String']>;
  /** 分析項目名 */
  name: Scalars['String'];
  /** 備考 */
  remark?: InputMaybe<Scalars['String']>;
  /** 分析タイミング */
  timing: AnalyticalTiming;
  /** 分析項目値 */
  value: Scalars['String'];
};

export type CreateAnalyticalInfoResult = CreateAnalyticalInfoFailed | CreateAnalyticalInfoSuccess;

export type CreateAnalyticalInfoSuccess = {
  __typename?: 'CreateAnalyticalInfoSuccess';
  analyticalInfo: AnalyticalInfo;
};

/** 分析項目種別作成失敗 */
export type CreateAnalyticalInfoTypeFailed = {
  __typename?: 'CreateAnalyticalInfoTypeFailed';
  /** 失敗理由 */
  reason: Scalars['String'];
};

/** 分析項目種別作成インプット */
export type CreateAnalyticalInfoTypeInput = {
  /** 分析種別 */
  analyticalType: AnalyticalType;
  /** 分析項目種別名 */
  text: Scalars['String'];
};

/** 分析項目種別作成結果 */
export type CreateAnalyticalInfoTypeResult = CreateAnalyticalInfoTypeFailed | CreateAnalyticalInfoTypeSuccess;

/** 分析項目種別作成成功 */
export type CreateAnalyticalInfoTypeSuccess = {
  __typename?: 'CreateAnalyticalInfoTypeSuccess';
  /** 分析項目種別 */
  analyticalInfoType: AnalyticalInfoType;
};

export type CreateBranchAccountFailed = {
  __typename?: 'CreateBranchAccountFailed';
  reason: Scalars['String'];
};

export type CreateBranchAccountInput = {
  /** 支店 */
  branch: Scalars['ID'];
  /**
   * カンパニー内で支店ごとにユニークなID
   *
   * e.g) 店舗番号
   */
  branchUniqueId: Scalars['String'];
  /**
   * 作成対象カンパニー
   *
   * 原則として認証ユーザーが属するカンパニーのみ支店アカウントの作成が可能ですが、
   * 当引数で指定されたカンパニーの支店アカウントを作成対象とします。
   */
  company?: InputMaybe<Scalars['ID']>;
  /**
   * LANのIPアドレス
   * @deprecated ipAddresses フィールドを使用してください
   */
  ipAddress?: InputMaybe<Scalars['String']>;
  /** お客様のLANのIPアドレス一覧 */
  ipAddresses?: InputMaybe<Array<Scalars['IPAddress']>>;
  /** 支店アカウント名 */
  name: Scalars['String'];
  /** パスワード */
  password: Scalars['String'];
  /** 備考 */
  remark?: InputMaybe<Scalars['String']>;
};

export type CreateBranchAccountResult = CreateBranchAccountFailed | CreateBranchAccountSuccess;

export type CreateBranchAccountSuccess = {
  __typename?: 'CreateBranchAccountSuccess';
  branchAccount: BranchAccount;
};

export type CreateBranchFailed = {
  __typename?: 'CreateBranchFailed';
  reason: Scalars['String'];
};

export type CreateBranchInput = {
  /** 住所 */
  address?: InputMaybe<Scalars['Address']>;
  /**
   * 支店が属するカンパニー
   *
   * 原則として認証ユーザーが属するカンパニーの支店のみを作成可能ですが、
   * 当引数で指定されたカンパニーの支店を作成対象とします。
   */
  company?: InputMaybe<Scalars['ID']>;
  /** 支店名 */
  name: Scalars['String'];
  /** 郵便番号 */
  postalCode?: InputMaybe<Scalars['PostalCode']>;
  /** 電話番号 */
  tel?: InputMaybe<Scalars['String']>;
};

export type CreateBranchResult = CreateBranchFailed | CreateBranchSuccess;

export type CreateBranchSuccess = {
  __typename?: 'CreateBranchSuccess';
  branch: Branch;
};

/** カンパニー作成失敗 */
export type CreateCompanyFailed = {
  __typename?: 'CreateCompanyFailed';
  /** 失敗理由 */
  reason: Scalars['String'];
};

/** カンパニー作成インプット */
export type CreateCompanyInput = {
  /**
   * データストアにおけるID
   *
   * 全カンパニーで重複しない、一意な値を指定してください。
   */
  datastoreId: Scalars['String'];
  /**
   * 機能トグル一覧
   *
   * 設定の ON/OFF を制御したい機能を一覧で指定してください。
   * 未指定の機能に関しては、デフォルトの設定が反映されます。
   */
  featureToggles?: InputMaybe<Array<FeatureToggleInput>>;
  /**
   * IP アドレスの制限がかかっているか
   *
   * true の場合、特定 IP からのリクエストしか許可しません。
   */
  isIPRestraint?: InputMaybe<Scalars['Boolean']>;
  /** カンパニー名 */
  name: Scalars['String'];
  /** レコードフラグ */
  recordFlg?: InputMaybe<Scalars['Boolean']>;
};

/** カンパニー作成結果 */
export type CreateCompanyResult = CreateCompanyFailed | CreateCompanySuccess;

/** カンパニー作成成功 */
export type CreateCompanySuccess = {
  __typename?: 'CreateCompanySuccess';
  /** カンパニー */
  company: Company;
};

export type CreateCustomScreenFailed = {
  __typename?: 'CreateCustomScreenFailed';
  reason: Scalars['String'];
};

export type CreateCustomScreenInput = {
  /**
   * カンパニーID
   *
   * 原則として認証ユーザーが属するカンパニーのカスタム画面のみ操作可能ですが、
   * 当引数で指定されたカンパニーのカスタム画面を操作対象とします。
   */
  company?: InputMaybe<Scalars['ID']>;
  /** カスタム画面名 */
  name: Scalars['String'];
  /** カスタム画面画像URL */
  src: Scalars['URL'];
  /** カンパニー内で一意となる、任意の画面識別子 */
  uniqueId: Scalars['String'];
};

export type CreateCustomScreenResult = CreateCustomScreenFailed | CreateCustomScreenSuccess;

export type CreateCustomScreenSuccess = {
  __typename?: 'CreateCustomScreenSuccess';
  customScreen: CustomScreen;
};

/** カスタム変数作成失敗 */
export type CreateCustomVariableFailed = {
  __typename?: 'CreateCustomVariableFailed';
  /** 理由 */
  reason: Scalars['String'];
};

/**
 * カスタム変数作成インプット
 *
 * owner, pc, userのうち1つだけ引数として与えること。
 * 与えない場合エラーが発生します
 */
export type CreateCustomVariableInput = {
  /**
   * 作成対象カンパニー
   *
   * 原則として認証ユーザーが属するカンパニーのカスタム変数のみ作成可能ですが、
   * 当引数で指定されたカンパニーのカスタム変数を作成対象とします。
   */
  company?: InputMaybe<Scalars['ID']>;
  /** 所有者 */
  owner: Scalars['ID'];
  /** 値 */
  value: Scalars['String'];
  /** 変数名 */
  variable: Scalars['String'];
};

/** カスタム変数作成結果 */
export type CreateCustomVariableResult = CreateCustomVariableFailed | CreateCustomVariableSuccess;

/** カスタム変数作成成功 */
export type CreateCustomVariableSuccess = {
  __typename?: 'CreateCustomVariableSuccess';
  /** 作成したカスタム変数 */
  customVariable: CustomVariable;
};

export type CreateCustomerServiceFailed = {
  __typename?: 'CreateCustomerServiceFailed';
  reason?: Maybe<Scalars['String']>;
};

export type CreateCustomerServiceInput = {
  /** アクション一覧 */
  actions?: InputMaybe<Array<AnActionInput>>;
  /** 接客分析項目一覧 */
  analyticalInfoList?: InputMaybe<Array<AnAnalyticalInfoInput>>;
  /**
   * 会話
   *
   * 遠隔スタッフと顧客との会話内容です。
   */
  conversation?: InputMaybe<Array<CustomerServiceConversationLogInput>>;
  /** 店舗側音声ファイル */
  customerVoiceFile?: InputMaybe<Scalars['URL']>;
  /** 接客情報を一意に表す */
  datastoreId: Scalars['String'];
  /** 接客終了日時 */
  finishTimestamp: Scalars['Time'];
  /** 接客しなかったか */
  notService?: InputMaybe<Scalars['Boolean']>;
  /** 接客を行った PC */
  pcId: Scalars['ID'];
  /** 個人情報を含む接客であったか */
  protect?: InputMaybe<Scalars['Boolean']>;
  /** 備考 */
  remark?: InputMaybe<Scalars['String']>;
  /** 接客開始日時 */
  startTimestamp: Scalars['Time'];
  /** ワーカー側音声ファイル */
  workerVoiceFile?: InputMaybe<Scalars['URL']>;
};

export type CreateCustomerServiceResult = CreateCustomerServiceFailed | CreateCustomerServiceSuccess;

export type CreateCustomerServiceSuccess = {
  __typename?: 'CreateCustomerServiceSuccess';
  customerService: CustomerService;
};

export type CreateExtensionWebAppFailed = {
  __typename?: 'CreateExtensionWebAppFailed';
  reason: Scalars['String'];
};

export type CreateExtensionWebAppInput = {
  /**
   * 有効な拡張アプリであるか（デフォルト： true）
   *
   * 有効な拡張アプリは RURA の接客画面で表示対象となります。
   */
  active?: InputMaybe<Scalars['Boolean']>;
  /** カンパニーID */
  company?: InputMaybe<Scalars['ID']>;
  /**
   * 表示名
   *
   * RURA接客画面におけるタブなどで使用
   */
  displayName: Scalars['String'];
  /** 拡張アプリ名 */
  name: Scalars['String'];
  /** iframeのsrc属性に指定するURL */
  url: Scalars['URL'];
};

export type CreateExtensionWebAppResult = CreateExtensionWebAppFailed | CreateExtensionWebAppSuccess;

export type CreateExtensionWebAppSuccess = {
  __typename?: 'CreateExtensionWebAppSuccess';
  extensionApp: ExtensionApp;
};

export type CreateFrameAndPcFailed = {
  __typename?: 'CreateFrameAndPcFailed';
  reason: Scalars['String'];
};

/** Frame(とPCと)を作成する場合のPC作成時インプット */
export type CreateFrameAndPcForPcInput = {
  /** Frame を利用する支店 */
  branch: Scalars['ID'];
  /** Frameが属するカンパニー */
  company?: InputMaybe<Scalars['ID']>;
  /** Frameとして識別するための名称 */
  name: Scalars['String'];
  /** 接客種別 */
  receptionType: Scalars['ID'];
  /** Frameとして作成するPC が属するルーム */
  room?: InputMaybe<Scalars['ID']>;
  /** 表示名 */
  viewName?: InputMaybe<Scalars['String']>;
};

export type CreateFrameAndPcInput = {
  /** Frame種別 */
  frameType: Scalars['ID'];
  /** 一度接客したらWebRTCを切断するかどうか */
  onceReception: Scalars['Boolean'];
  /** Frameを作成する場合のPC作成時インプット */
  pc: CreateFrameAndPcForPcInput;
  /** Frameを使用する環境 */
  platform: FramePlatform;
  /** 起動時の通知先 */
  startNotice?: InputMaybe<Scalars['ID']>;
  /** メディア使用フラグ */
  useMedia: Scalars['Boolean'];
  /**
   * スタッフ映像取得フラグ
   * 店舗側が自身の映像を送るかどうか
   */
  useVideo: Scalars['Boolean'];
  /**
   * メディア表示フラグ
   * 店舗側でスタッフのカメラ映像を表示させるかどうか
   */
  viewStaffVideo: Scalars['Boolean'];
};

export type CreateFrameAndPcResult = CreateFrameAndPcFailed | CreateFrameAndPcSuccess;

export type CreateFrameAndPcSuccess = {
  __typename?: 'CreateFrameAndPcSuccess';
  frame: Frame;
};

export type CreateFrameTypeFailed = {
  __typename?: 'CreateFrameTypeFailed';
  reason: Scalars['String'];
};

export type CreateFrameTypeInput = {
  /** Frame種別名 */
  name: Scalars['String'];
  /** Frame種別の所有者 */
  owner?: InputMaybe<Scalars['ID']>;
  /** Frame種別 */
  value: Scalars['String'];
};

export type CreateFrameTypeResult = CreateFrameTypeFailed | CreateFrameTypeSuccess;

export type CreateFrameTypeSuccess = {
  __typename?: 'CreateFrameTypeSuccess';
  frameType: FrameType;
};

export type CreateImageGroupFailed = {
  __typename?: 'CreateImageGroupFailed';
  reason?: Maybe<Scalars['String']>;
};

export type CreateImageGroupInput = {
  /** グループ名 */
  name: Scalars['String'];
  /** 優先度 */
  priority: Scalars['Int'];
};

export type CreateImageGroupResult = CreateImageGroupFailed | CreateImageGroupSuccess;

export type CreateImageGroupSuccess = {
  __typename?: 'CreateImageGroupSuccess';
  imageGroup: ImageGroup;
};

export type CreateMemoFailed = {
  __typename?: 'CreateMemoFailed';
  reason: Scalars['String'];
};

export type CreateMemoInput = {
  /** 内容 */
  description?: InputMaybe<Scalars['String']>;
  /** メモ名 */
  name: Scalars['String'];
  /** メモ所有者 */
  owner: Scalars['ID'];
  /** 備考 */
  remark?: InputMaybe<Scalars['String']>;
};

export type CreateMemoResult = CreateMemoFailed | CreateMemoSuccess;

export type CreateMemoSuccess = {
  __typename?: 'CreateMemoSuccess';
  memo: Memo;
};

/** メモリ作成失敗 */
export type CreateMemoryFailed = {
  __typename?: 'CreateMemoryFailed';
  /** 理由 */
  reason: Scalars['String'];
};

/** メモリ作成インプット */
export type CreateMemoryInput = {
  /**
   * キー
   *
   * 全メモリの中で一意な値を指定してください。
   */
  key: Scalars['String'];
  /** 値 */
  value: Scalars['String'];
};

/** メモリ作成結果 */
export type CreateMemoryResult = CreateMemoryFailed | CreateMemorySuccess;

/** メモリ作成成功 */
export type CreateMemorySuccess = {
  __typename?: 'CreateMemorySuccess';
  /** 作成したメモリ */
  memory: Memory;
};

export type CreateNotificationFailed = {
  __typename?: 'CreateNotificationFailed';
  reason?: Maybe<Scalars['String']>;
};

export type CreateNotificationInput = {
  /** 通知種別 */
  buttonType: Scalars['Int'];
  /**
   * 作成先カンパニー
   *
   * 未指定の場合、認証ユーザが所属するカンパニーに作成されます。
   */
  company?: InputMaybe<Scalars['ID']>;
  /** 呼出を行うキーコード文字列 */
  keyText?: InputMaybe<Scalars['String']>;
  /** 備考 */
  remark?: InputMaybe<Scalars['String']>;
  /**
   * 通知タイミング
   *
   * 未指定の場合、デフォルトは "待機中" のみとなります。
   */
  timing?: InputMaybe<Array<MediaEventType>>;
  /** 通知先のユーザーグループ一覧 */
  userGroups?: InputMaybe<Array<Scalars['ID']>>;
  /** 待機画面向けの呼出中表示テキスト */
  value: Scalars['String'];
  /** 通知の表示名 */
  viewData: Scalars['String'];
  /** Web Hooks のテキスト */
  webHookText?: InputMaybe<Scalars['String']>;
  /** Web Hook の URL */
  webHookUrl?: InputMaybe<Scalars['URL']>;
};

export type CreateNotificationResult = CreateNotificationFailed | CreateNotificationSuccess;

export type CreateNotificationSuccess = {
  __typename?: 'CreateNotificationSuccess';
  notification: Notification;
};

/** PC 外部連携作成失敗 */
export type CreatePcCooperationFailed = {
  __typename?: 'CreatePcCooperationFailed';
  /** 失敗理由 */
  reason: Scalars['String'];
};

/** PC 外部連携作成 インプット */
export type CreatePcCooperationInput = {
  /** カンパニー */
  company: Scalars['ID'];
  /** 外部連携名 */
  name: Scalars['String'];
  /** 連携対象PC */
  pc: Scalars['ID'];
  /**
   * パーミッション
   *
   * 未指定の場合は READ 権限となります。
   */
  permission?: InputMaybe<PcCooperationPermission>;
  /**
   * トークン
   *
   * 未指定の場合は自動採番されます。
   */
  token?: InputMaybe<Scalars['UUID']>;
};

/** PC 外部連携作成結果 */
export type CreatePcCooperationResult = CreatePcCooperationFailed | CreatePcCooperationSuccess;

/** PC 外部連携作成成功 */
export type CreatePcCooperationSuccess = {
  __typename?: 'CreatePcCooperationSuccess';
  /** 作成したPC外部連携 */
  pcCooperation: PcCooperation;
};

/** PC 作成失敗 */
export type CreatePcFailed = {
  __typename?: 'CreatePcFailed';
  /** 失敗理由 */
  reason: Scalars['String'];
};

/** PC 作成インプット */
export type CreatePcInput = {
  /** バーコード有無 */
  barcodeFlg?: InputMaybe<Scalars['Boolean']>;
  /** カメラリスト */
  cameraList?: InputMaybe<Array<Scalars['String']>>;
  /**
   * PC が所属するカンパニー
   *
   * 原則として認証ユーザが所属するカンパニーに PC が作成されますが、
   * 他カンパニーの PC を作成する場合は当フィールドを指定してください。
   */
  company?: InputMaybe<Scalars['ID']>;
  /** 表示オプション */
  displayOption?: InputMaybe<DisplayOption>;
  /**
   * 機能トグル一覧
   *
   * 設定の ON/OFF を制御したい機能を一覧で指定してください。
   * 未指定の機能に関しては、デフォルトの設定が反映されます。
   */
  featureToggles?: InputMaybe<Array<FeatureToggleInput>>;
  /** IP アドレス */
  ipAddress?: InputMaybe<Scalars['IPAddress']>;
  /** PC 名 */
  name: Scalars['String'];
  /** プラン種別 */
  planType?: InputMaybe<PlanType>;
  /** 接客種別 */
  receptionType?: InputMaybe<Scalars['ID']>;
  /**
   * 遠隔操作機器の IP アドレス一覧
   *
   * 原則として IPv4 形式の IP アドレスを指定してください。
   * ただし 遠隔操作機器が Android 端末の場合は "android" という文字列を指定する必要があります。
   */
  remoteIPList?: InputMaybe<Array<Scalars['String']>>;
  /** PC が属するルーム */
  room?: InputMaybe<Scalars['ID']>;
  /** 表示名 */
  viewName?: InputMaybe<Scalars['String']>;
};

/** PC 作成結果 */
export type CreatePcResult = CreatePcFailed | CreatePcSuccess;

/** PC 作成成功 */
export type CreatePcSuccess = {
  __typename?: 'CreatePcSuccess';
  /** PC */
  pc: Pc;
};

export type CreatePreUserFailed = {
  __typename?: 'CreatePreUserFailed';
  reason?: Maybe<Scalars['String']>;
};

export type CreatePreUserInput = {
  /**
   * 作成対象カンパニー
   *
   * 原則として認証ユーザーが属するカンパニーのカスタム変数のみ作成可能ですが、
   * 当引数で指定されたカンパニーに属するユーザーを作成します。
   */
  company?: InputMaybe<Scalars['ID']>;
  /** 仮ユーザーのメールアドレス */
  mail: Scalars['Email'];
  /** 備考欄 */
  remark?: InputMaybe<Scalars['String']>;
  /** ロール */
  role: Role;
  /** ルームグループ */
  roomGroup: Scalars['ID'];
  /** ユーザー種別 */
  userType: UserType;
};

export type CreatePreUserResult = CreatePreUserFailed | CreatePreUserSuccess;

export type CreatePreUserSuccess = {
  __typename?: 'CreatePreUserSuccess';
  preUser: PreUser;
};

export type CreateRemoteControllerFailed = {
  __typename?: 'CreateRemoteControllerFailed';
  reason: Scalars['String'];
};

/** 遠隔操作端末作成インプット */
export type CreateRemoteControllerInput = {
  /** 対象カンパニー */
  company?: InputMaybe<Scalars['ID']>;
  /** 接客画面への表示 */
  isActive: Scalars['Boolean'];
  /** 端末名 */
  name: Scalars['String'];
  /** 使用店舗 */
  pc?: InputMaybe<Scalars['ID']>;
  /** 固定IP */
  staticIpv4?: InputMaybe<Scalars['IPAddress']>;
};

export type CreateRemoteControllerResult = CreateRemoteControllerFailed | CreateRemoteControllerSuccess;

export type CreateRemoteControllerSuccess = {
  __typename?: 'CreateRemoteControllerSuccess';
  remoteController: RemoteController;
};

/** ルーム作成失敗 */
export type CreateRoomFailed = {
  __typename?: 'CreateRoomFailed';
  /** 失敗理由 */
  reason: Scalars['String'];
};

/** ルームグループ作成失敗 */
export type CreateRoomGroupFailed = {
  __typename?: 'CreateRoomGroupFailed';
  reason: Scalars['String'];
};

/** ルームグループ作成インプット */
export type CreateRoomGroupInput = {
  /**
   * ルームグループが属するカンパニー
   *
   * 原則として認証ユーザーが属するカンパニーにルームグループが作成されますが、
   * 他カンパニーのルームグループを作成する場合は当フィールドを指定してください。
   */
  company?: InputMaybe<Scalars['ID']>;
  /** ルームグループ名 */
  name: Scalars['String'];
  /** 備考 */
  remark?: InputMaybe<Scalars['String']>;
  /**
   * ルーム一覧
   *
   * 指定されたルームを当ルームグループに所属させます。
   * なお、他のルームグループに属している場合は当ルームグループに移動します。
   */
  rooms?: InputMaybe<Array<Scalars['ID']>>;
};

/** ルームグループ作成結果 */
export type CreateRoomGroupResult = CreateRoomGroupFailed | CreateRoomGroupSuccess;

/** ルームグループ作成成功 */
export type CreateRoomGroupSuccess = {
  __typename?: 'CreateRoomGroupSuccess';
  roomGroup: RoomGroup;
};

/** ルーム作成インプット */
export type CreateRoomInput = {
  /**
   * ルームが属するカンパニー
   *
   * 原則として認証ユーザーのカンパニーにルームが作成されます。
   * ただし、タイムリープユーザーの場合はカンパニーに指定が可能です。
   */
  company?: InputMaybe<Scalars['ID']>;
  /** 連携外部サービス */
  externalServices?: InputMaybe<Array<ExternalService>>;
  /** 自由に接客開始可能であるか */
  isFreeReception?: InputMaybe<Scalars['Boolean']>;
  /** ルーム名 */
  name: Scalars['String'];
  /**
   * ルームに属する PC 一覧
   *
   * 既に PC がルームに属している場合は、作成したルームに移動します。
   */
  pcList?: InputMaybe<Array<Scalars['ID']>>;
  /**
   * 契約タイプ
   *
   * 未指定の場合はデフォルトで STANDARD となります。
   */
  planType?: InputMaybe<PlanType>;
  /** 備考 */
  remark?: InputMaybe<Scalars['String']>;
  /** ルームNo */
  roomNo?: InputMaybe<Scalars['Int']>;
};

/** ルーム作成結果 */
export type CreateRoomResult = CreateRoomFailed | CreateRoomSuccess;

/** ルーム作成成功 */
export type CreateRoomSuccess = {
  __typename?: 'CreateRoomSuccess';
  /** ルーム */
  room: Room;
};

export type CreateScenarioFailed = {
  __typename?: 'CreateScenarioFailed';
  reason: Scalars['String'];
};

export type CreateScenarioInput = {
  /**
   * 作成対象カンパニー
   *
   * 原則として認証ユーザーが属するカンパニーのシナリオを作成可能ですが、
   * 当引数で指定されたカンパニーのシナリオを作成対象とします。
   */
  company?: InputMaybe<Scalars['ID']>;
  /** シナリオ機能使用先PCモニタにおける表示向き */
  monitorOrientation: MonitorOrientation;
  /** シナリオ名 */
  name: Scalars['String'];
  /** 備考 */
  remark?: InputMaybe<Scalars['String']>;
};

export type CreateScenarioResult = CreateScenarioFailed | CreateScenarioSuccess;

export type CreateScenarioSuccess = {
  __typename?: 'CreateScenarioSuccess';
  scenario: Scenario;
};

export type CreateScenarioViewButtonFailed = {
  __typename?: 'CreateScenarioViewButtonFailed';
  reason: Scalars['String'];
};

export type CreateScenarioViewButtonInput = {
  /** シナリオボタン種別 */
  buttonType: ScenarioViewButtonType;
  /** 色 */
  color: ScenarioViewButtonColor;
  /**
   * 作成対象カンパニー
   *
   * 原則として認証ユーザーが属するカンパニーのシナリオビューボタンを作成可能ですが、
   * 当引数で指定されたカンパニーのシナリオビューボタンを作成対象とします。
   */
  company?: InputMaybe<Scalars['ID']>;
  /** ボタン表示 */
  displayText: Scalars['String'];
  /** Fill */
  fill: ScenarioViewButtonFill;
  /**
   * ボタン名
   * @deprecated displayText に統合されました
   */
  name?: InputMaybe<Scalars['String']>;
  /**
   * 遷移先シナリオビュー
   *
   * 変更したくない場合、同じIDを設定すること
   * null値を渡したとき、遷移先シナリオビューが未設定となります
   */
  nextScenarioView?: InputMaybe<Scalars['ID']>;
  /**
   * 通知ID
   *
   * 変更したくない場合、同じIDを設定すること
   * null値を渡したとき、通知が未設定となります
   */
  notification?: InputMaybe<Scalars['ID']>;
  /** シナリオビューボタン配置対象シナリオビューID */
  scenarioView: Scalars['ID'];
  /**
   * サイズ
   * @deprecated サイズは固定になったため指定不要です
   */
  size?: InputMaybe<ScenarioViewButtonSize>;
};

export type CreateScenarioViewButtonResult = CreateScenarioViewButtonFailed | CreateScenarioViewButtonSuccess;

export type CreateScenarioViewButtonSuccess = {
  __typename?: 'CreateScenarioViewButtonSuccess';
  scenarioViewButton: ScenarioViewButton;
};

export type CreateScenarioViewFailed = {
  __typename?: 'CreateScenarioViewFailed';
  reason: Scalars['String'];
};

/** シナリオビュー固定ボタン作成インプット */
export type CreateScenarioViewFixedButtonInput = {
  /** シナリオビュー固定ボタン種別 */
  buttonType: ScenarioViewFixedButtonType;
  /** ボタンを表示するか */
  show: Scalars['Boolean'];
};

export type CreateScenarioViewInput = {
  /** 背景 画像/動画 */
  backGroundMedia?: InputMaybe<Scalars['ID']>;
  /** ボタン配置 */
  buttonsPosition: ButtonsPosition;
  /** ボタン表示時の列数 */
  colsButtonsArrangement: ColsButtonsArrangement;
  /**
   * 作成対象カンパニー
   *
   * 原則として認証ユーザーが属するカンパニーのシナリオビューを作成可能ですが、
   * 当引数で指定されたカンパニーのシナリオビューを作成対象とします。
   */
  company?: InputMaybe<Scalars['ID']>;
  /** 固定ボタンの設定 */
  fixedButtons?: InputMaybe<Array<CreateScenarioViewFixedButtonInput>>;
  /** タイムアウトを動画と同じ長さにする(Default = false) */
  isAdjustmentVideoPlaytime?: InputMaybe<Scalars['Boolean']>;
  /** シナリオビュー名 */
  name: Scalars['String'];
  /** 所属元シナリオID */
  scenario: Scalars['ID'];
  /** 人検知遷移先シナリオビュー */
  scenarioViewOnDetection?: InputMaybe<Scalars['ID']>;
  /** タイムアウト時遷移先シナリオビュー */
  scenarioViewOnTimeout?: InputMaybe<Scalars['ID']>;
  /** タイムアウト秒数 */
  timeoutSeconds?: InputMaybe<Scalars['Int']>;
};

export type CreateScenarioViewResult = CreateScenarioViewFailed | CreateScenarioViewSuccess;

export type CreateScenarioViewSuccess = {
  __typename?: 'CreateScenarioViewSuccess';
  scenarioView: ScenarioView;
};

export type CreateSpeechGroupFailed = {
  __typename?: 'CreateSpeechGroupFailed';
  reason?: Maybe<Scalars['String']>;
};

export type CreateSpeechGroupInput = {
  /** グループ名 */
  name: Scalars['String'];
  /** 優先度 */
  priority: Scalars['Int'];
};

export type CreateSpeechGroupResult = CreateSpeechGroupFailed | CreateSpeechGroupSuccess;

export type CreateSpeechGroupSuccess = {
  __typename?: 'CreateSpeechGroupSuccess';
  speechGroup: SpeechGroup;
};

export type CreateSystemNotificationFailed = {
  __typename?: 'CreateSystemNotificationFailed';
  reason: Scalars['String'];
};

export type CreateSystemNotificationInput = {
  /** 詳細 */
  detail?: InputMaybe<Scalars['String']>;
  /** 通知日時 */
  notificationAt: Scalars['Time'];
  /** タイトル */
  title: Scalars['String'];
  /** リンク先 */
  url?: InputMaybe<Scalars['URL']>;
};

export type CreateSystemNotificationResult = CreateSystemNotificationFailed | CreateSystemNotificationSuccess;

export type CreateSystemNotificationSuccess = {
  __typename?: 'CreateSystemNotificationSuccess';
  /** 作成したシステム通知 */
  systemNotification: SystemNotification;
};

export type CreateSystemUserFailed = {
  __typename?: 'CreateSystemUserFailed';
  reason: Scalars['String'];
};

/** システムユーザー作成インプット */
export type CreateSystemUserInput = {
  /**
   * システムユーザーが属するカンパニー
   *
   * 原則として認証ユーザーのカンパニーにシステムユーザーが作成されます。
   * ただし、タイムリープユーザーの場合はカンパニーに指定が可能です。
   */
  company?: InputMaybe<Scalars['ID']>;
  /** システムユーザー名 */
  name: Scalars['String'];
  /** パスワード */
  password: Scalars['String'];
  /** 備考 */
  remark?: InputMaybe<Scalars['String']>;
  /** ユーザーロール */
  role: Role;
  /** ユーザーID */
  userId: Scalars['String'];
  /** ユーザータイプ(SYSTEM, REMOTE_CONTROLLERのみが指定可能) */
  userType: UserType;
};

export type CreateSystemUserResult = CreateSystemUserFailed | CreateSystemUserSuccess;

export type CreateSystemUserSuccess = {
  __typename?: 'CreateSystemUserSuccess';
  user: User;
};

/** テンプレート作成失敗 */
export type CreateTemplateFailed = {
  __typename?: 'CreateTemplateFailed';
  /** 失敗理由 */
  reason: Scalars['String'];
};

/** テンプレート作成インプット */
export type CreateTemplateInput = {
  /** 画面サイズ_高さ */
  displaySizeHeight: Scalars['Int'];
  /** 画面サイズ_幅 */
  displaySizeWidth: Scalars['Int'];
  /** テンプレート名 */
  name: Scalars['String'];
  /** 使用中店舗 */
  pcs?: InputMaybe<Array<Scalars['ID']>>;
  /** 備考 */
  remark?: InputMaybe<Scalars['String']>;
};

/** テンプレート作成結果 */
export type CreateTemplateResult = CreateTemplateFailed | CreateTemplateSuccess;

/** テンプレート作成成功 */
export type CreateTemplateSuccess = {
  __typename?: 'CreateTemplateSuccess';
  /** テンプレート */
  template: Template;
};

export type CreateUserGroupFailed = {
  __typename?: 'CreateUserGroupFailed';
  reason: Scalars['String'];
};

export type CreateUserGroupInput = {
  /**
   * 作成対象カンパニー
   *
   * 原則、認証ユーザーが属するカンパニーのユーザー・グループを作成しますが、
   * 他カンパニーのユーザー・グループを作成する場合は当フィールドを指定してください。
   */
  company?: InputMaybe<Scalars['ID']>;
  /** ユーザーグループ名 */
  name: Scalars['String'];
  /** ユーザーグループで管理する対象ユーザー */
  users?: InputMaybe<Array<Scalars['ID']>>;
};

export type CreateUserGroupResult = CreateUserGroupFailed | CreateUserGroupSuccess;

export type CreateUserGroupSuccess = {
  __typename?: 'CreateUserGroupSuccess';
  userGroup: UserGroup;
};

export type CreateVideoGroupFailed = {
  __typename?: 'CreateVideoGroupFailed';
  reason?: Maybe<Scalars['String']>;
};

/** 動画グループ作成インプット */
export type CreateVideoGroupInput = {
  /** 動画グループ名 */
  name: Scalars['String'];
  /** 優先度 */
  priority: Scalars['Int'];
};

export type CreateVideoGroupResult = CreateVideoGroupFailed | CreateVideoGroupSuccess;

export type CreateVideoGroupSuccess = {
  __typename?: 'CreateVideoGroupSuccess';
  videoGroup: VideoGroup;
};

/** カスタム画面 */
export type CustomScreen = Node & {
  __typename?: 'CustomScreen';
  /** カンパニー */
  company: Company;
  /** データストアID */
  datastoreId: Scalars['String'];
  /** オブジェクトID */
  id: Scalars['ID'];
  /** カスタム画面名 */
  name: Scalars['String'];
  /** 署名付きURL */
  presignedUrl?: Maybe<Scalars['URL']>;
  /** カスタム画面画像URL */
  src?: Maybe<Scalars['URL']>;
  /** カンパニー内でユニークなナチュラルキー */
  uniqueId: Scalars['String'];
};

export type CustomScreenConnection = Connection & {
  __typename?: 'CustomScreenConnection';
  /** エッジ一覧 */
  edges: Array<CustomScreenEdge>;
  /** ノード一覧 */
  nodes: Array<CustomScreen>;
  /** ページ情報 */
  pageInfo: PageInfo;
  /** 総件数 */
  totalCount: Scalars['Int'];
};

export type CustomScreenEdge = Edge & {
  __typename?: 'CustomScreenEdge';
  /** カーソル */
  cursor: Scalars['String'];
  /** ノード */
  node: CustomScreen;
};

/** カスタム変数 */
export type CustomVariable = Node & {
  __typename?: 'CustomVariable';
  /** カンパニー */
  company: Company;
  /** データストアID */
  datastoreId: Scalars['UUID'];
  /** オブジェクトID */
  id: Scalars['ID'];
  /** 所有者 */
  owner: CustomVariableOwner;
  /** 値 */
  value: Scalars['String'];
  /** 変数 */
  variable: Scalars['String'];
};

/** カスタム変数コネクション */
export type CustomVariableConnection = Connection & {
  __typename?: 'CustomVariableConnection';
  /** エッジ一覧 */
  edges: Array<CustomVariableEdge>;
  /** ノード一覧 */
  nodes: Array<CustomVariable>;
  /** ページ情報 */
  pageInfo: PageInfo;
  /** 総件数 */
  totalCount: Scalars['Int'];
};

/** カスタム変数エッジ */
export type CustomVariableEdge = Edge & {
  __typename?: 'CustomVariableEdge';
  /** カーソル */
  cursor: Scalars['String'];
  /** ノード */
  node: CustomVariable;
};

/** カスタム変数のソート条件 */
export type CustomVariableOrder = {
  /** ソート順 */
  direction: OrderDirection;
  /** ソート対象フィールド */
  field: CustomVariableSortField;
};

/** カスタム変数値の定義者 */
export type CustomVariableOwner = Company | Pc | User;

/** カスタム変数ソート可能フィールド */
export enum CustomVariableSortField {
  /** データストアID */
  DatastoreId = 'DATASTORE_ID'
}

/** 分析接客情報 */
export type CustomerService = Node & {
  __typename?: 'CustomerService';
  /** アクション一覧 */
  actions?: Maybe<Array<AnAction>>;
  /** 分析項目一覧 */
  analyticalInfoList?: Maybe<Array<AnAnalyticalInfo>>;
  /** カンパニーID */
  companyId: Scalars['String'];
  /**
   * 店舗側テキスト
   * @deprecated CustomerServiceVoiceText の customer を使用してください
   */
  customerTalkText?: Maybe<Scalars['String']>;
  /** 店舗側音声ファイル */
  customerVoiceFile?: Maybe<Scalars['URL']>;
  /** データストアID */
  datastoreId: Scalars['String'];
  /**
   * 接客評価情報
   *
   * evaluateCustomerService Mutation を実行するまで評価は行われません。
   */
  evaluation?: Maybe<CustomerServiceEvaluation>;
  /** 接客終了日時 */
  finishTimestamp?: Maybe<Scalars['Time']>;
  /** オブジェクトID */
  id: Scalars['ID'];
  /** 合成音声ファイル */
  mixedVoiceFile?: Maybe<Scalars['URL']>;
  /** 接客しなかったか */
  notService: Scalars['Boolean'];
  /** 接客店舗 */
  pc?: Maybe<Pc>;
  /** 店舗側音声ファイル（署名付きURL） */
  presignedCustomerVoiceFile?: Maybe<Scalars['URL']>;
  /** 合成音声ファイル（署名付きURL） */
  presignedMixedVoiceFile?: Maybe<Scalars['URL']>;
  /** ワーカー側音声ファイル（署名付きURL） */
  presignedWorkerVoiceFile?: Maybe<Scalars['URL']>;
  /** 個人情報を含む接客であったか */
  protect: Scalars['Boolean'];
  /** 備考 */
  remark?: Maybe<Scalars['String']>;
  /** 接客開始日時 */
  startTimestamp?: Maybe<Scalars['Time']>;
  /** ユーザー */
  user?: Maybe<User>;
  /** 接客音声テキスト */
  voiceText?: Maybe<CustomerServiceVoiceText>;
  /**
   * ワーカー側接客テキスト
   * @deprecated CustomerServiceVoiceText の worker を使用してください
   */
  workerTalkText?: Maybe<Scalars['String']>;
  /** ワーカー側音声ファイル */
  workerVoiceFile?: Maybe<Scalars['URL']>;
};

/** 接客情報コネクション */
export type CustomerServiceConnection = Connection & {
  __typename?: 'CustomerServiceConnection';
  /** エッジ一覧 */
  edges: Array<CustomerServiceEdge>;
  /** ノード一覧 */
  nodes: Array<CustomerService>;
  /** ページ情報 */
  pageInfo: PageInfo;
  /** 総件数 */
  totalCount: Scalars['Int'];
};

/** 接客会話ログ */
export type CustomerServiceConversationLog = {
  __typename?: 'CustomerServiceConversationLog';
  /**
   * 発声終了位置（秒）
   *
   * 会話の開始から何秒の位置で喋り終えたか。
   */
  finish: Scalars['Float'];
  /** 会話内容 */
  sentence: Scalars['String'];
  /**
   * 発声開始位置（秒）
   *
   * 会話の開始から何秒の位置で喋り始めたか。
   */
  start: Scalars['Float'];
  /** 話者 */
  user: CustomerServiceConversationUser;
};

/** 会話ログインプット */
export type CustomerServiceConversationLogInput = {
  /**
   * 発声終了位置（秒）
   *
   * 会話の開始から何秒の位置で喋り終えたか。
   */
  finish: Scalars['Float'];
  /** 会話内容 */
  sentence: Scalars['String'];
  /**
   * 発声開始位置（秒）
   *
   * 会話の開始から何秒の位置で喋り始めたか。
   */
  start: Scalars['Float'];
  /** 話者 */
  user: CustomerServiceConversationUser;
};

/** 話者 */
export enum CustomerServiceConversationUser {
  /** 顧客 */
  Customer = 'CUSTOMER',
  /** 遠隔スタッフ */
  Staff = 'STAFF'
}

/** 接客情報エッジ */
export type CustomerServiceEdge = Edge & {
  __typename?: 'CustomerServiceEdge';
  /** カーソル */
  cursor: Scalars['String'];
  /** ノード */
  node: CustomerService;
};

/** 分析接客評価情報 */
export type CustomerServiceEvaluation = {
  __typename?: 'CustomerServiceEvaluation';
  /**
   * 評価結果
   *
   * status が FINISHED の場合に設定されます。
   */
  result?: Maybe<CustomerServiceEvaluationResult>;
  /** 進捗状況 */
  status: JobStatus;
};

/** 分析接客評価結果 */
export type CustomerServiceEvaluationResult = Node & {
  __typename?: 'CustomerServiceEvaluationResult';
  /** 接客に関するアドバイス */
  advice?: Maybe<Scalars['String']>;
  /** データストアID */
  datastoreId: Scalars['Int'];
  /** オブジェクトID */
  id: Scalars['ID'];
  /**
   * 点数
   *
   * 接客の点数を 0 - 100 の整数で表します。
   */
  score: Scalars['Int'];
};

/** CSV 出力用接客情報 */
export type CustomerServiceForCsv = {
  __typename?: 'CustomerServiceForCsv';
  /** 分析項目名 */
  analyticalInfoName: Scalars['String'];
  /** 分析項目種別名 */
  analyticalIntoTypeName: Scalars['String'];
  /** 接客情報ID */
  customerServiceId: Scalars['String'];
  /** 接客終了日（YYYY/MM/DD 形式） */
  finishDate: Scalars['String'];
  /** 接客終了時間（hh:mm:ss 形式） */
  finishTime: Scalars['String'];
  /** 接客しなかったか */
  notService: Scalars['Boolean'];
  /** 店舗名 */
  pcName: Scalars['String'];
  /** 特記事項 */
  remark?: Maybe<Scalars['String']>;
  /** 接客時間（hh:mm:ss 形式） */
  servedTime: Scalars['String'];
  /** 接客開始日（YYYY/MM/DD 形式） */
  startDate: Scalars['String'];
  /** 接客開始時間（hh:mm:ss 形式） */
  startTime: Scalars['String'];
  /** 接客ユーザーID */
  userId: Scalars['String'];
  /** 接客ユーザー名 */
  userName: Scalars['String'];
};

/**
 * カンパニー接客情報概要
 *
 * 今月の日間平均接客数と1回あたり平均接客時間(秒) を表します。
 */
export type CustomerServiceMonthlyOverview = {
  __typename?: 'CustomerServiceMonthlyOverview';
  /** 今月の日間平均接客数 */
  averageCustomerServedCountPerDay: Scalars['Int'];
  /** 1回あたり平均接客時間(秒) */
  averageCustomerServedSeconds: Scalars['Int'];
};

export type CustomerServiceOrder = {
  /** ソート順 */
  direction: OrderDirection;
  /** ソート対象フィールド */
  field: CustomerServiceOrderField;
};

export enum CustomerServiceOrderField {
  /** 接客開始日時 */
  StartTimestamp = 'START_TIMESTAMP'
}

/**
 * 接客情報サマリー
 *
 * 指定期間における接客情報のサマリーを表します。
 */
export type CustomerServiceSummary = {
  __typename?: 'CustomerServiceSummary';
  /** 接客しなかった回数 */
  notServedCount: Scalars['Int'];
  /** 接客しなかった秒数 */
  notServedSeconds: Scalars['Int'];
  /** 接客した回数 */
  servedCount: Scalars['Int'];
  /** 接客した秒数 */
  servedSeconds: Scalars['Int'];
  /**
   * 総接客回数
   *
   * 「接客した回数」と「接客しなかった回数」の合計値
   */
  totalServedCount: Scalars['Int'];
  /**
   * 総接客秒数
   *
   * 「接客した秒数」と「接客しなかった秒数」の合計値
   */
  totalServedSeconds: Scalars['Int'];
};

export type CustomerServiceVoicePutUrl = {
  __typename?: 'CustomerServiceVoicePutURL';
  /** 店舗側音声 アップロード情報 */
  customer: MediaUpload;
  /** 接客スタッフ音声 アップロード情報 */
  worker: MediaUpload;
};

/** 接客音声テキスト */
export type CustomerServiceVoiceText = Node & {
  __typename?: 'CustomerServiceVoiceText';
  /**
   * 会話
   *
   * 遠隔スタッフと顧客との会話内容です。
   */
  conversation?: Maybe<Array<CustomerServiceConversationLog>>;
  /** 顧客の音声テキスト */
  customer?: Maybe<Scalars['String']>;
  /** データストアID */
  datastoreId: Scalars['Int'];
  /** オブジェクトID */
  id: Scalars['ID'];
  /** 顧客とワーカーの合成音声テキスト */
  mixed?: Maybe<Scalars['String']>;
  /**
   * 要約
   *
   * 接客内容の要約
   */
  summary?: Maybe<Scalars['String']>;
  /** ワーカーの音声テキスト */
  worker?: Maybe<Scalars['String']>;
};

/** 日別分析項目集計結果 */
export type DailyAggregateByAnalyticalInfo = {
  __typename?: 'DailyAggregateByAnalyticalInfo';
  /** 分析項目集計結果一覧 */
  aggregateList: Array<AggregateByAnalyticalInfo>;
  /** 日付 */
  date: Scalars['Time'];
};

/** 日別店舗接客情報 */
export type DailyShopCustomerService = Node & {
  __typename?: 'DailyShopCustomerService';
  /** 接客情報一覧 */
  customerServices: Array<CustomerService>;
  /** 日付（YYYY/MM/DD） */
  day: Scalars['String'];
  /** オブジェクトID */
  id: Scalars['ID'];
  /** 店舗名 */
  pcName: Scalars['String'];
};

/** 日別店舗接客情報コネクション */
export type DailyShopCustomerServiceConnection = Connection & {
  __typename?: 'DailyShopCustomerServiceConnection';
  /** エッジ一覧 */
  edges: Array<DailyShopCustomerServiceEdge>;
  /** ノード一覧 */
  nodes: Array<DailyShopCustomerService>;
  /** ページ情報 */
  pageInfo: PageInfo;
  /** 総件数 */
  totalCount: Scalars['Int'];
};

/** 日別店舗接客情報エッジ */
export type DailyShopCustomerServiceEdge = Edge & {
  __typename?: 'DailyShopCustomerServiceEdge';
  /** カーソル */
  cursor: Scalars['String'];
  /** ノード */
  node: DailyShopCustomerService;
};

/** PC 外部連携一括削除失敗 */
export type DeleteAllPcCooperationFailed = {
  __typename?: 'DeleteAllPcCooperationFailed';
  /** 失敗理由 */
  reason: Scalars['String'];
};

/** PC 外部連携一括削除インプット */
export type DeleteAllPcCooperationInput = {
  /** 削除対象のPC外部連携ID一覧 */
  ids: Array<Scalars['ID']>;
};

/** PC 外部連携一括削除結果 */
export type DeleteAllPcCooperationResult = DeleteAllPcCooperationFailed | DeleteAllPcCooperationSuccess;

/** PC 外部連携一括削除成功 */
export type DeleteAllPcCooperationSuccess = {
  __typename?: 'DeleteAllPcCooperationSuccess';
  /** 削除済みPC外部連携ID一覧 */
  deletePcCooperationIds: Array<Scalars['ID']>;
};

/** 分析グラフ設定削除失敗 */
export type DeleteAnGraphFailed = {
  __typename?: 'DeleteAnGraphFailed';
  /** 失敗理由 */
  reason: Scalars['String'];
};

/** 分析グラフ設定削除インプット */
export type DeleteAnGraphInput = {
  /** 削除対象の分析グラフ設定 */
  id: Scalars['ID'];
};

/** 分析グラフ設定削除結果 */
export type DeleteAnGraphResult = DeleteAnGraphFailed | DeleteAnGraphSuccess;

/** 分析グラフ設定削除成功 */
export type DeleteAnGraphSuccess = {
  __typename?: 'DeleteAnGraphSuccess';
  /** 削除済み分析グラフ設定ID */
  deletedAnGraphId: Scalars['ID'];
};

export type DeleteAnalyticalInfoFailed = {
  __typename?: 'DeleteAnalyticalInfoFailed';
  reason: Scalars['String'];
};

export type DeleteAnalyticalInfoInput = {
  id: Scalars['ID'];
};

export type DeleteAnalyticalInfoResult = DeleteAnalyticalInfoFailed | DeleteAnalyticalInfoSuccess;

export type DeleteAnalyticalInfoSuccess = {
  __typename?: 'DeleteAnalyticalInfoSuccess';
  deleteAnalyticalInfoId: Scalars['ID'];
};

export type DeleteBranchAccountsFailed = {
  __typename?: 'DeleteBranchAccountsFailed';
  reason: Scalars['String'];
};

export type DeleteBranchAccountsInput = {
  /**
   * 原則として認証ユーザーが属するカンパニーの支店アカウントを削除可能ですが、
   * 当引数で指定されたカンパニーの支店アカウントを更新対象とします。
   */
  company?: InputMaybe<Scalars['ID']>;
  /** 削除対象支店アカウント */
  ids: Array<Scalars['ID']>;
};

export type DeleteBranchAccountsResult = DeleteBranchAccountsFailed | DeleteBranchAccountsSuccess;

export type DeleteBranchAccountsSuccess = {
  __typename?: 'DeleteBranchAccountsSuccess';
  deletedIds: Array<Scalars['ID']>;
};

export type DeleteBranchesFailed = {
  __typename?: 'DeleteBranchesFailed';
  reason: Scalars['String'];
};

export type DeleteBranchesInput = {
  /** 削除対象支店 */
  branches?: InputMaybe<Array<Scalars['ID']>>;
  /**
   * 支店が属するカンパニー
   *
   * 原則として認証ユーザーが属するカンパニーの支店のPC一覧のみを更新可能ですが、
   * 当引数で指定されたカンパニーの支店のPC一覧を更新対象とします。
   */
  company?: InputMaybe<Scalars['ID']>;
};

export type DeleteBranchesResult = DeleteBranchesFailed | DeleteBranchesSuccess;

export type DeleteBranchesSuccess = {
  __typename?: 'DeleteBranchesSuccess';
  /** 削除済支店 */
  branches?: Maybe<Array<Scalars['ID']>>;
};

export type DeleteCustomScreensFailed = {
  __typename?: 'DeleteCustomScreensFailed';
  reason: Scalars['String'];
};

export type DeleteCustomScreensInput = {
  /**
   * 削除対象のカスタムスクリーン所属カンパニーID
   *
   * 原則として認証ユーザーが属するカンパニーのカスタム画面のみ操作可能ですが、
   * 当引数で指定されたカンパニーのカスタム画面を操作対象とします。
   */
  company?: InputMaybe<Scalars['ID']>;
  /** 削除対象カスタムスクリーンID */
  ids: Array<Scalars['ID']>;
};

export type DeleteCustomScreensResult = DeleteCustomScreensFailed | DeleteCustomScreensSuccess;

export type DeleteCustomScreensSuccess = {
  __typename?: 'DeleteCustomScreensSuccess';
  deletedCustomScreenIds: Array<Scalars['ID']>;
};

/** カスタム変数削除失敗 */
export type DeleteCustomVariablesFailed = {
  __typename?: 'DeleteCustomVariablesFailed';
  reason: Scalars['String'];
};

/** カスタム変数削除インプット */
export type DeleteCustomVariablesInput = {
  /**
   * 削除対象カンパニーID
   *
   * 原則として認証ユーザーが属するカンパニーのカスタム変数のみ削除可能ですが、
   * 当引数で指定されたカンパニーのカスタム変数を削除対象とします。
   */
  company?: InputMaybe<Scalars['ID']>;
  /** カスタム変数ID */
  ids: Array<Scalars['ID']>;
};

/** カスタム変数削除結果 */
export type DeleteCustomVariablesResult = DeleteCustomVariablesFailed | DeleteCustomVariablesSuccess;

/** カスタム変数削除成功 */
export type DeleteCustomVariablesSuccess = {
  __typename?: 'DeleteCustomVariablesSuccess';
  /** 削除済みカスタム変数ID一覧 */
  deletedIds: Array<Scalars['ID']>;
};

export type DeleteExtensionWebAppsFailed = {
  __typename?: 'DeleteExtensionWebAppsFailed';
  reason: Scalars['String'];
};

export type DeleteExtensionWebAppsInput = {
  /** 削除対象拡張アプリ */
  ids: Array<Scalars['ID']>;
};

export type DeleteExtensionWebAppsResult = DeleteExtensionWebAppsFailed | DeleteExtensionWebAppsSuccess;

export type DeleteExtensionWebAppsSuccess = {
  __typename?: 'DeleteExtensionWebAppsSuccess';
  /** 削除済拡張アプリID */
  deleteExtensionWebAppIds: Array<Scalars['ID']>;
};

export type DeleteFrameTypesFailed = {
  __typename?: 'DeleteFrameTypesFailed';
  reason: Scalars['String'];
};

export type DeleteFrameTypesInput = {
  company?: InputMaybe<Scalars['ID']>;
  ids: Array<Scalars['ID']>;
};

export type DeleteFrameTypesResult = DeleteFrameTypesFailed | DeleteFrameTypesSuccess;

export type DeleteFrameTypesSuccess = {
  __typename?: 'DeleteFrameTypesSuccess';
  /** 削除済みFrameTypeID */
  deleteFrameTypeIds: Array<Scalars['ID']>;
};

/** Frameの削除失敗 */
export type DeleteFramesAndPcsFailed = {
  __typename?: 'DeleteFramesAndPcsFailed';
  reason: Scalars['String'];
};

export type DeleteFramesAndPcsInput = {
  /**
   * 削除FrameとPCの所属先カンパニー
   *
   * 原則として認証ユーザーが属するカンパニーのFrameとPCが削除可能ですが、
   * 当引数で指定されたカンパニーのFrameとPCを取得対象とします。
   */
  company?: InputMaybe<Scalars['ID']>;
  ids: Array<Scalars['ID']>;
};

export type DeleteFramesAndPcsResult = DeleteFramesAndPcsFailed | DeleteFramesAndPcsSuccess;

/** Frameの削除成功 */
export type DeleteFramesAndPcsSuccess = {
  __typename?: 'DeleteFramesAndPcsSuccess';
  /** 削除済みのFrameID */
  deleteFrameIds: Array<Scalars['ID']>;
};

export type DeleteImageFailed = {
  __typename?: 'DeleteImageFailed';
  reason?: Maybe<Scalars['String']>;
};

export type DeleteImageGroupFailed = {
  __typename?: 'DeleteImageGroupFailed';
  reason?: Maybe<Scalars['String']>;
};

export type DeleteImageGroupInput = {
  id: Scalars['ID'];
};

export type DeleteImageGroupResult = DeleteImageGroupFailed | DeleteImageGroupSuccess;

export type DeleteImageGroupSuccess = {
  __typename?: 'DeleteImageGroupSuccess';
  deleteImageGroupId: Scalars['ID'];
};

export type DeleteImageInput = {
  id: Scalars['ID'];
};

export type DeleteImageResult = DeleteImageFailed | DeleteImageSuccess;

export type DeleteImageSuccess = {
  __typename?: 'DeleteImageSuccess';
  /** 削除済み画像ID */
  deleteImageId: Scalars['ID'];
};

export type DeleteIngressIpAddressListFailed = {
  __typename?: 'DeleteIngressIPAddressListFailed';
  reason: Scalars['String'];
};

export type DeleteIngressIpAddressListInput = {
  ids: Array<Scalars['ID']>;
};

export type DeleteIngressIpAddressListResult = DeleteIngressIpAddressListFailed | DeleteIngressIpAddressListSuccess;

export type DeleteIngressIpAddressListSuccess = {
  __typename?: 'DeleteIngressIPAddressListSuccess';
  deletedIds: Array<Scalars['ID']>;
};

/** ログイン禁止リストからの解除失敗 */
export type DeleteLoginBlacklistsFailed = {
  __typename?: 'DeleteLoginBlacklistsFailed';
  message: Scalars['String'];
};

export type DeleteLoginBlacklistsInput = {
  ids: Array<Scalars['ID']>;
};

export type DeleteLoginBlacklistsResult = DeleteLoginBlacklistsFailed | DeleteLoginBlacklistsSuccess;

/** ログイン禁止リストからの解除成功 */
export type DeleteLoginBlacklistsSuccess = {
  __typename?: 'DeleteLoginBlacklistsSuccess';
  /** 削除済みのログイン禁止リストID */
  deleteLoginBlacklistIds: Array<Scalars['ID']>;
};

export type DeleteLoginWhitelistsFailed = {
  __typename?: 'DeleteLoginWhitelistsFailed';
  reason: Scalars['String'];
};

export type DeleteLoginWhitelistsInput = {
  ids: Array<Scalars['ID']>;
};

export type DeleteLoginWhitelistsResult = DeleteLoginWhitelistsFailed | DeleteLoginWhitelistsSuccess;

export type DeleteLoginWhitelistsSuccess = {
  __typename?: 'DeleteLoginWhitelistsSuccess';
  deletedIds: Array<Scalars['ID']>;
};

export type DeleteMemoFailed = {
  __typename?: 'DeleteMemoFailed';
  reason: Scalars['String'];
};

export type DeleteMemoInput = {
  id: Scalars['ID'];
};

export type DeleteMemoResult = DeleteMemoFailed | DeleteMemoSuccess;

export type DeleteMemoSuccess = {
  __typename?: 'DeleteMemoSuccess';
  deleteMemoId: Scalars['ID'];
};

/** メモリ一括削除失敗 */
export type DeleteMemoriesFailed = {
  __typename?: 'DeleteMemoriesFailed';
  /** 理由 */
  reason: Scalars['String'];
};

/** メモリ一括削除インプット */
export type DeleteMemoriesInput = {
  memories: Array<Scalars['ID']>;
};

/** メモリ一括削除結果 */
export type DeleteMemoriesResult = DeleteMemoriesFailed | DeleteMemoriesSuccess;

/** メモリ一括削除成功 */
export type DeleteMemoriesSuccess = {
  __typename?: 'DeleteMemoriesSuccess';
  /** 削除済みメモリID一覧 */
  deletedMemoryIds: Array<Scalars['ID']>;
};

export type DeleteNotificationFailed = {
  __typename?: 'DeleteNotificationFailed';
  reason?: Maybe<Scalars['String']>;
};

export type DeleteNotificationInput = {
  /** 削除対象の通知 */
  id: Scalars['ID'];
  /**
   * 通知を所有するカンパニー
   *
   * 原則として認証ユーザーが属するカンパニーの通知しか削除できませんが、
   * 他カンパニーの通知を削除対象とする場合は当フィールドを指定してください。
   */
  owner?: InputMaybe<Scalars['ID']>;
};

export type DeleteNotificationResult = DeleteNotificationFailed | DeleteNotificationSuccess;

export type DeleteNotificationSuccess = {
  __typename?: 'DeleteNotificationSuccess';
  deleteNotificationId: Scalars['ID'];
};

export type DeleteOperationFailed = {
  __typename?: 'DeleteOperationFailed';
  reason: Scalars['String'];
};

export type DeleteOperationInput = {
  ids?: InputMaybe<Array<Scalars['ID']>>;
};

export type DeleteOperationResult = DeleteOperationFailed | DeleteOperationSuccess;

export type DeleteOperationSuccess = {
  __typename?: 'DeleteOperationSuccess';
  /** 削除済遠隔操作情報 */
  deletedIds: Array<Scalars['ID']>;
};

/** PC 削除失敗 */
export type DeletePcsFailed = {
  __typename?: 'DeletePcsFailed';
  reason: Scalars['String'];
};

/** PC 削除インプット */
export type DeletePcsInput = {
  ids: Array<Scalars['ID']>;
};

/** PC 削除結果 */
export type DeletePcsResult = DeletePcsFailed | DeletePcsSuccess;

/** PC 削除成功 */
export type DeletePcsSuccess = {
  __typename?: 'DeletePcsSuccess';
  /** 削除済 */
  deletePcIds: Array<Scalars['ID']>;
};

/** 遠隔操作端末一括削除失敗 */
export type DeleteRemoteControllersFailed = {
  __typename?: 'DeleteRemoteControllersFailed';
  /** 失敗理由 */
  reason: Scalars['String'];
};

/** 遠隔操作端末一括削除インプット */
export type DeleteRemoteControllersInput = {
  /**
   * 対象カンパニー
   *
   * 原則、認証ユーザーが属するカンパニーの遠隔操作端末を削除対象としますが、
   * 他カンパニーの遠隔操作端末を削除する場合は当フィールドを指定してください。
   */
  company?: InputMaybe<Scalars['ID']>;
  /** 削除対象の遠隔操作端末IDリスト */
  ids: Array<Scalars['ID']>;
};

/** 遠隔操作端末一括削除結果 */
export type DeleteRemoteControllersResult = DeleteRemoteControllersFailed | DeleteRemoteControllersSuccess;

/** 遠隔操作端末一括削除成功 */
export type DeleteRemoteControllersSuccess = {
  __typename?: 'DeleteRemoteControllersSuccess';
  /** 削除対象の遠隔操作端末IDリスト */
  deletedRemoteControllerIds: Array<Scalars['ID']>;
};

/** ルームグループ削除失敗 */
export type DeleteRoomGroupFailed = {
  __typename?: 'DeleteRoomGroupFailed';
  reason: Scalars['String'];
};

/** ルームグループ削除インプット */
export type DeleteRoomGroupInput = {
  /**
   * ルームグループが所属するユーザーが所属するカンパニー
   *
   * 原則として認証ユーザが所属するカンパニーに所属するルームグループを削除しますが、
   * 他カンパニーの ルームグループを削除する場合は当フィールドを指定してください。
   */
  company?: InputMaybe<Scalars['ID']>;
  /** ルームグループのID */
  id: Scalars['ID'];
};

/** ルームグループ削除結果 */
export type DeleteRoomGroupResult = DeleteRoomGroupFailed | DeleteRoomGroupSuccess;

/** ルームグループ削除成功 */
export type DeleteRoomGroupSuccess = {
  __typename?: 'DeleteRoomGroupSuccess';
  /** 削除済みルームグループID */
  deleteRoomGroupId: Scalars['ID'];
};

/** ルームグループ削除失敗 */
export type DeleteRoomGroupsFailed = {
  __typename?: 'DeleteRoomGroupsFailed';
  reason: Scalars['String'];
};

/** ルームグループ削除インプット */
export type DeleteRoomGroupsInput = {
  /**
   * 削除対象カンパニーID
   *
   * 原則として認証ユーザーが属するカンパニーのルームグループのみ削除可能ですが、
   * 当引数で指定されたカンパニーのループグループを削除対象とします。
   */
  company?: InputMaybe<Scalars['ID']>;
  /** ルームグループのID */
  ids: Array<Scalars['ID']>;
};

/** ルームグループ削除結果 */
export type DeleteRoomGroupsResult = DeleteRoomGroupsFailed | DeleteRoomGroupsSuccess;

/** ルームグループ削除成功 */
export type DeleteRoomGroupsSuccess = {
  __typename?: 'DeleteRoomGroupsSuccess';
  /** 削除済みルームグループID */
  deleteRoomGroupIds: Array<Scalars['ID']>;
};

/** ルーム削除失敗 */
export type DeleteRoomsFailed = {
  __typename?: 'DeleteRoomsFailed';
  reason: Scalars['String'];
};

/** ルーム削除インプット */
export type DeleteRoomsInput = {
  ids: Array<Scalars['ID']>;
};

/** ルーム削除結果 */
export type DeleteRoomsResult = DeleteRoomsFailed | DeleteRoomsSuccess;

/** ルーム削除成功 */
export type DeleteRoomsSuccess = {
  __typename?: 'DeleteRoomsSuccess';
  /** 削除済みのRoomID */
  deleteRoomIds: Array<Scalars['ID']>;
};

export type DeleteScenarioFailed = {
  __typename?: 'DeleteScenarioFailed';
  reason: Scalars['String'];
};

export type DeleteScenarioInput = {
  /**
   * 更新対象カンパニー
   *
   * 原則として認証ユーザーが属するカンパニーのシナリオを削除可能ですが、
   * 当引数で指定されたカンパニーのシナリオを削除対象とします。
   */
  company?: InputMaybe<Scalars['ID']>;
  /** 削除対象のシナリオID */
  scenario: Scalars['ID'];
};

export type DeleteScenarioResult = DeleteScenarioFailed | DeleteScenarioSuccess;

export type DeleteScenarioSuccess = {
  __typename?: 'DeleteScenarioSuccess';
  deletedScenarioId: Scalars['ID'];
};

export type DeleteScenarioViewButtonFailed = {
  __typename?: 'DeleteScenarioViewButtonFailed';
  reason: Scalars['String'];
};

export type DeleteScenarioViewButtonInput = {
  /**
   * 対象カンパニー
   *
   * 原則として認証ユーザーが属するカンパニーのシナリオビューボタンを削除可能ですが、
   * 当引数で指定されたカンパニーのシナリオビューボタンを削除対象とします。
   */
  company?: InputMaybe<Scalars['ID']>;
  /** 削除対象シナリオビューボタンID */
  scenarioViewButton: Scalars['ID'];
};

export type DeleteScenarioViewButtonResult = DeleteScenarioViewButtonFailed | DeleteScenarioViewButtonSuccess;

export type DeleteScenarioViewButtonSuccess = {
  __typename?: 'DeleteScenarioViewButtonSuccess';
  /** 削除したシナリオビューボタンID */
  deletedScenarioViewButton: Scalars['ID'];
  /** ボタン削除後のシナリオビュー */
  scenarioView: ScenarioView;
};

export type DeleteScenarioViewFailed = {
  __typename?: 'DeleteScenarioViewFailed';
  reason: Scalars['String'];
};

export type DeleteScenarioViewInput = {
  /**
   * 更新対象カンパニー
   *
   * 原則として認証ユーザーが属するカンパニーのシナリオビューを更新可能ですが、
   * 当引数で指定されたカンパニーのシナリオビューを更新対象とします。
   */
  company?: InputMaybe<Scalars['ID']>;
  /** 削除対象シナリオビューID */
  id: Scalars['ID'];
};

export type DeleteScenarioViewResult = DeleteScenarioViewFailed | DeleteScenarioViewSuccess;

export type DeleteScenarioViewSuccess = {
  __typename?: 'DeleteScenarioViewSuccess';
  deletedScenarioViewId: Scalars['ID'];
};

/** スピーチ削除失敗 */
export type DeleteSpeechFailed = {
  __typename?: 'DeleteSpeechFailed';
  reason?: Maybe<Scalars['String']>;
};

export type DeleteSpeechGroupFailed = {
  __typename?: 'DeleteSpeechGroupFailed';
  reason: Scalars['String'];
};

export type DeleteSpeechGroupInput = {
  id: Scalars['ID'];
};

export type DeleteSpeechGroupResult = DeleteSpeechGroupFailed | DeleteSpeechGroupSuccess;

export type DeleteSpeechGroupSuccess = {
  __typename?: 'DeleteSpeechGroupSuccess';
  deleteSpeechGroupId: Scalars['ID'];
};

/** スピーチ削除インプット */
export type DeleteSpeechInput = {
  /** 削除対象スピーチ */
  id: Scalars['ID'];
};

/** スピーチ削除結果 */
export type DeleteSpeechResult = DeleteSpeechFailed | DeleteSpeechSuccess;

/** スピーチ削除成功 */
export type DeleteSpeechSuccess = {
  __typename?: 'DeleteSpeechSuccess';
  /** 削除済みスピーチID */
  deleteSpeechId: Scalars['ID'];
};

export type DeleteSystemNotificationsFailed = {
  __typename?: 'DeleteSystemNotificationsFailed';
  reason: Scalars['String'];
};

export type DeleteSystemNotificationsInput = {
  ids: Array<Scalars['ID']>;
};

export type DeleteSystemNotificationsResult = DeleteSystemNotificationsFailed | DeleteSystemNotificationsSuccess;

export type DeleteSystemNotificationsSuccess = {
  __typename?: 'DeleteSystemNotificationsSuccess';
  deletedIds: Array<Scalars['ID']>;
};

/** 削除に失敗 */
export type DeleteTemplatesFailed = {
  __typename?: 'DeleteTemplatesFailed';
  /** 失敗理由 */
  reason: Scalars['String'];
};

/** テンプレート削除インプット */
export type DeleteTemplatesInput = {
  /** 削除対象となるテンプレートの Node ID 一覧 */
  ids: Array<Scalars['ID']>;
};

/** テンプレート削除結果 */
export type DeleteTemplatesResult = DeleteTemplatesFailed | DeleteTemplatesSuccess | DeleteTemplatesUsing;

/** 削除に成功 */
export type DeleteTemplatesSuccess = {
  __typename?: 'DeleteTemplatesSuccess';
  /** 削除済みのテンプレートID一覧 */
  deletedIds: Array<Scalars['ID']>;
};

/** 使用中のテンプレートのため削除できない */
export type DeleteTemplatesUsing = {
  __typename?: 'DeleteTemplatesUsing';
  /** 使用中のテンプレート */
  templates: Array<Template>;
};

export type DeleteUserGroupsFailed = {
  __typename?: 'DeleteUserGroupsFailed';
  reason: Scalars['String'];
};

export type DeleteUserGroupsInput = {
  /**
   * 削除対象カンパニー
   *
   * 原則、認証ユーザーが属するカンパニーのユーザー・グループを削除しますが、
   * 他カンパニーのユーザー・グループを削除する場合は当フィールドを指定してください。
   */
  company?: InputMaybe<Scalars['ID']>;
  /** 削除対象のユーザーグループID */
  ids: Array<Scalars['ID']>;
};

export type DeleteUserGroupsResult = DeleteUserGroupsFailed | DeleteUserGroupsSuccess;

export type DeleteUserGroupsSuccess = {
  __typename?: 'DeleteUserGroupsSuccess';
  /** 削除済みのUserGroupID */
  deleteUserGroupIds: Array<Scalars['ID']>;
};

/** 削除対象ユーザーに自身を含んでいるため削除できない */
export type DeleteUsersCannotDeleteMyself = {
  __typename?: 'DeleteUsersCannotDeleteMyself';
  reason: Scalars['String'];
};

export type DeleteUsersFailed = {
  __typename?: 'DeleteUsersFailed';
  reason: Scalars['String'];
};

export type DeleteUsersInput = {
  ids: Array<Scalars['ID']>;
};

export type DeleteUsersResult = DeleteUsersCannotDeleteMyself | DeleteUsersFailed | DeleteUsersSuccess;

export type DeleteUsersSuccess = {
  __typename?: 'DeleteUsersSuccess';
  deleteUserIds: Array<Scalars['ID']>;
};

/** 動画削除失敗 */
export type DeleteVideoFailed = {
  __typename?: 'DeleteVideoFailed';
  /** 理由 */
  reason?: Maybe<Scalars['String']>;
};

export type DeleteVideoGroupFailed = {
  __typename?: 'DeleteVideoGroupFailed';
  reason?: Maybe<Scalars['String']>;
};

/** 動画グループ削除インプット */
export type DeleteVideoGroupInput = {
  id: Scalars['ID'];
};

export type DeleteVideoGroupResult = DeleteVideoGroupFailed | DeleteVideoGroupSuccess;

export type DeleteVideoGroupSuccess = {
  __typename?: 'DeleteVideoGroupSuccess';
  deleteVideoGroupId: Scalars['ID'];
};

/** 動画削除インプット */
export type DeleteVideoInput = {
  /** 削除対象の動画 */
  id: Scalars['ID'];
};

/** 動画削除結果 */
export type DeleteVideoResult = DeleteVideoFailed | DeleteVideoSuccess;

/** 動画削除成功 */
export type DeleteVideoSuccess = {
  __typename?: 'DeleteVideoSuccess';
  /** 削除済み動画ID */
  deleteVideoId: Scalars['ID'];
};

export type DetachAnalyticalInfoFromPcFailed = {
  __typename?: 'DetachAnalyticalInfoFromPcFailed';
  reason: Scalars['String'];
};

export type DetachAnalyticalInfoFromPcInput = {
  analyticalInfo: Scalars['ID'];
  pc: Scalars['ID'];
};

export type DetachAnalyticalInfoFromPcResult = DetachAnalyticalInfoFromPcFailed | DetachAnalyticalInfoFromPcSuccess;

export type DetachAnalyticalInfoFromPcSuccess = {
  __typename?: 'DetachAnalyticalInfoFromPcSuccess';
  pc: Pc;
};

export type DetachImageFromPcFailed = {
  __typename?: 'DetachImageFromPcFailed';
  reason: Scalars['String'];
};

export type DetachImageFromPcInput = {
  image: Scalars['ID'];
  pc: Scalars['ID'];
};

export type DetachImageFromPcResult = DetachImageFromPcFailed | DetachImageFromPcSuccess;

export type DetachImageFromPcSuccess = {
  __typename?: 'DetachImageFromPcSuccess';
  pc: Pc;
};

/** 画像グループと画像の紐付け解除失敗 */
export type DetachImageGroupFromImageFailed = {
  __typename?: 'DetachImageGroupFromImageFailed';
  /** 失敗理由 */
  reason: Scalars['String'];
};

/** 画像グループと画像の紐付け解除インプット */
export type DetachImageGroupFromImageInput = {
  image: Scalars['ID'];
};

/** 画像グループと画像の紐付け解除結果 */
export type DetachImageGroupFromImageResult = DetachImageGroupFromImageFailed | DetachImageGroupFromImageSuccess;

/** 画像グループと画像の紐付け解除成功 */
export type DetachImageGroupFromImageSuccess = {
  __typename?: 'DetachImageGroupFromImageSuccess';
  /** 画像 */
  image: Image;
};

/** メディア・イベント解除失敗 */
export type DetachMediaEventFailed = {
  __typename?: 'DetachMediaEventFailed';
  /** 理由 */
  reason?: Maybe<Scalars['String']>;
};

/** 店舗メディア・イベント解除失敗 */
export type DetachMediaEventFromPcFailed = {
  __typename?: 'DetachMediaEventFromPcFailed';
  /** 理由 */
  reason?: Maybe<Scalars['String']>;
};

/** 店舗メディア・イベント解除インプット */
export type DetachMediaEventFromPcInput = {
  /** 対象イベント */
  event: MediaEventType;
  /** 解除対象PC */
  pcId: Scalars['ID'];
};

/** 店舗メディア・イベント解除結果 */
export type DetachMediaEventFromPcResult = DetachMediaEventFromPcFailed | DetachMediaEventFromPcSuccess;

/** 店舗メディア・イベント解除成功 */
export type DetachMediaEventFromPcSuccess = {
  __typename?: 'DetachMediaEventFromPcSuccess';
  /** PC */
  pc: Pc;
};

/** メディア・イベント解除インプット */
export type DetachMediaEventInput = {
  /** 対象イベント */
  event: MediaEventType;
  /** 解除対象 */
  owner: Scalars['ID'];
};

/** メディア・イベント解除結果 */
export type DetachMediaEventResult = DetachMediaEventFailed | DetachMediaEventSuccess;

/** メディア・イベント解除成功 */
export type DetachMediaEventSuccess = {
  __typename?: 'DetachMediaEventSuccess';
  /** オーナー */
  owner: MediaEventOwner;
};

export type DetachNotificationFromPcFailed = {
  __typename?: 'DetachNotificationFromPcFailed';
  reason: Scalars['String'];
};

export type DetachNotificationFromPcInput = {
  notification: Scalars['ID'];
  pc: Scalars['ID'];
};

export type DetachNotificationFromPcResult = DetachNotificationFromPcFailed | DetachNotificationFromPcSuccess;

export type DetachNotificationFromPcSuccess = {
  __typename?: 'DetachNotificationFromPcSuccess';
  pc: Pc;
};

export type DetachScenarioFromPcFailed = {
  __typename?: 'DetachScenarioFromPcFailed';
  reason: Scalars['String'];
};

export type DetachScenarioFromPcInput = {
  /** 解除対象PC */
  pc: Scalars['ID'];
  /** 対象シナリオ */
  scenario: Scalars['ID'];
};

export type DetachScenarioFromPcResult = DetachScenarioFromPcFailed | DetachScenarioFromPcSuccess;

export type DetachScenarioFromPcSuccess = {
  __typename?: 'DetachScenarioFromPcSuccess';
  /** PC */
  pc: Pc;
};

export type DetachSoundFromPcFailed = {
  __typename?: 'DetachSoundFromPcFailed';
  reason: Scalars['String'];
};

export type DetachSoundFromPcInput = {
  pc: Scalars['ID'];
  soundEventType: SoundEventType;
};

export type DetachSoundFromPcResult = DetachSoundFromPcFailed | DetachSoundFromPcSuccess;

export type DetachSoundFromPcSuccess = {
  __typename?: 'DetachSoundFromPcSuccess';
  pc: Pc;
};

export type DetachSpeechFromPcInput = {
  pc: Scalars['ID'];
  speech: Scalars['ID'];
};

export type DetachSpeechFromPcResult = DetachSpeechToPcFailed | DetachSpeechToPcSuccess;

export type DetachSpeechToPcFailed = {
  __typename?: 'DetachSpeechToPcFailed';
  reason: Scalars['String'];
};

export type DetachSpeechToPcSuccess = {
  __typename?: 'DetachSpeechToPcSuccess';
  pc: Pc;
};

export type DetachUserGroupsFromNotificationFailed = {
  __typename?: 'DetachUserGroupsFromNotificationFailed';
  reason: Scalars['String'];
};

export type DetachUserGroupsFromNotificationInput = {
  /**
   * 対象カンパニー
   *
   * タイムリープに所属するユーザーのみカンパニーの指定が可能です。
   */
  company?: InputMaybe<Scalars['ID']>;
  /** 対象の通知 */
  notificationId: Scalars['ID'];
  /** 通知対象から解除したいUserGroupの一覧 */
  userGroups: Array<Scalars['ID']>;
};

export type DetachUserGroupsFromNotificationResult = DetachUserGroupsFromNotificationFailed | DetachUserGroupsFromNotificationSuccess;

export type DetachUserGroupsFromNotificationSuccess = {
  __typename?: 'DetachUserGroupsFromNotificationSuccess';
  /** ユーザーグループとの紐付けを解除した通知 */
  notification: Notification;
};

/** PC 動画紐付け解除失敗 */
export type DetachVideoFromPcFailed = {
  __typename?: 'DetachVideoFromPcFailed';
  /** 失敗理由 */
  reason?: Maybe<Scalars['String']>;
};

/** PC 動画紐付け解除インプット */
export type DetachVideoFromPcInput = {
  /** 対象のPC */
  pcId: Scalars['ID'];
  /** 紐付け解除対象の動画 */
  videoId: Scalars['ID'];
};

/** PC 動画紐付け解除結果 */
export type DetachVideoFromPcResult = DetachVideoFromPcFailed | DetachVideoFromPcSuccess;

/** PC 動画紐付け解除成功 */
export type DetachVideoFromPcSuccess = {
  __typename?: 'DetachVideoFromPcSuccess';
  pc: Pc;
};

export type DetachVideoGroupFromVideoFailed = {
  __typename?: 'DetachVideoGroupFromVideoFailed';
  reason: Scalars['String'];
};

export type DetachVideoGroupFromVideoInput = {
  videoId: Scalars['ID'];
};

export type DetachVideoGroupFromVideoResult = DetachVideoGroupFromVideoFailed | DetachVideoGroupFromVideoSuccess;

export type DetachVideoGroupFromVideoSuccess = {
  __typename?: 'DetachVideoGroupFromVideoSuccess';
  video: Video;
};

/**
 * 表示オプション
 *
 * 店舗モニターに店舗映像を表示するオプション
 */
export enum DisplayOption {
  /** 常に表示 */
  All = 'ALL',
  /** 表示しない */
  None = 'NONE',
  /** 接客中のみ表示 */
  Reception = 'RECEPTION',
  /** 待機中のみ表示 */
  Waiting = 'WAITING'
}

/** エッジ */
export type Edge = {
  /** カーソル */
  cursor: Scalars['String'];
  /** ノード */
  node: Node;
};

export type EndBreakFailed = {
  __typename?: 'EndBreakFailed';
  reason?: Maybe<Scalars['String']>;
};

export type EndBreakResult = EndBreakFailed | EndBreakSuccess;

export type EndBreakSuccess = {
  __typename?: 'EndBreakSuccess';
  endTime: Scalars['Time'];
};

/** 接客評価インプット */
export type EvaluateCustomerServiceInput = {
  /** 評価対象の接客情報 */
  customerService: Scalars['ID'];
};

/** 接客評価結果 */
export type EvaluateCustomerServiceResult = EvaluationsCustomerServiceFailed | EvaluationsCustomerServiceSuccess | EvaluationsCustomerUnavailable;

/** 接客評価失敗 */
export type EvaluationsCustomerServiceFailed = {
  __typename?: 'EvaluationsCustomerServiceFailed';
  reason: Scalars['String'];
};

/** 接客評価受付成功 */
export type EvaluationsCustomerServiceSuccess = {
  __typename?: 'EvaluationsCustomerServiceSuccess';
  /** 評価を開始した接客情報 */
  customerService: CustomerService;
};

/**
 * 接客評価使用不可
 *
 * 利用上限に到達などの理由により、接客評価が行えない場合に返却されます。
 */
export type EvaluationsCustomerUnavailable = {
  __typename?: 'EvaluationsCustomerUnavailable';
  reason: Scalars['String'];
};

/** 拡張アプリ */
export type ExtensionApp = Node & {
  __typename?: 'ExtensionApp';
  /**
   * 有効な拡張アプリであるか
   *
   * 有効な拡張アプリは RURA の接客画面で表示対象となります。
   */
  active: Scalars['Boolean'];
  /** カンパニー */
  company: Company;
  /** データストアID */
  datastoreId: Scalars['UUID'];
  /**
   * 表示名
   *
   * RURA接客画面におけるタブなどで使用
   */
  displayName: Scalars['String'];
  /** オブジェクトID */
  id: Scalars['ID'];
  /** 拡張アプリ名 */
  name: Scalars['String'];
  /** iframeのsrc属性に指定するURL */
  url: Scalars['URL'];
};

/** 拡張アプリコネクション */
export type ExtensionAppConnection = Connection & {
  __typename?: 'ExtensionAppConnection';
  /** エッジ一覧 */
  edges: Array<ExtensionAppEdge>;
  /** ノード一覧 */
  nodes: Array<ExtensionApp>;
  /** ページ情報 */
  pageInfo: PageInfo;
  /** 総件数 */
  totalCount: Scalars['Int'];
};

/** 拡張アプリエッジ */
export type ExtensionAppEdge = Edge & {
  __typename?: 'ExtensionAppEdge';
  /** カーソル */
  cursor: Scalars['String'];
  /** ノード */
  node: ExtensionApp;
};

/** 外部サービス */
export enum ExternalService {
  /** CocoDesk オンライン相談サービス */
  CocoDesk = 'COCO_DESK'
}

/**
 * 制御可能機能
 *
 * 設定によって ON / OFF が切替可能な機能。
 */
export enum Feature {
  /**
   * 通信量の解析 (index: 45)
   *
   * 店舗PCや遠隔スタッフの通信量の解析を行う機能
   */
  AnalysisTrafficVolume = 'ANALYSIS_TRAFFIC_VOLUME',
  /** 接客分析 (index: 14) */
  Analytics = 'ANALYTICS',
  /**
   * stream通信量の自動調整 (index: 46)
   *
   * 店舗PCや遠隔スタッフの通信streamの自動調整を行う機能
   */
  AutoAdjustStream = 'AUTO_ADJUST_STREAM',
  /** 背景マスキング (index: 26) */
  BackgroundMasking = 'BACKGROUND_MASKING',
  /**
   * 接客中に待機映像に空の映像を送信する (index: 41)
   *
   * 接客中に待機映像に空の映像を送信する
   */
  BlankFrameMode = 'BLANK_FRAME_MODE',
  /** 接客開始時のブラー (index: 53) */
  BlurOnStarting = 'BLUR_ON_STARTING',
  /** 店舗ディスプレイのキャプチャ (index: 13) */
  CaptureShopDisplay = 'CAPTURE_SHOP_DISPLAY',
  /** 接客中店舗の入出力音量操作 (index: 9) */
  ChangeShopAudioVolumeInCs = 'CHANGE_SHOP_AUDIO_VOLUME_IN_CS',
  /**
   * チャット機能 (index: 32)
   *
   * 有効な場合はチャット機能の利用を許可します。
   * 本機能はカンパニー毎の制御となります。
   */
  Chat = 'CHAT',
  /**
   * チャット通話機能 (index: 48)
   *
   * チャット内で通話を行える機能
   */
  ChatCalling = 'CHAT_CALLING',
  /** 時刻表示 (index: 23) */
  Clock = 'CLOCK',
  /** CocoDesk 連携 (index: 25) */
  Cocodesk = 'COCODESK',
  /** 横断通知 (index: 27) */
  CrossNotification = 'CROSS_NOTIFICATION',
  /** 接客中メディアとモーション (index: 3) */
  CsMedia = 'CS_MEDIA',
  /** 人検知 (index: 19) */
  DetectionHuman = 'DETECTION_HUMAN',
  /** 動体検知 (index: 18) */
  DetectionMovingObject = 'DETECTION_MOVING_OBJECT',
  /** 音声検知 (index: 17) */
  DetectionSound = 'DETECTION_SOUND',
  /** 通知の経過秒数表示 (index: 30) */
  ElapsedTime = 'ELAPSED_TIME',
  /**
   * 接客時の解像度を上げる (index: 39)
   *
   * 接客画面の店舗側映像の解像度を上げます。
   */
  EndUserUltraResolution = 'END_USER_ULTRA_RESOLUTION',
  /** 接客採点 (index: 29) */
  EvaluateCustomerService = 'EVALUATE_CUSTOMER_SERVICE',
  /**
   * フェイスマスキング機能 (index: 55)
   *
   * ON の場合、フェイスマスキング機能が使用できます。
   * デフォルトは OFF です。
   */
  FaceMasking = 'FACE_MASKING',
  /**
   * 店舗側のメディアを全画面画像表示する機能 (index: 50)
   *
   * 現在は縦型のみ参照するようにしています
   */
  FullScreenMedia = 'FULL_SCREEN_MEDIA',
  /**
   * 人検知 (index: 42)
   *
   * 人認識での検知を行います(使用していません)
   * @deprecated 人検知は別の権限と重複しているため不要です
   */
  HumanDetection = 'HUMAN_DETECTION',
  /** 検証用機能 (index: 15) */
  Inspection = 'INSPECTION',
  /**
   * PC監視連携 (index: 44)
   *
   * 店舗PCのメモリやネットワークのリアルタイム監視を行う機能
   */
  InspectionShopPc = 'INSPECTION_SHOP_PC',
  /**
   * videoCodecを最新版で使用する機能 (index: 49)
   *
   * p2pのvideoCodecを最新版で使用する機能
   * 最新:AV1 / 旧:VP9
   */
  LatestVideoCodec = 'LATEST_VIDEO_CODEC',
  /**
   * 「連携」タブ選択 (index: 38)
   *
   * 有効な場合、接客開始時に「ホーム」タブではなく「連携」タブが選択されます。
   */
  LaunchCollaborationTab = 'LAUNCH_COLLABORATION_TAB',
  /**
   * 店舗から送信される映像のフレームレートの低下 (index: 40)
   *
   * 店舗側から送信される待機映像のみフレームレートを1に下げます。(待機映像に送るもののみ)　
   */
  LowFpsMode = 'LOW_FPS_MODE',
  /** ルーム移動 (index: 20) */
  MoveRoom = 'MOVE_ROOM',
  /**
   * 複数カメラ映像表示機能 (index: 36)
   *
   * 有効な場合は店舗に接続されているカメラの数だけ店舗に映像が表示されます。
   */
  MultiCameraViewer = 'MULTI_CAMERA_VIEWER',
  /** ノイズキャンセリング (index: 2) */
  NoiseCancel = 'NOISE_CANCEL',
  /** ピクチャーインピクチャー (index: 16) */
  PictureInPicture = 'PICTURE_IN_PICTURE',
  /** 接客状態のビットレート制御 (index: 52) */
  ReceptionBitrateControl = 'RECEPTION_BITRATE_CONTROL',
  /**
   * 録音 (index: 1)
   *
   * 接客中の店舗、スタッフの音声を録音します。
   */
  Recording = 'RECORDING',
  /**
   * 手元カメラ機能 (index: 35)
   *
   * 有効な場合は接客画面に手元カメラのタブが表示されます
   */
  RemoteViewer = 'REMOTE_VIEWER',
  /**
   * 手元カメラ高解像度モード (index: 43)
   *
   * 手元カメラ機能で高解像度の映像を遠隔スタッフに送信します
   */
  RemoteViewerHighResolution = 'REMOTE_VIEWER_HIGH_RESOLUTION',
  /**
   * 手元カメラの回転 (index: 54)
   *
   * ON の場合、接客画面での手元カメラの回転を許可します。
   * デフォルトは OFF です。
   */
  RotateOnRemoteViewer = 'ROTATE_ON_REMOTE_VIEWER',
  /** 店舗映像の拡大縮小 (index: 11) */
  ScaleShopVideo = 'SCALE_SHOP_VIDEO',
  /**
   * シナリオ機能 (index: 33)
   *
   * 有効な場合はシナリオ機能の利用を許可します。
   * 本機能はカンパニー毎の制御となります。
   */
  Scenario = 'SCENARIO',
  /** スクリーンセーバ (index: 24) */
  ScreenSaver = 'SCREEN_SAVER',
  /** 画面共有 (index: 5) */
  ScreenShare = 'SCREEN_SHARE',
  /** テキスト送信 (index: 8) */
  SendText = 'SEND_TEXT',
  /**
   * 店舗チャットを使用可能にする機能 (index: 47)
   *
   * 店舗ごとのチャットを使用可能にする機能
   */
  ShopChat = 'SHOP_CHAT',
  /**
   * 店舗デザインβ (index: 37)
   *
   * 有効な場合は店舗側のデザインが検証中のデザインに切り替わります。
   * βの理由は同様の機能が複数できる可能性があるためです。
   */
  ShopDesignBeta = 'SHOP_DESIGN_BETA',
  /** PC 種別の表示 (index: 22) */
  ShowShopType = 'SHOW_SHOP_TYPE',
  /** 接客中のスタッフ映像 (index: 10) */
  ShowStaffCamera = 'SHOW_STAFF_CAMERA',
  /** スタッフのボリューム変更 (index: 12) */
  StaffMicVolume = 'STAFF_MIC_VOLUME',
  /** 字幕 (index: 6) */
  Subtitle = 'SUBTITLE',
  /** ワーカーのカメラと解像度の切り替え (index: 28) */
  SwitchCameraResolution = 'SWITCH_CAMERA_RESOLUTION',
  /** 店舗カメラの切り替え (index: 4) */
  SwitchShopCamera = 'SWITCH_SHOP_CAMERA',
  /** 翻訳 (index: 7) */
  Translate = 'TRANSLATE',
  /**
   * 店鋪の TURN 利用 (index: 31)
   *
   * 有効な場合は店鋪の TURN による UDP リレーを許可します。
   * また、本機能は店舗毎の制御となります。
   */
  TurnForShop = 'TURN_FOR_SHOP',
  /**
   * 遠隔スタッフの TURN 利用 (index: 34)
   *
   * 有効な場合は遠隔スタッフの TURN による UDP リレー利用を許可します。
   * 本機能はカンパニー毎の制御となります。
   */
  TurnForStaff = 'TURN_FOR_STAFF',
  /** 通知なしで接客に入れるか (index: 21) */
  UnannouncedInService = 'UNANNOUNCED_IN_SERVICE',
  /** 待機状態のビットレート制御 (index: 51) */
  WaitingBitrateControl = 'WAITING_BITRATE_CONTROL'
}

/**
 * 機能トグル
 *
 * 機能の ON / OFF を管理するためのモデルです。
 */
export type FeatureToggle = {
  __typename?: 'FeatureToggle';
  /** 有効であるか */
  enabled: Scalars['Boolean'];
  /** 機能 */
  feature: Feature;
};

/** 機能トグルインプット */
export type FeatureToggleInput = {
  /** 有効であるか */
  enabled: Scalars['Boolean'];
  /** 機能 */
  feature: Feature;
};

export type FinishWorkingFailed = {
  __typename?: 'FinishWorkingFailed';
  reason?: Maybe<Scalars['String']>;
};

export type FinishWorkingResult = FinishWorkingFailed | FinishWorkingSuccess;

export type FinishWorkingSuccess = {
  __typename?: 'FinishWorkingSuccess';
  finishTime: Scalars['Time'];
};

/** Frame */
export type Frame = Node & {
  __typename?: 'Frame';
  /** Frameが属するカンパニー */
  company: Company;
  /** データストアID */
  datastoreId: Scalars['UUID'];
  /** オブジェクトID */
  id: Scalars['ID'];
  /** 一度接客したらWebRTCを切断するかどうか */
  onceReception: Scalars['Boolean'];
  /** frameとして振る舞うPC */
  pc: Pc;
  /** Frameを使用する環境 */
  platform: FramePlatform;
  /** 起動時の通知先 */
  startNotice?: Maybe<Notification>;
  /** Frame種別 */
  type: FrameType;
  /** RuraFrameとしてのURL */
  url: Scalars['URL'];
  /** メディア使用フラグ */
  useMedia: Scalars['Boolean'];
  /**
   * 店舗映像送信フラグ
   * 店舗側が自身の映像を送るかどうか
   */
  useVideo: Scalars['Boolean'];
  /**
   * スタッフビデオ表示フラグ
   * 店舗側でスタッフのカメラ映像を表示させるかどうか
   */
  viewStaffVideo: Scalars['Boolean'];
};

/** Frameコネクション */
export type FrameConnection = Connection & {
  __typename?: 'FrameConnection';
  /** エッジ一覧 */
  edges: Array<FrameEdge>;
  /** ノード一覧 */
  nodes: Array<Frame>;
  /** ページ情報 */
  pageInfo: PageInfo;
  /** 総件数 */
  totalCount: Scalars['Int'];
};

/** Frameエッジ */
export type FrameEdge = Edge & {
  __typename?: 'FrameEdge';
  /** カーソル */
  cursor: Scalars['String'];
  /** ノード */
  node: Frame;
};

/** Frameを使用する環境 */
export enum FramePlatform {
  /** Android */
  Android = 'ANDROID',
  /** iOS */
  Ios = 'IOS',
  /** Web */
  Web = 'WEB'
}

/** Frame種別 */
export type FrameType = Node & {
  __typename?: 'FrameType';
  /** データストアID */
  datastoreId: Scalars['UUID'];
  /** オブジェクトID */
  id: Scalars['ID'];
  /** Frame種別名 */
  name: Scalars['String'];
  /** Frame種別の所有者 */
  owner: Company;
  /** Frame種別 */
  value: Scalars['String'];
};

export type FrameTypeConnection = Connection & {
  __typename?: 'FrameTypeConnection';
  /** エッジ一覧 */
  edges: Array<FrameTypeEdge>;
  /** ノード一覧 */
  nodes: Array<FrameType>;
  /** ページ一覧 */
  pageInfo: PageInfo;
  /** 総件数 */
  totalCount: Scalars['Int'];
};

export type FrameTypeEdge = Edge & {
  __typename?: 'FrameTypeEdge';
  /** カーソル */
  cursor: Scalars['String'];
  /** ノード */
  node: FrameType;
};

/** 画像 */
export type Image = Node & {
  __typename?: 'Image';
  /** カンパニー */
  company: Company;
  /** データストアID */
  datastoreId: Scalars['String'];
  /** オブジェクトID */
  id: Scalars['ID'];
  /** 所属する画像グループ */
  imageGroup?: Maybe<ImageGroup>;
  /** 画像名 */
  name: Scalars['String'];
  /** サムネイル画像のURL（署名付きURL） */
  presignedThumbnail?: Maybe<Scalars['URL']>;
  /** 署名付きURL */
  presignedUrl?: Maybe<Scalars['URL']>;
  /** 優先度 */
  priority: Scalars['Int'];
  /** 画像URL */
  src?: Maybe<Scalars['URL']>;
  /** サムネイル画像のURL */
  thumbnail?: Maybe<Scalars['URL']>;
};

/** 画像コネクション */
export type ImageConnection = Connection & {
  __typename?: 'ImageConnection';
  /** エッジ一覧 */
  edges: Array<ImageEdge>;
  /** ノード一覧 */
  nodes: Array<Image>;
  /** ページ情報 */
  pageInfo: PageInfo;
  /** 総件数 */
  totalCount: Scalars['Int'];
};

/** 画像エッジ */
export type ImageEdge = Edge & {
  __typename?: 'ImageEdge';
  /** カーソル */
  cursor: Scalars['String'];
  /** ノード */
  node: Image;
};

/** 画像グループ */
export type ImageGroup = Node & {
  __typename?: 'ImageGroup';
  /** データストアID */
  datastoreId: Scalars['String'];
  /** オブジェクトID */
  id: Scalars['ID'];
  /** グループに属する画像の一覧 */
  images?: Maybe<Array<Image>>;
  /** グループ名 */
  name: Scalars['String'];
  /** 画像グループの所有者 */
  owner: Company;
  /** 優先度 */
  priority: Scalars['Int'];
};

/** 画像グループコネクション */
export type ImageGroupConnection = Connection & {
  __typename?: 'ImageGroupConnection';
  /** エッジ一覧 */
  edges: Array<ImageGroupEdge>;
  /** ノード一覧 */
  nodes: Array<ImageGroup>;
  /** ページ情報 */
  pageInfo: PageInfo;
  /** 総件数 */
  totalCount: Scalars['Int'];
};

/** 画像グループエッジ */
export type ImageGroupEdge = Edge & {
  __typename?: 'ImageGroupEdge';
  /** カーソル */
  cursor: Scalars['String'];
  /** ノード */
  node: ImageGroup;
};

/**
 * 通信許可IPアドレス
 *
 * カンパニーが IP 制限を掛けている際に、通信を許可する IP アドレスを管理します。
 */
export type IngressIpAddress = Node & {
  __typename?: 'IngressIPAddress';
  /** カンパニー */
  company: Company;
  /** 作成日時 */
  createdAt: Scalars['Time'];
  /** データストアID */
  datastoreId: Scalars['Int'];
  /** オブジェクトID */
  id: Scalars['ID'];
  /** IP アドレス */
  ipAddress: Scalars['IPAddress'];
  /** 通信許可IPアドレス設定名 */
  name: Scalars['String'];
  /** 備考 */
  remark?: Maybe<Scalars['String']>;
};

export type IngressIpAddressConnection = Connection & {
  __typename?: 'IngressIPAddressConnection';
  /** エッジ一覧 */
  edges: Array<IngressIpAddressEdge>;
  /** ノード一覧 */
  nodes: Array<IngressIpAddress>;
  /** ページ情報 */
  pageInfo: PageInfo;
  /** 総件数 */
  totalCount: Scalars['Int'];
};

export type IngressIpAddressEdge = Edge & {
  __typename?: 'IngressIPAddressEdge';
  /** カーソル */
  cursor: Scalars['String'];
  /** ノード */
  node: IngressIpAddress;
};

/**
 * ジョブステータス
 *
 * 非同期処理などのジョブについて、進捗状況を表すステータスです。
 */
export enum JobStatus {
  /** 失敗 */
  Failed = 'FAILED',
  /** 終了 */
  Finished = 'FINISHED',
  /** 処理中 */
  Processing = 'PROCESSING',
  /** 開始 */
  Starting = 'STARTING'
}

/** ローカルサーバ状態 */
export enum LocalServerStatus {
  /** 命令:再起動/更新する */
  Reboot = 'REBOOT',
  /** 命令:起動する */
  Start = 'START',
  /** 状態:起動中 */
  Starting = 'STARTING',
  /** 命令:停止する */
  Stop = 'STOP',
  /** 状態:停止中 */
  Stopped = 'STOPPED'
}

/** ログイン禁止リスト */
export type LoginBlacklist = Node & {
  __typename?: 'LoginBlacklist';
  /** 作成日時 */
  createdAt: Scalars['Time'];
  /** データストアID */
  datastoreId: Scalars['Int'];
  /** オブジェクトID */
  id: Scalars['ID'];
  /** ログインが禁止されている IP アドレス */
  ipAddress: Scalars['IPAddress'];
};

/** ログイン禁止リストコネクション */
export type LoginBlacklistConnection = Connection & {
  __typename?: 'LoginBlacklistConnection';
  /** エッジ一覧 */
  edges: Array<LoginBlacklistEdge>;
  /** ノード一覧 */
  nodes: Array<LoginBlacklist>;
  /** ページ情報 */
  pageInfo: PageInfo;
  /** 総件数 */
  totalCount: Scalars['Int'];
};

/** ログイン禁止リストエッジ */
export type LoginBlacklistEdge = Edge & {
  __typename?: 'LoginBlacklistEdge';
  /** カーソル */
  cursor: Scalars['String'];
  /** ノード */
  node: LoginBlacklist;
};

export enum LoginBlacklistField {
  /** 作成日時 */
  CreatedAt = 'CREATED_AT'
}

/** ログイン禁止リストソート条件 */
export type LoginBlacklistOrder = {
  /** ソート順 */
  direction: OrderDirection;
  /** ソート対象フィールド */
  field: LoginBlacklistField;
};

/** ログインの失敗回数に制限がかからない、IPアドレスのホワイトリスト */
export type LoginWhitelist = Node & {
  __typename?: 'LoginWhitelist';
  /** 作成日時 */
  createdAt: Scalars['Time'];
  /** データストアID */
  datastoreId: Scalars['Int'];
  /** オブジェクトID */
  id: Scalars['ID'];
  /** 無制限にログインが許可されている IP アドレス */
  ipAddress: Scalars['IPAddress'];
  /** ホワイトリスト名 */
  name: Scalars['String'];
};

export type LoginWhitelistConnection = Connection & {
  __typename?: 'LoginWhitelistConnection';
  /** エッジ一覧 */
  edges: Array<LoginWhitelistEdge>;
  /** ノード一覧 */
  nodes: Array<LoginWhitelist>;
  /** ページ情報 */
  pageInfo: PageInfo;
  /** 総件数 */
  totalCount: Scalars['Int'];
};

export type LoginWhitelistEdge = Edge & {
  __typename?: 'LoginWhitelistEdge';
  /** カーソル */
  cursor: Scalars['String'];
  /** ノード */
  node: LoginWhitelist;
};

/** マスター・シナリオ */
export type MasterScenario = Node & Scenario & {
  __typename?: 'MasterScenario';
  /** データストアID */
  datastoreId: Scalars['UUID'];
  /** オブジェクトID */
  id: Scalars['ID'];
  /** シナリオ機能使用先PCモニタにおける表示向き */
  monitorOrientation: MonitorOrientation;
  /** シナリオ名 */
  name: Scalars['String'];
  /** 通知リスト */
  notifications?: Maybe<Array<Notification>>;
  /** 使用中の店舗 */
  pcs?: Maybe<Array<Pc>>;
  /** 備考 */
  remark?: Maybe<Scalars['String']>;
  /** 先頭シナリオビューID */
  rootScenarioViewID?: Maybe<Scalars['ID']>;
  /** シナリオビューボタンリスト */
  scenarioViewButtons?: Maybe<Array<ScenarioViewButton>>;
  /** シナリオビューリスト */
  scenarioViews?: Maybe<Array<ScenarioView>>;
};

export type MasterScenarioConnection = Connection & {
  __typename?: 'MasterScenarioConnection';
  /** エッジ一覧 */
  edges: Array<MasterScenarioEdge>;
  /** ノード一覧 */
  nodes: Array<MasterScenario>;
  /** ページ情報 */
  pageInfo: PageInfo;
  /** 総件数 */
  totalCount: Scalars['Int'];
};

export type MasterScenarioEdge = Edge & {
  __typename?: 'MasterScenarioEdge';
  /** カーソル */
  cursor: Scalars['String'];
  /** ノード */
  node: MasterScenario;
};

/** マスター・シナリオビュー */
export type MasterScenarioView = Node & ScenarioView & {
  __typename?: 'MasterScenarioView';
  /** 背景メディア */
  backGroundMedia?: Maybe<BackGroundMedia>;
  /** ボタン配置 */
  buttonsPosition: ButtonsPosition;
  /** ボタン表示時の列数 */
  colsButtonsArrangement: ColsButtonsArrangement;
  /** 作成日時 */
  createdAt: Scalars['Time'];
  /** データストアID */
  datastoreId: Scalars['UUID'];
  /** 固定ボタン一覧 */
  fixedButtons: Array<ScenarioViewFixedButton>;
  /** オブジェクトID */
  id: Scalars['ID'];
  /** タイムアウトを動画と同じ長さにする */
  isAdjustmentVideoPlaytime: Scalars['Boolean'];
  /** シナリオビュー名 */
  name: Scalars['String'];
  /** 動体検知時の遷移先シナリオビュー */
  nextScenarioViewIDOnDetection?: Maybe<Scalars['ID']>;
  /** タイムアウト時の遷移先シナリオビュー */
  nextScenarioViewIDOnTimeout?: Maybe<Scalars['ID']>;
  /** シナリオID */
  scenarioId: Scalars['ID'];
  /** シナリオビューボタン */
  scenarioViewButtons?: Maybe<Array<ScenarioViewButton>>;
  /** タイムアウト時間(秒) */
  timeoutSec?: Maybe<Scalars['Int']>;
};

/** マスター・シナリオビューボタン */
export type MasterScenarioViewButton = Node & ScenarioViewButton & {
  __typename?: 'MasterScenarioViewButton';
  /** シナリオボタン種別 */
  buttonType: ScenarioViewButtonType;
  /** ボタンカラー */
  color: ScenarioViewButtonColor;
  /** データストアID */
  datastoreId: Scalars['UUID'];
  /** ボタン内テキスト */
  displayText: Scalars['String'];
  /** 背景塗り */
  fill: ScenarioViewButtonFill;
  /** オブジェクトID */
  id: Scalars['ID'];
  /**
   * シナリオボタンとしての名前
   * @deprecated displayText に統合されました
   */
  name: Scalars['String'];
  /** 押下時のシナリオビュー */
  nextScenarioViewID?: Maybe<Scalars['ID']>;
  /** ボタン押下時の通知 */
  notification?: Maybe<Notification>;
  /** シナリオビューにおける表示順 */
  priority: Scalars['Int'];
  /**
   * ボタンサイズ
   * @deprecated サイズは固定となりました
   */
  size: ScenarioViewButtonSize;
};

/** シナリオビューコネクション */
export type MasterScenarioViewConnection = Connection & {
  __typename?: 'MasterScenarioViewConnection';
  /** エッジ一覧 */
  edges: Array<MasterScenarioViewEdge>;
  /** ノード一覧 */
  nodes: Array<MasterScenarioView>;
  /** ページ情報 */
  pageInfo: PageInfo;
  /** 総件数 */
  totalCount: Scalars['Int'];
};

/** シナリオビューエッジ */
export type MasterScenarioViewEdge = Edge & {
  __typename?: 'MasterScenarioViewEdge';
  /** カーソル */
  cursor: Scalars['String'];
  /** ノード */
  node: MasterScenarioView;
};

/** メディア・イベント */
export type MediaEvent = Node & {
  __typename?: 'MediaEvent';
  /** データストアID */
  datastoreId: Scalars['UUID'];
  /** イベント種別 */
  eventType: MediaEventType;
  /** オブジェクトID */
  id: Scalars['ID'];
  /** メディア */
  media: MediaEventMedia;
  /** メディア・イベントの所有者 */
  owner: MediaEventOwner;
};

/** メディア・イベントに指定可能なメディア */
export type MediaEventMedia = Image | Video;

/** メディアイベントの所有者 */
export type MediaEventOwner = Pc | Template;

/** メディア・イベントの所有種別 */
export enum MediaEventOwnerType {
  /** PC */
  Pc = 'PC',
  /** テンプレート */
  Template = 'TEMPLATE'
}

/** メディア・イベント種別 */
export enum MediaEventType {
  /** スタッフ不在 */
  Absent = 'ABSENT',
  /** 背景 */
  Back = 'BACK',
  /** ブラー */
  Blur = 'BLUR',
  /** 接客中 */
  DealingWithCustomer = 'DEALING_WITH_CUSTOMER',
  /** 呼び出し */
  Detection = 'DETECTION',
  /** メンテナンス */
  Maintenance = 'MAINTENANCE',
  /** 保留中 */
  OnHold = 'ON_HOLD',
  /** 接客 */
  Reception = 'RECEPTION',
  /** 休憩中 */
  Rest = 'REST',
  /** スクリーンセーバー */
  Screen = 'SCREEN',
  /** 待機中 */
  Wait = 'WAIT'
}

/** メディアのソート条件 */
export type MediaOrder = {
  /** ソート順 */
  direction: OrderDirection;
  /** ソート対象フィールド */
  field: MediaOrderField;
};

/** メディアのソート可能フィールド */
export enum MediaOrderField {
  /** 優先度 */
  Priority = 'PRIORITY'
}

/**
 * メディアの表示位置
 *
 * 縦型モニターにて、メディアをどの位置に表示させるかを表します。
 */
export enum MediaPosition {
  /** 下 */
  Bottom = 'BOTTOM',
  /** メディア不要 */
  None = 'NONE',
  /** 上 */
  Top = 'TOP'
}

/**
 * メディア（画像、動画、スピーチ、サウンド）のアップロード用情報
 *
 * メディアを S3 へアップロードするために必要な情報を表します。
 */
export type MediaUpload = {
  __typename?: 'MediaUpload';
  /**
   * 格納先ファイルパス
   *
   * API に格納先を渡す必要がある場合には、当フィールドの情報を渡すようにしてください。
   */
  src: Scalars['URL'];
  /** アップロード用URL */
  uploadUrl: Scalars['URL'];
};

/** メモ */
export type Memo = Node & {
  __typename?: 'Memo';
  /** データストアID */
  datastoreId: Scalars['UUID'];
  /** 内容 */
  description?: Maybe<Scalars['String']>;
  /** オブジェクトID */
  id: Scalars['ID'];
  /** メモ名 */
  name: Scalars['String'];
  /** メモ所有者 */
  owner: MemoOwner;
  /** 優先度 */
  priority: Scalars['Int'];
  /** 備考 */
  remark?: Maybe<Scalars['String']>;
};

/** メモのソート可能フィールド */
export enum MemoField {
  /** 優先度 */
  Priority = 'PRIORITY'
}

/** メモのソート条件 */
export type MemoOrder = {
  /** ソート順 */
  direction: OrderDirection;
  /** ソート対象フィールド */
  field: MemoField;
};

/** メモ所有者 */
export type MemoOwner = Company | Pc;

/** メモリ情報 */
export type Memory = Node & {
  __typename?: 'Memory';
  /** 作成日時 */
  createdAt: Scalars['Time'];
  /** オブジェクトID */
  id: Scalars['ID'];
  /** キー */
  key: Scalars['String'];
  /** 更新日時 */
  updatedAt: Scalars['Time'];
  /** 値 */
  value: Scalars['String'];
};

export type MemoryConnection = Connection & {
  __typename?: 'MemoryConnection';
  /** エッジ一覧 */
  edges: Array<MemoryEdge>;
  /** ノード一覧 */
  nodes: Array<Memory>;
  /** ページ情報 */
  pageInfo: PageInfo;
  /** 総件数 */
  totalCount: Scalars['Int'];
};

export type MemoryEdge = Edge & {
  __typename?: 'MemoryEdge';
  /** カーソル */
  cursor: Scalars['String'];
  /** ノード */
  node: Memory;
};

export type MemoryOrder = {
  /** ソート順 */
  direction: OrderDirection;
  /** ソート対象フィールド */
  field: MemoryOrderField;
};

/** メモリのソート可能フィールド */
export enum MemoryOrderField {
  /** キー */
  Key = 'KEY'
}

/**
 * シナリオ機能使用先PCモニタにおける表示向き
 *
 * PCモニタ向きを変更する場合、ENUM値の変更と
 * シナリオに紐づく各シナリオの背景メディアを
 * PCモニタの表示に適したものに変更する必要があることに注意してください
 */
export enum MonitorOrientation {
  /** 横 */
  Horizontal = 'HORIZONTAL',
  /** 縦 */
  Vertical = 'VERTICAL'
}

/** アバター用モーション */
export type Motion = Node & {
  __typename?: 'Motion';
  /** データストアID */
  datastoreId: Scalars['String'];
  /** オブジェクトID */
  id: Scalars['ID'];
  playTime?: Maybe<Scalars['Int']>;
  position?: Maybe<Scalars['String']>;
  remark?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['String']>;
  text: Scalars['String'];
  value: Scalars['String'];
};

export enum MotionDetectType {
  /** network_camera */
  NetworkCamera = 'NETWORK_CAMERA',
  /** web_camera */
  WebCamera = 'WEB_CAMERA'
}

/** モーションのソート可能フィールド */
export enum MotionField {
  /** 優先度 */
  Priority = 'PRIORITY'
}

/** モーションのソート条件 */
export type MotionOrder = {
  /** ソート順 */
  direction: OrderDirection;
  /** ソート対象フィールド */
  field: MotionField;
};

export type Mutation = {
  __typename?: 'Mutation';
  /**
   * Eメールアドレス変更受付
   *
   * 対象のuserIdについて、Eメールアドレス変更待ち情報があれば削除し、
   * Eメールアドレス変更用のEmailを変更先アドレスに送信します
   */
  acceptChangeEmail: AcceptChangeEmailResult;
  /** 対象のuserIdについてemailアドレスを検索し、パスワードリセット用のemailを送信します */
  acceptPasswordReset: AcceptPasswordResetResult;
  /** 画像追加 */
  addImage: AddImageResult;
  /** 通信許可IPアドレス 追加 */
  addIngressIPAddress: AddIngressIpAddressResult;
  /** ログインホワイトリスト追加 */
  addLoginWhitelist: AddLoginWhitelistResult;
  /** スピーチ追加 */
  addSpeech: AddSpeechResult;
  /**
   * 動画追加
   *
   * 認証済みユーザーが属するカンパニーに紐づけて動画を登録します。
   */
  addVideo: AddVideoResult;
  /**
   * 店鋪設定一括反映
   *
   * 設定されている店鋪設定を実店舗に反映させます。
   */
  applyPreferencesForPcList: ApplyPreferencesForPcListResult;
  /**
   * PC 分析項目紐付け登録
   *
   * PC に対して分析項目の紐付けを行います。
   */
  attachAnalyticalInfoToPc: AttachAnalyticalInfoToPcResult;
  /**
   * 画像と画像グループの紐付け
   *
   * 単一の画像に紐付け可能な画像グループは1つまでです。
   * 他の画像グループと紐付いている場合、指定された画像グループに付け変わります。
   */
  attachImageGroupToImage: AttachImageGroupToImageResult;
  /**
   * PC 画像紐付け登録
   *
   * PC に対して画像の紐付けを行います。
   */
  attachImageToPc: AttachImageToPcResult;
  /** メディア・イベント紐付け */
  attachMediaEvent: AttachMediaEventResult;
  /** 店舗メディア・イベント登録 */
  attachMediaEventToPc: AttachMediaEventToPcResult;
  /** PC 通知ボタン紐付け登録 */
  attachNotificationToPc: AttachNotificationToPcResult;
  /** 店舗へのシナリオ登録 */
  attachScenarioToPc: AttachScenarioToPcResult;
  /** サウンド紐付け登録 */
  attachSoundToPc: AttachSoundToPcResult;
  /**
   * PC スピーチ紐付け登録
   *
   * PC に対してスピーチの紐付けを行います。
   */
  attachSpeechToPc: AttachSpeechToPcResult;
  /** 通知にユーザーグループとの紐付けを作成する */
  attachUserGroupsToNotification: AttachUserGroupsToNotificationResult;
  /** 動画グループに動画を紐付けます */
  attachVideoGroupToVideo: AttachVideoGroupToVideoResult;
  /**
   * PC 動画紐付け登録
   *
   * PC に対して動画の紐付けを行います。
   */
  attachVideoToPc: AttachVideoToPcResult;
  /** 指定されたパスワードリセットトークンが存在し、有効期限内であれば、パスワード変更処理を実施します。 */
  changePassword: ChangePasswordResult;
  /**
   * シナリオのディープコピー
   *
   * シナリオ名および備考と
   * シナリオに紐づく各々のシナリオビューについて、
   * シナリオビュー名、タイムアウト秒数、タイムアウト時遷移先シナリオビュー、人検知遷移先シナリオビュー、ボタン配置についての設定および
   * シナリオビューに紐付いているシナリオビューボタンについて、同じプロパティで作成します
   */
  copyScenario: CopyScenarioResult;
  /**
   * シナリオビューのディープコピー
   *
   * シナリオビュー名、タイムアウト秒数、ボタン配置についての設定および
   * シナリオビューに紐付いているシナリオビューボタンについて、同じプロパティで作成します
   */
  copyScenarioView: CopyScenarioViewResult;
  /** 分析グラフ設定作成 */
  createAnGraph: CreateAnGraphResult;
  /** 分析情報作成 */
  createAnalyticalInfo: CreateAnalyticalInfoResult;
  /** 分析項目種別作成 */
  createAnalyticalInfoType: CreateAnalyticalInfoTypeResult;
  /** 支店 作成 */
  createBranch: CreateBranchResult;
  /** 支店アカウントの追加 */
  createBranchAccount: CreateBranchAccountResult;
  /** カンパニー作成 */
  createCompany: CreateCompanyResult;
  /** カスタム画面作成 */
  createCustomScreen: CreateCustomScreenResult;
  /** カスタム変数作成 */
  createCustomVariable: CreateCustomVariableResult;
  /** 接客情報作成 */
  createCustomerService: CreateCustomerServiceResult;
  /** 拡張アプリ登録 */
  createExtensionWebApp: CreateExtensionWebAppResult;
  /** Frame(とPCと)を作成します */
  createFrameAndPc: CreateFrameAndPcResult;
  /** FrameTypeを作成します */
  createFrameType: CreateFrameTypeResult;
  /** 画像グループ作成 */
  createImageGroup: CreateImageGroupResult;
  /** メモ作成 */
  createMemo: CreateMemoResult;
  /** メモリ作成 */
  createMemory: CreateMemoryResult;
  /** 通知作成 */
  createNotification: CreateNotificationResult;
  /** PC 作成 */
  createPc: CreatePcResult;
  /** PC 外部連携作成 */
  createPcCooperation: CreatePcCooperationResult;
  /** 仮ユーザーを作成します */
  createPreUser: CreatePreUserResult;
  /** 遠隔操作端末作成 */
  createRemoteController: CreateRemoteControllerResult;
  /** ルーム作成 */
  createRoom: CreateRoomResult;
  /** ルームグループ作成 */
  createRoomGroup: CreateRoomGroupResult;
  /** シナリオ追加 */
  createScenario: CreateScenarioResult;
  /** シナリオビュー作成 */
  createScenarioView: CreateScenarioViewResult;
  /** シナリオビューボタン作成 */
  createScenarioViewButton: CreateScenarioViewButtonResult;
  /** スピーチグループ作成 */
  createSpeechGroup: CreateSpeechGroupResult;
  /** システム通知作成 */
  createSystemNotification: CreateSystemNotificationResult;
  /** システムユーザー作成用 */
  createSystemUser: CreateSystemUserResult;
  /** テンプレート作成 */
  createTemplate: CreateTemplateResult;
  /** ユーザーグループを作成します */
  createUserGroup: CreateUserGroupResult;
  /** 動画グループの作成 */
  createVideoGroup: CreateVideoGroupResult;
  /** PC 外部連携一括削除 */
  deleteAllPcCooperation: DeleteAllPcCooperationResult;
  /** 分析グラフ設定削除 */
  deleteAnGraph: DeleteAnGraphResult;
  /** 分析情報削除 */
  deleteAnalyticalInfo: DeleteAnalyticalInfoResult;
  /** 支店アカウントの削除 */
  deleteBranchAccounts: DeleteBranchAccountsResult;
  /** 支店削除 */
  deleteBranches: DeleteBranchesResult;
  /** カスタム画面削除 */
  deleteCustomScreens: DeleteCustomScreensResult;
  /** カスタム変数削除 */
  deleteCustomVariables: DeleteCustomVariablesResult;
  /** 拡張アプリ削除 */
  deleteExtensionWebApps: DeleteExtensionWebAppsResult;
  /**
   * FrameTypeを削除します
   *
   * カンパニーにおいて、
   * 指定したframeTypeを使用しているFrameが1件でも存在している場合、削除に失敗します
   */
  deleteFrameTypes: DeleteFrameTypesResult;
  /** Frame(とPCと)を削除します */
  deleteFramesAndPcs: DeleteFramesAndPcsResult;
  /** 画像削除 */
  deleteImage: DeleteImageResult;
  /** 画像グループ削除 */
  deleteImageGroup: DeleteImageGroupResult;
  /** 通信許可IPアドレス 削除 */
  deleteIngressIPAddressList: DeleteIngressIpAddressListResult;
  /** ログイン禁止リストからの解除 */
  deleteLoginBlacklists: DeleteLoginBlacklistsResult;
  /** ログインホワイトリスト削除 */
  deleteLoginWhitelists: DeleteLoginWhitelistsResult;
  /** メモ削除 */
  deleteMemo: DeleteMemoResult;
  /** メモリ一括削除 */
  deleteMemories: DeleteMemoriesResult;
  /** 通知削除 */
  deleteNotification: DeleteNotificationResult;
  /** 遠隔操作情報 削除 */
  deleteOperation: DeleteOperationResult;
  /** PC 削除 */
  deletePcs: DeletePcsResult;
  /** 遠隔操作端末一括削除 */
  deleteRemoteControllers: DeleteRemoteControllersResult;
  /**
   * ルームグループ削除
   * @deprecated deleteRoomGroups Mutationを使用してください
   */
  deleteRoomGroup: DeleteRoomGroupResult;
  /** ルームグループ削除 */
  deleteRoomGroups: DeleteRoomGroupsResult;
  /** ルーム削除 */
  deleteRooms: DeleteRoomsResult;
  /** シナリオ削除 */
  deleteScenario: DeleteScenarioResult;
  /**
   * シナリオビュー削除
   *
   * シナリオビューとそれに紐づくボタンの削除を行います
   */
  deleteScenarioView: DeleteScenarioViewResult;
  /** シナリオビューボタン削除 */
  deleteScenarioViewButton: DeleteScenarioViewButtonResult;
  /** スピーチ削除 */
  deleteSpeech: DeleteSpeechResult;
  /** スピーチグループ削除 */
  deleteSpeechGroup: DeleteSpeechGroupResult;
  /** システム通知削除 */
  deleteSystemNotifications: DeleteSystemNotificationsResult;
  /** テンプレート削除 */
  deleteTemplates: DeleteTemplatesResult;
  /** ユーザーグループを削除します */
  deleteUserGroups: DeleteUserGroupsResult;
  /** ユーザーの削除 */
  deleteUsers: DeleteUsersResult;
  /**
   * 動画削除
   *
   * 指定された動画を削除します。
   */
  deleteVideo: DeleteVideoResult;
  /** 動画グループの削除 */
  deleteVideoGroup: DeleteVideoGroupResult;
  /**
   * PC 分析項目紐付け解除
   *
   * PC と分析項目の紐付けを解除します。
   */
  detachAnalyticalInfoFromPc: DetachAnalyticalInfoFromPcResult;
  /**
   * PC 画像紐付け解除
   *
   * PC と画像の紐付けを解除します。
   */
  detachImageFromPc: DetachImageFromPcResult;
  /** 画像と画像グループの紐付け解除 */
  detachImageGroupFromImage: DetachImageGroupFromImageResult;
  /** メディア・イベント解除 */
  detachMediaEvent: DetachMediaEventResult;
  /** 店舗メディア・イベント解除 */
  detachMediaEventFromPc: DetachMediaEventFromPcResult;
  /**
   * PC 通知ボタン紐付け解除
   *
   * PC と通知ボタンの紐付けを解除します
   */
  detachNotificationFromPc: DetachNotificationFromPcResult;
  /** 店舗からのシナリオ登録解除 */
  detachScenarioFromPc: DetachScenarioFromPcResult;
  /** サウンド紐付け解除 */
  detachSoundFromPc: DetachSoundFromPcResult;
  /**
   * PC スピーチ紐付け解除
   *
   * PC とスピーチの紐付けを解除します。
   */
  detachSpeechFromPc: DetachSpeechFromPcResult;
  /** 通知からユーザーグループとの紐付けを解除する */
  detachUserGroupsFromNotification: DetachUserGroupsFromNotificationResult;
  /**
   * PC 動画紐付け解除
   *
   * PC に紐付いている動画との関連を解除します。
   */
  detachVideoFromPc: DetachVideoFromPcResult;
  /** 動画グループとの紐付けを解除します */
  detachVideoGroupFromVideo: DetachVideoGroupFromVideoResult;
  /** 休憩終了 */
  endBreak: EndBreakResult;
  /**
   * 接客評価
   *
   * 指定された接客情報を元に接客の評価を行います。
   */
  evaluateCustomerService: EvaluateCustomerServiceResult;
  /** 勤務終了 */
  finishWorking: FinishWorkingResult;
  noop?: Maybe<NoopPayload>;
  /**
   * お知らせ既読
   *
   * 認証済みユーザーのお知らせを既読状態にします。
   */
  readSystemNotification: ReadSystemNotificationResult;
  /** 店舗ブラウザ再起動 */
  rebootBrowser: RebootBrowserResult;
  /** 店舗再起動 */
  rebootPc: RebootPcResult;
  /** シナリオボタンの順序入れ替え */
  reorderScenarioViewButton: ReOrderScenarioViewButtonsResult;
  /** 通知ボタン押されたときに、Slack Webhookを実行します */
  sendNotification: SendNotificationResult;
  /** リモコンブラウザから遠隔操作情報について送信するためのMutation */
  sendRemoteControllerInfo: SendRemoteControllerInfoResult;
  signin: SigninResult;
  /** 支店アカウントログイン */
  signinAsBranchAccount: SigninAsBranchAccountResult;
  /** タイムリープユーザーのみが認証および認可を許可されます */
  signinAsTimeleap: SigninResult;
  /** ユーザーの作成 */
  signup: SignupResult;
  /** 休憩開始 */
  startBreak: StartBreakResult;
  /** 勤務開始 */
  startWorking: StartWorkingResult;
  /**
   * メディア一括適用
   *
   * コピー元PCと関連を持つメディア情報を取得し、
   * 同じ支店に属する全てのPCに設定を反映させます。
   * コピー先PCがすでにメディアとの関連を持っている場合、
   * その設定を削除してから処理を行います。
   *
   * 以下PCがコピー先PCに含まれる場合それらは無視されます。
   * - コピー元PC同じPCのdatastoreId
   * - コピー元PCと同じ支店に属していないPCのdatastoreId
   */
  syncAssociatedResourcesForPc: SyncAssociatedResourcesForPcResult;
  /** 分析グラフ設定更新 */
  updateAnGraph: UpdateAnGraphResult;
  /** 分析情報更新 */
  updateAnalyticalInfo: UpdateAnalyticalInfoResult;
  /** PC に紐づく分析項目を更新 */
  updateAnalyticalInfoListForPc: UpdateAnalyticalInfoListForPcResult;
  /** 支店 更新 */
  updateBranch: UpdateBranchResult;
  /** 支店アカウントの更新 */
  updateBranchAccount: UpdateBranchAccountResult;
  /** カンパニー更新 */
  updateCompany: UpdateCompanyResult;
  /** カスタム画面更新 */
  updateCustomScreen: UpdateCustomScreenResult;
  /** カスタム変数変更 */
  updateCustomVariable: UpdateCustomVariableResult;
  /** 拡張アプリ更新 */
  updateExtensionWebApp: UpdateExtensionWebAppResult;
  /** Frame（とPC）を更新します */
  updateFrameAndPc: UpdateFrameAndPcResult;
  /** 画像更新 */
  updateImage: UpdateImageResult;
  /** 画像グループ更新 */
  updateImageGroup: UpdateImageGroupResult;
  /** PC に紐づく画像を更新 */
  updateImagesForPc: UpdateImagesForPcResult;
  /** 通信許可IPアドレス 更新 */
  updateIngressIPAddress: UpdateIngressIpAddressResult;
  /** ログインホワイトリスト更新 */
  updateLoginWhitelist: UpdateLoginWhitelistResult;
  /** 自己更新 */
  updateMe: UpdateMeResult;
  /** メモ更新 */
  updateMemo: UpdateMemoResult;
  /** メモリ更新 */
  updateMemory: UpdateMemoryResult;
  /** PC に紐づくメモを更新 */
  updateMemosForPc: UpdateMemosForPcResult;
  /** 通知更新 */
  updateNotification: UpdateNotificationResult;
  /** 遠隔操作情報の更新 */
  updateOperation: UpdateOperationResult;
  /** PC 更新 */
  updatePc: UpdatePcResult;
  /** PC 外部連携更新 */
  updatePcCooperation: UpdatePcCooperationResult;
  /** 支店管理下としたいPCの登録・更新 */
  updatePcsForBranch: UpdatePcsForBranchResult;
  /**
   * プロフィール更新
   *
   * 認証済みユーザーのプロフィール情報を更新します。
   */
  updateProfile: UpdateProfileResult;
  /** 遠隔操作端末更新 */
  updateRemoteController: UpdateRemoteControllerResult;
  /** ルーム更新 */
  updateRoom: UpdateRoomResult;
  /** ルームグループ更新 */
  updateRoomGroup: UpdateRoomGroupResult;
  /** RURA PC Setting更新 */
  updateRuraPcSetting: UpdateRuraPcSettingResult;
  /** シナリオ編集 */
  updateScenario: UpdateScenarioResult;
  /** シナリオビュー編集 */
  updateScenarioView: UpdateScenarioViewResult;
  /** シナリオビューボタン編集 */
  updateScenarioViewButton: UpdateScenarioViewButtonResult;
  /** スピーチ更新 */
  updateSpeech: UpdateSpeechResult;
  /** スピーチグループ更新 */
  updateSpeechGroup: UpdateSpeechGroupResult;
  /** PC に紐づくスピーチを更新 */
  updateSpeechesForPc: UpdateSpeechesForPcResult;
  /** システム通知更新 */
  updateSystemNotification: UpdateSystemNotificationResult;
  /** システムユーザー更新用 */
  updateSystemUser: UpdateSystemUserResult;
  /** テンプレート更新 */
  updateTemplate: UpdateTemplateResult;
  /** ユーザーの更新 */
  updateUser: UpdateUserResult;
  /** ユーザーグループを更新します */
  updateUserGroup: UpdateUserGroupResult;
  /** 動画更新 */
  updateVideo: UpdateVideoResult;
  /** PCに紐づく動画を更新 */
  updateVideosForPc: UpdateVideosForPcResult;
  /** 分析写真アップロード */
  uploadAnPicture: UploadAnPictureResult;
  /**
   * Eメールアドレス変更処理
   *
   * Eメールアドレス変更受付後、トークンを元にユーザープロフィールのEメールアドレスを更新します
   */
  verifyChangeEmail: VerifyChangeEmailResult;
};


export type MutationAcceptChangeEmailArgs = {
  input: AcceptChangeEmailInput;
};


export type MutationAcceptPasswordResetArgs = {
  input: AcceptPasswordResetInput;
};


export type MutationAddImageArgs = {
  input: AddImageInput;
};


export type MutationAddIngressIpAddressArgs = {
  input?: InputMaybe<AddIngressIpAddressInput>;
};


export type MutationAddLoginWhitelistArgs = {
  input: AddLoginWhitelistInput;
};


export type MutationAddSpeechArgs = {
  input: AddSpeechInput;
};


export type MutationAddVideoArgs = {
  input: AddVideoInput;
};


export type MutationApplyPreferencesForPcListArgs = {
  input: ApplyPreferencesForPcListInput;
};


export type MutationAttachAnalyticalInfoToPcArgs = {
  input: AttachAnalyticalInfoToPcInput;
};


export type MutationAttachImageGroupToImageArgs = {
  input: AttachImageGroupToImageInput;
};


export type MutationAttachImageToPcArgs = {
  input: AttachImageToPcInput;
};


export type MutationAttachMediaEventArgs = {
  input: AttachMediaEventInput;
};


export type MutationAttachMediaEventToPcArgs = {
  input: AttachMediaEventToPcInput;
};


export type MutationAttachNotificationToPcArgs = {
  input: AttachNotificationToPcInput;
};


export type MutationAttachScenarioToPcArgs = {
  input: AttachScenarioToPcInput;
};


export type MutationAttachSoundToPcArgs = {
  input: AttachSoundToPcInput;
};


export type MutationAttachSpeechToPcArgs = {
  input: AttachSpeechToPcInput;
};


export type MutationAttachUserGroupsToNotificationArgs = {
  input: AttachUserGroupsToNotificationInput;
};


export type MutationAttachVideoGroupToVideoArgs = {
  input: AttachVideoGroupToVideoInput;
};


export type MutationAttachVideoToPcArgs = {
  input: AttachVideoToPcInput;
};


export type MutationChangePasswordArgs = {
  input: ChangePasswordInput;
};


export type MutationCopyScenarioArgs = {
  input: CopyScenarioInput;
};


export type MutationCopyScenarioViewArgs = {
  input: CopyScenarioViewInput;
};


export type MutationCreateAnGraphArgs = {
  input: CreateAnGraphInput;
};


export type MutationCreateAnalyticalInfoArgs = {
  input: CreateAnalyticalInfoInput;
};


export type MutationCreateAnalyticalInfoTypeArgs = {
  input: CreateAnalyticalInfoTypeInput;
};


export type MutationCreateBranchArgs = {
  input: CreateBranchInput;
};


export type MutationCreateBranchAccountArgs = {
  input: CreateBranchAccountInput;
};


export type MutationCreateCompanyArgs = {
  input: CreateCompanyInput;
};


export type MutationCreateCustomScreenArgs = {
  input: CreateCustomScreenInput;
};


export type MutationCreateCustomVariableArgs = {
  input: CreateCustomVariableInput;
};


export type MutationCreateCustomerServiceArgs = {
  input: CreateCustomerServiceInput;
};


export type MutationCreateExtensionWebAppArgs = {
  input: CreateExtensionWebAppInput;
};


export type MutationCreateFrameAndPcArgs = {
  input: CreateFrameAndPcInput;
};


export type MutationCreateFrameTypeArgs = {
  input: CreateFrameTypeInput;
};


export type MutationCreateImageGroupArgs = {
  input: CreateImageGroupInput;
};


export type MutationCreateMemoArgs = {
  input: CreateMemoInput;
};


export type MutationCreateMemoryArgs = {
  input: CreateMemoryInput;
};


export type MutationCreateNotificationArgs = {
  input: CreateNotificationInput;
};


export type MutationCreatePcArgs = {
  input: CreatePcInput;
};


export type MutationCreatePcCooperationArgs = {
  input: CreatePcCooperationInput;
};


export type MutationCreatePreUserArgs = {
  input: CreatePreUserInput;
};


export type MutationCreateRemoteControllerArgs = {
  input?: InputMaybe<CreateRemoteControllerInput>;
};


export type MutationCreateRoomArgs = {
  input: CreateRoomInput;
};


export type MutationCreateRoomGroupArgs = {
  input: CreateRoomGroupInput;
};


export type MutationCreateScenarioArgs = {
  input: CreateScenarioInput;
};


export type MutationCreateScenarioViewArgs = {
  input: CreateScenarioViewInput;
};


export type MutationCreateScenarioViewButtonArgs = {
  input: CreateScenarioViewButtonInput;
};


export type MutationCreateSpeechGroupArgs = {
  input: CreateSpeechGroupInput;
};


export type MutationCreateSystemNotificationArgs = {
  input: CreateSystemNotificationInput;
};


export type MutationCreateSystemUserArgs = {
  input?: InputMaybe<CreateSystemUserInput>;
};


export type MutationCreateTemplateArgs = {
  input: CreateTemplateInput;
};


export type MutationCreateUserGroupArgs = {
  input: CreateUserGroupInput;
};


export type MutationCreateVideoGroupArgs = {
  input: CreateVideoGroupInput;
};


export type MutationDeleteAllPcCooperationArgs = {
  input: DeleteAllPcCooperationInput;
};


export type MutationDeleteAnGraphArgs = {
  input: DeleteAnGraphInput;
};


export type MutationDeleteAnalyticalInfoArgs = {
  input: DeleteAnalyticalInfoInput;
};


export type MutationDeleteBranchAccountsArgs = {
  input: DeleteBranchAccountsInput;
};


export type MutationDeleteBranchesArgs = {
  input: DeleteBranchesInput;
};


export type MutationDeleteCustomScreensArgs = {
  input: DeleteCustomScreensInput;
};


export type MutationDeleteCustomVariablesArgs = {
  input: DeleteCustomVariablesInput;
};


export type MutationDeleteExtensionWebAppsArgs = {
  input: DeleteExtensionWebAppsInput;
};


export type MutationDeleteFrameTypesArgs = {
  input: DeleteFrameTypesInput;
};


export type MutationDeleteFramesAndPcsArgs = {
  input: DeleteFramesAndPcsInput;
};


export type MutationDeleteImageArgs = {
  input: DeleteImageInput;
};


export type MutationDeleteImageGroupArgs = {
  input: DeleteImageGroupInput;
};


export type MutationDeleteIngressIpAddressListArgs = {
  input?: InputMaybe<DeleteIngressIpAddressListInput>;
};


export type MutationDeleteLoginBlacklistsArgs = {
  input: DeleteLoginBlacklistsInput;
};


export type MutationDeleteLoginWhitelistsArgs = {
  input: DeleteLoginWhitelistsInput;
};


export type MutationDeleteMemoArgs = {
  input: DeleteMemoInput;
};


export type MutationDeleteMemoriesArgs = {
  input: DeleteMemoriesInput;
};


export type MutationDeleteNotificationArgs = {
  input: DeleteNotificationInput;
};


export type MutationDeleteOperationArgs = {
  input: DeleteOperationInput;
};


export type MutationDeletePcsArgs = {
  input: DeletePcsInput;
};


export type MutationDeleteRemoteControllersArgs = {
  input: DeleteRemoteControllersInput;
};


export type MutationDeleteRoomGroupArgs = {
  input: DeleteRoomGroupInput;
};


export type MutationDeleteRoomGroupsArgs = {
  input: DeleteRoomGroupsInput;
};


export type MutationDeleteRoomsArgs = {
  input: DeleteRoomsInput;
};


export type MutationDeleteScenarioArgs = {
  input: DeleteScenarioInput;
};


export type MutationDeleteScenarioViewArgs = {
  input: DeleteScenarioViewInput;
};


export type MutationDeleteScenarioViewButtonArgs = {
  input: DeleteScenarioViewButtonInput;
};


export type MutationDeleteSpeechArgs = {
  input: DeleteSpeechInput;
};


export type MutationDeleteSpeechGroupArgs = {
  input: DeleteSpeechGroupInput;
};


export type MutationDeleteSystemNotificationsArgs = {
  input: DeleteSystemNotificationsInput;
};


export type MutationDeleteTemplatesArgs = {
  input: DeleteTemplatesInput;
};


export type MutationDeleteUserGroupsArgs = {
  input: DeleteUserGroupsInput;
};


export type MutationDeleteUsersArgs = {
  input: DeleteUsersInput;
};


export type MutationDeleteVideoArgs = {
  input: DeleteVideoInput;
};


export type MutationDeleteVideoGroupArgs = {
  input: DeleteVideoGroupInput;
};


export type MutationDetachAnalyticalInfoFromPcArgs = {
  input: DetachAnalyticalInfoFromPcInput;
};


export type MutationDetachImageFromPcArgs = {
  input: DetachImageFromPcInput;
};


export type MutationDetachImageGroupFromImageArgs = {
  input: DetachImageGroupFromImageInput;
};


export type MutationDetachMediaEventArgs = {
  input: DetachMediaEventInput;
};


export type MutationDetachMediaEventFromPcArgs = {
  input: DetachMediaEventFromPcInput;
};


export type MutationDetachNotificationFromPcArgs = {
  input: DetachNotificationFromPcInput;
};


export type MutationDetachScenarioFromPcArgs = {
  input: DetachScenarioFromPcInput;
};


export type MutationDetachSoundFromPcArgs = {
  input: DetachSoundFromPcInput;
};


export type MutationDetachSpeechFromPcArgs = {
  input: DetachSpeechFromPcInput;
};


export type MutationDetachUserGroupsFromNotificationArgs = {
  input: DetachUserGroupsFromNotificationInput;
};


export type MutationDetachVideoFromPcArgs = {
  input: DetachVideoFromPcInput;
};


export type MutationDetachVideoGroupFromVideoArgs = {
  input: DetachVideoGroupFromVideoInput;
};


export type MutationEvaluateCustomerServiceArgs = {
  input: EvaluateCustomerServiceInput;
};


export type MutationNoopArgs = {
  clientMutationId?: InputMaybe<Scalars['String']>;
};


export type MutationRebootBrowserArgs = {
  input: RebootBrowserInput;
};


export type MutationRebootPcArgs = {
  input: RebootPcInput;
};


export type MutationReorderScenarioViewButtonArgs = {
  input: ReOrderScenarioViewButtonsInput;
};


export type MutationSendNotificationArgs = {
  input: SendNotificationInput;
};


export type MutationSendRemoteControllerInfoArgs = {
  input: SendRemoteControllerInfoInput;
};


export type MutationSigninArgs = {
  input: SigninInput;
};


export type MutationSigninAsBranchAccountArgs = {
  input: SigninAsBranchAccountInput;
};


export type MutationSigninAsTimeleapArgs = {
  input: SigninInput;
};


export type MutationSignupArgs = {
  input: SignupInput;
};


export type MutationSyncAssociatedResourcesForPcArgs = {
  input: SyncAssociatedResourcesForPcInput;
};


export type MutationUpdateAnGraphArgs = {
  input: UpdateAnGraphInput;
};


export type MutationUpdateAnalyticalInfoArgs = {
  input: UpdateAnalyticalInfoInput;
};


export type MutationUpdateAnalyticalInfoListForPcArgs = {
  input: UpdateAnalyticalInfoListForPcInput;
};


export type MutationUpdateBranchArgs = {
  input: UpdateBranchInput;
};


export type MutationUpdateBranchAccountArgs = {
  input: UpdateBranchAccountInput;
};


export type MutationUpdateCompanyArgs = {
  input: UpdateCompanyInput;
};


export type MutationUpdateCustomScreenArgs = {
  input: UpdateCustomScreenInput;
};


export type MutationUpdateCustomVariableArgs = {
  input: UpdateCustomVariableInput;
};


export type MutationUpdateExtensionWebAppArgs = {
  input: UpdateExtensionWebAppInput;
};


export type MutationUpdateFrameAndPcArgs = {
  input: UpdateFrameAndPcInput;
};


export type MutationUpdateImageArgs = {
  input: UpdateImageInput;
};


export type MutationUpdateImageGroupArgs = {
  input: UpdateImageGroupInput;
};


export type MutationUpdateImagesForPcArgs = {
  input: UpdateImagesForPcInput;
};


export type MutationUpdateIngressIpAddressArgs = {
  input?: InputMaybe<UpdateIngressIpAddressInput>;
};


export type MutationUpdateLoginWhitelistArgs = {
  input: UpdateLoginWhitelistInput;
};


export type MutationUpdateMeArgs = {
  input: UpdateMeInput;
};


export type MutationUpdateMemoArgs = {
  input: UpdateMemoInput;
};


export type MutationUpdateMemoryArgs = {
  input: UpdateMemoryInput;
};


export type MutationUpdateMemosForPcArgs = {
  input: UpdateMemosForPcInput;
};


export type MutationUpdateNotificationArgs = {
  input: UpdateNotificationInput;
};


export type MutationUpdateOperationArgs = {
  input: UpdateOperationInput;
};


export type MutationUpdatePcArgs = {
  input: UpdatePcInput;
};


export type MutationUpdatePcCooperationArgs = {
  input: UpdatePcCooperationInput;
};


export type MutationUpdatePcsForBranchArgs = {
  input: UpdatePcsForBranchInput;
};


export type MutationUpdateProfileArgs = {
  input: UpdateProfileInput;
};


export type MutationUpdateRemoteControllerArgs = {
  input: UpdateRemoteControllerInput;
};


export type MutationUpdateRoomArgs = {
  input: UpdateRoomInput;
};


export type MutationUpdateRoomGroupArgs = {
  input: UpdateRoomGroupInput;
};


export type MutationUpdateRuraPcSettingArgs = {
  input: UpdateRuraPcSettingInput;
};


export type MutationUpdateScenarioArgs = {
  input: UpdateScenarioInput;
};


export type MutationUpdateScenarioViewArgs = {
  input: UpdateScenarioViewInput;
};


export type MutationUpdateScenarioViewButtonArgs = {
  input: UpdateScenarioViewButtonInput;
};


export type MutationUpdateSpeechArgs = {
  input: UpdateSpeechInput;
};


export type MutationUpdateSpeechGroupArgs = {
  input: UpdateSpeechGroupInput;
};


export type MutationUpdateSpeechesForPcArgs = {
  input: UpdateSpeechesForPcInput;
};


export type MutationUpdateSystemNotificationArgs = {
  input: UpdateSystemNotificationInput;
};


export type MutationUpdateSystemUserArgs = {
  input?: InputMaybe<UpdateSystemUserInput>;
};


export type MutationUpdateTemplateArgs = {
  input: UpdateTemplateInput;
};


export type MutationUpdateUserArgs = {
  input: UpdateUserInput;
};


export type MutationUpdateUserGroupArgs = {
  input: UpdateUserGroupInput;
};


export type MutationUpdateVideoArgs = {
  input: UpdateVideoInput;
};


export type MutationUpdateVideosForPcArgs = {
  input: UpdateVideosForPcInput;
};


export type MutationUploadAnPictureArgs = {
  input: UploadAnPictureInput;
};


export type MutationVerifyChangeEmailArgs = {
  input: VerifyChangeEmailInput;
};

export enum NetWorkCameraTiming {
  /** 1min */
  OneMin = 'ONE_MIN',
  /** 60min */
  SixtyMin = 'SIXTY_MIN',
  /** 10min */
  TenMin = 'TEN_MIN',
  /** 30min */
  ThirtyMin = 'THIRTY_MIN'
}

/** グローバルに一意のIDを持つオブジェクト */
export type Node = {
  /** オブジェクトID */
  id: Scalars['ID'];
};

export type NoopPayload = {
  __typename?: 'NoopPayload';
  clientMutationId?: Maybe<Scalars['String']>;
};

/** 通知 */
export type Notification = Node & {
  __typename?: 'Notification';
  /** 通知種別 */
  buttonType: Scalars['Int'];
  /** カンパニー */
  company: Company;
  /** データストアID */
  datastoreId: Scalars['String'];
  /** オブジェクトID */
  id: Scalars['ID'];
  /** 呼出を行うキーコード文字列 */
  keyText?: Maybe<Scalars['String']>;
  /** 優先度 */
  priority: Scalars['Int'];
  /** 備考 */
  remark?: Maybe<Scalars['String']>;
  /**
   * 通知タイミング
   *
   * 遠隔スタッフに対して通知を許可するタイミングの一覧。
   * 店舗の状態が、この一覧の何れかに該当する場合にのみ通知が行われます。
   */
  timing: Array<MediaEventType>;
  /** 通知先のユーザーグループ一覧 */
  userGroups?: Maybe<Array<UserGroup>>;
  /** 待機画面向けの呼出中表示テキスト */
  value: Scalars['String'];
  /** 通知の表示名 */
  viewData: Scalars['String'];
  /** Web Hooks のテキスト */
  webHookText?: Maybe<Scalars['String']>;
  /** Web Hook の URL */
  webHookUrl?: Maybe<Scalars['URL']>;
};

export type NotificationConnection = Connection & {
  __typename?: 'NotificationConnection';
  /** エッジ一覧 */
  edges: Array<NotificationEdge>;
  /** ノード一覧 */
  nodes: Array<Notification>;
  /** ページ情報 */
  pageInfo: PageInfo;
  /** 総件数 */
  totalCount: Scalars['Int'];
};

export type NotificationEdge = Edge & {
  __typename?: 'NotificationEdge';
  /** カーソル */
  cursor: Scalars['String'];
  /** ノード */
  node: Notification;
};

/** 通知のソート可能フィールド */
export enum NotificationField {
  /** 優先度 */
  Priority = 'PRIORITY'
}

/** 通知のソート条件 */
export type NotificationOrder = {
  /** ソート順 */
  direction: OrderDirection;
  /** ソート対象フィールド */
  field: NotificationField;
};

/**
 * 待機画面での表示位置
 *
 * 待機画面にて、PCをどこに表示させるかを表します。
 */
export enum OnMonitorPosition {
  /** 通常の各PCの配置表示 */
  Main = 'MAIN',
  /** 待機画面のどこにも表示しない */
  None = 'NONE',
  /** サイドバーに表示する */
  Sidebar = 'SIDEBAR'
}

/** 遠隔操作情報 */
export type Operation = Node & {
  __typename?: 'Operation';
  /** RURAブラウザへの命令および状態 */
  browserStatus?: Maybe<BrowserStatus>;
  /** カンパニー */
  company: Company;
  /** データストアID */
  datastoreId: Scalars['Int'];
  /** RURAブラウザ 終了時間(hh:mm) */
  finishTime?: Maybe<Scalars['Time']>;
  /** オブジェクトID */
  id: Scalars['ID'];
  /** ローカルサーバーアクセス時間 */
  localServerRequestTime?: Maybe<Scalars['Time']>;
  /** ローカルサーバー状態 */
  localServerStatus?: Maybe<LocalServerStatus>;
  /** ログ */
  log?: Maybe<Scalars['String']>;
  /** PC */
  pc: Pc;
  /** PCへの命令および状態 */
  pcStatus?: Maybe<PcStatus>;
  /** 備考 */
  remark?: Maybe<Scalars['String']>;
  /** ロボットへの命令および状態 */
  robotStatus?: Maybe<Scalars['String']>;
  /** RURAブラウザ 開始時間(hh:mm) */
  startTime?: Maybe<Scalars['Time']>;
  /** 曜日指定 */
  weekDays: Array<WeekDay>;
};

/** 遠隔操作情報コネクション */
export type OperationConnection = Connection & {
  __typename?: 'OperationConnection';
  /** エッジ一覧 */
  edges: Array<OperationEdge>;
  /** ノード一覧 */
  nodes: Array<Operation>;
  /** ページ情報 */
  pageInfo: PageInfo;
  /** 総件数 */
  totalCount: Scalars['Int'];
};

/** 遠隔操作情報エッジ */
export type OperationEdge = Edge & {
  __typename?: 'OperationEdge';
  /** カーソル */
  cursor: Scalars['String'];
  /** ノード */
  node: Operation;
};

export enum OperationField {
  /** pc_id */
  PcId = 'PC_ID'
}

/** 遠隔操作情報ソート条件 */
export type OperationOrder = {
  /** ソート順 */
  direction: OrderDirection;
  /** ソート対象フィールド */
  field: OperationField;
};

/** Possible directions in which to order a list of items when provided an `orderBy` argument. */
export enum OrderDirection {
  /** Specifies an ascending order for a given `orderBy` argument. */
  Asc = 'ASC',
  /** Specifies a descending order for a given `orderBy` argument. */
  Desc = 'DESC'
}

/** 店舗PC */
export type Pc = Node & {
  __typename?: 'PC';
  /** 分析ボタン一覧 */
  analyticalInfos?: Maybe<Array<AnalyticalInfo>>;
  /** 支店およびPC分析ボタン一覧 */
  analyticalInfosAsUnionWithBranch?: Maybe<Array<AnalyticalInfo>>;
  /** 反映日時 */
  applyAt?: Maybe<Scalars['Time']>;
  /** 店舗反映ステータス */
  applyStatus: PcApplyStatus;
  /** バーコード有無 */
  barcodeFlg?: Maybe<Scalars['Boolean']>;
  /** 支店 */
  branch?: Maybe<Branch>;
  /** カメラリスト */
  cameraList?: Maybe<Array<Scalars['String']>>;
  /** PC を所有するカンパニー */
  company: Company;
  /** 作成日時 */
  createdAt: Scalars['Time'];
  /** 接客開始音 */
  csStartSoundNo?: Maybe<Scalars['Int']>;
  /** データストアID */
  datastoreId: Scalars['String'];
  /** 表示オプション */
  displayOption?: Maybe<DisplayOption>;
  /** 機能トグル一覧 */
  featureToggles: Array<FeatureToggle>;
  /**
   * PCとして振る舞うFrameの実体
   *
   * ReceptionType.PlatformFrame であるときだけ、
   * このframeフィールドが1つのFrameモデルを持ちます
   */
  frame?: Maybe<Frame>;
  /** オブジェクトID */
  id: Scalars['ID'];
  /** 画像一覧 */
  images?: Maybe<Array<Image>>;
  /** 支店およびPC画像一覧 */
  imagesAsUnionWithBranch?: Maybe<Array<Image>>;
  /** IP アドレス */
  ipAddress?: Maybe<Scalars['IPAddress']>;
  /** メディア・イベント一覧 */
  mediaEvents?: Maybe<Array<MediaEvent>>;
  /** 支店およびPCメディア・イベント一覧 */
  mediaEventsAsUnionWithBranch?: Maybe<Array<MediaEvent>>;
  /** メモ一覧 */
  memos?: Maybe<Array<Memo>>;
  /** 支店およびPCメモ一覧 */
  memosAnUnionWithBranch?: Maybe<Array<Memo>>;
  /**
   * マージ済み機能トグル一覧
   *
   * カンパニーの機能トグル設定とマージした結果の機能トグル一覧です。
   */
  mergedFeatureToggles: Array<FeatureToggle>;
  /** モーション一覧 */
  motions?: Maybe<Array<Motion>>;
  /** PC 名 */
  name: Scalars['String'];
  /** 支店およびPC通知一覧 */
  notificationAsUnionWithBranch?: Maybe<Array<Notification>>;
  /** 通知一覧 */
  notifications?: Maybe<Array<Notification>>;
  /** 待機画面での表示位置 */
  onMonitorPosition: OnMonitorPosition;
  /**
   * 遠隔操作情報
   *
   * Frame 店舗の場合は遠隔操作情報は作成されない。
   */
  operation?: Maybe<Operation>;
  /** プラン種別 */
  planType?: Maybe<PlanType>;
  /** 接客種別 */
  receptionType?: Maybe<ReceptionType>;
  /** 店舗に紐づく遠隔操作端末 */
  remoteControllers?: Maybe<Array<RemoteController>>;
  /**
   * 遠隔操作機器の IP アドレス一覧
   *
   * 原則として IPv4 形式の IP アドレスが設定されますが、
   * 遠隔操作機器が Android 端末の場合は "android" という文字列が設定されます。
   */
  remoteIPList?: Maybe<Array<Scalars['String']>>;
  /** PC が属するルーム */
  room?: Maybe<Room>;
  /** PC に紐づいているシナリオ */
  scenario?: Maybe<Scenario>;
  /**
   * PC に紐づいているシナリオ一覧
   * @deprecated PC.scenario を使用してください。
   */
  scenarios?: Maybe<Array<Scenario>>;
  /** RURA PC Setting */
  setting?: Maybe<RuraPcSetting>;
  /** サウンド・イベント一覧 */
  soundEvents?: Maybe<Array<SoundEvent>>;
  /** 支店およびPCサウンド・イベント一覧 */
  soundEventsAsUnionWithBranch?: Maybe<Array<SoundEvent>>;
  /** 音声一覧 */
  speeches?: Maybe<Array<Speech>>;
  /** 支店およびPC音声一覧 */
  speechesAsUnionWithBranch?: Maybe<Array<Speech>>;
  /** 使用中のテンプレート */
  template?: Maybe<Template>;
  /** 更新日時 */
  updatedAt: Scalars['Time'];
  /** 更新者 */
  updatedBy?: Maybe<User>;
  /** 動画一覧 */
  videos?: Maybe<Array<Video>>;
  /** 支店およびPC動画一覧 */
  videosAsUnionWithBranch?: Maybe<Array<Video>>;
  /** 表示名 */
  viewName?: Maybe<Scalars['String']>;
};


/** 店舗PC */
export type PcAnalyticalInfosArgs = {
  orderBy?: InputMaybe<AnalyticalOrder>;
};


/** 店舗PC */
export type PcAnalyticalInfosAsUnionWithBranchArgs = {
  orderBy?: InputMaybe<AnalyticalOrder>;
};


/** 店舗PC */
export type PcImagesArgs = {
  orderBy?: InputMaybe<MediaOrder>;
};


/** 店舗PC */
export type PcImagesAsUnionWithBranchArgs = {
  orderBy?: InputMaybe<MediaOrder>;
};


/** 店舗PC */
export type PcMediaEventsArgs = {
  owners?: InputMaybe<Array<MediaEventOwnerType>>;
  snapshot?: InputMaybe<Scalars['Boolean']>;
};


/** 店舗PC */
export type PcMemosArgs = {
  orderBy?: InputMaybe<MemoOrder>;
};


/** 店舗PC */
export type PcMemosAnUnionWithBranchArgs = {
  orderBy?: InputMaybe<MemoOrder>;
};


/** 店舗PC */
export type PcMotionsArgs = {
  orderBy?: InputMaybe<MotionOrder>;
};


/** 店舗PC */
export type PcNotificationAsUnionWithBranchArgs = {
  orderBy?: InputMaybe<NotificationOrder>;
};


/** 店舗PC */
export type PcNotificationsArgs = {
  orderBy?: InputMaybe<NotificationOrder>;
};


/** 店舗PC */
export type PcScenarioArgs = {
  snapshot?: InputMaybe<Scalars['Boolean']>;
};


/** 店舗PC */
export type PcSpeechesArgs = {
  orderBy?: InputMaybe<MediaOrder>;
};


/** 店舗PC */
export type PcSpeechesAsUnionWithBranchArgs = {
  orderBy?: InputMaybe<MediaOrder>;
};


/** 店舗PC */
export type PcVideosArgs = {
  orderBy?: InputMaybe<MediaOrder>;
};


/** 店舗PC */
export type PcVideosAsUnionWithBranchArgs = {
  orderBy?: InputMaybe<MediaOrder>;
};

/** ページング情報 */
export type PageInfo = {
  __typename?: 'PageInfo';
  /** 終端カーソル */
  endCursor?: Maybe<Scalars['String']>;
  /** 次ページが存在するか */
  hasNextPage: Scalars['Boolean'];
  /** 前ページが存在するか */
  hasPreviousPage: Scalars['Boolean'];
  /** 開始カーソル */
  startCursor?: Maybe<Scalars['String']>;
};

/** 店舗反映ステータス */
export enum PcApplyStatus {
  /** 反映済 */
  Applied = 'APPLIED',
  /** 反映中 */
  Applying = 'APPLYING',
  /** 未反映 */
  NotApplied = 'NOT_APPLIED',
  /** 未設定 */
  NotSet = 'NOT_SET'
}

/** PC コネクション */
export type PcConnection = Connection & {
  __typename?: 'PcConnection';
  /** 店舗反映ステータスごとの店舗数 */
  countByApplyStatus: ShopCountByApplyStatus;
  /** エッジ一覧 */
  edges: Array<PcEdge>;
  /** ノード一覧 */
  nodes: Array<Pc>;
  /** ページ情報 */
  pageInfo: PageInfo;
  /** 総件数 */
  totalCount: Scalars['Int'];
};

/** PC外部連携 */
export type PcCooperation = Node & {
  __typename?: 'PcCooperation';
  /** カンパニー */
  company: Company;
  /** データストアID */
  datastoreId: Scalars['Int'];
  /** オブジェクトID */
  id: Scalars['ID'];
  /** 外部連携名 */
  name: Scalars['String'];
  /** 連携対象PC */
  pc: Pc;
  /** パーミッション */
  permission: PcCooperationPermission;
  /** トークン */
  token: Scalars['UUID'];
};

/** PC 外部連携コネクション */
export type PcCooperationConnection = Connection & {
  __typename?: 'PcCooperationConnection';
  /** エッジ一覧 */
  edges: Array<PcCooperationEdge>;
  /** ノード一覧 */
  nodes: Array<PcCooperation>;
  /** ページ情報 */
  pageInfo: PageInfo;
  /** 総件数 */
  totalCount: Scalars['Int'];
};

/** PC 外部連携エッジ */
export type PcCooperationEdge = Edge & {
  __typename?: 'PcCooperationEdge';
  /** カーソル */
  cursor: Scalars['String'];
  /** ノード */
  node: PcCooperation;
};

/** PC 外部連携ソート条件 */
export type PcCooperationOrder = {
  /** ソート順 */
  direction: OrderDirection;
  /** ソート対象フィールド */
  field: PcCooperationOrderField;
};

/** PC 外部連携のソート可能フィールド */
export enum PcCooperationOrderField {
  /** データストアID */
  DatastoreId = 'DATASTORE_ID'
}

/** PC外部連携パーミッション */
export enum PcCooperationPermission {
  /** 全て */
  All = 'ALL',
  /** 読み取り */
  Read = 'READ',
  /** 書き込み */
  Write = 'WRITE'
}

/** PC エッジ */
export type PcEdge = Edge & {
  __typename?: 'PcEdge';
  /** カーソル */
  cursor: Scalars['String'];
  /** ノード */
  node: Pc;
};

/** PC のソート条件 */
export type PcOrder = {
  /** ソート順 */
  direction: OrderDirection;
  /** ソート対象フィールド */
  field: PcOrderField;
};

/** PC のソート可能フィールド */
export enum PcOrderField {
  /** 作成日時 */
  CreatedAt = 'CREATED_AT'
}

/** PC状態 */
export enum PcStatus {
  /** 命令:再起動する */
  Reboot = 'REBOOT',
  /** 状態:起動中 */
  Starting = 'STARTING',
  /** 状態:停止中 */
  Stopped = 'STOPPED'
}

/** RURA の契約種別 */
export enum PlanType {
  /** RURA Lite */
  Lite = 'LITE',
  /** RURA Standard */
  Standard = 'STANDARD'
}

/** 店舗のプラットフォーム */
export enum Platform {
  /** Android */
  Android = 'ANDROID',
  /** frame */
  Frame = 'FRAME',
  /** PC */
  Pc = 'PC'
}

/** 仮ユーザー */
export type PreUser = Node & {
  __typename?: 'PreUser';
  /** カンパニー */
  company: Company;
  /** 作成日時 */
  createdAt: Scalars['Time'];
  /** データストアID */
  datastoreID: Scalars['UUID'];
  /** オブジェクトID */
  id: Scalars['ID'];
  /** 仮ユーザーのメールアドレス */
  mail: Scalars['Email'];
  /** 備考欄 */
  remark?: Maybe<Scalars['String']>;
  /** ロール */
  role: Role;
  /** ルームグループ */
  roomGroup: RoomGroup;
  /** 仮ユーザーを識別するための認証トークン */
  token: Scalars['String'];
  /** ユーザー種別 */
  userType: UserType;
};

/** 仮ユーザーコネクション */
export type PreUserConnection = Connection & {
  __typename?: 'PreUserConnection';
  /** エッジ一覧 */
  edges: Array<PreUserEdge>;
  /** ノード一覧 */
  nodes: Array<PreUser>;
  /** ページ情報 */
  pageInfo: PageInfo;
  /** 総件数 */
  totalCount: Scalars['Int'];
};

/** 仮ユーザー エッジ */
export type PreUserEdge = Edge & {
  __typename?: 'PreUserEdge';
  /** カーソル */
  cursor: Scalars['String'];
  /** ノード */
  node: PreUser;
};

/** 仮ユーザーのソート条件 */
export type PreUserOrder = {
  /** ソート順 */
  direction: OrderDirection;
  /** ソート対象フィールド */
  field: PreUserOrderField;
};

/** 仮ユーザーのソート可能フィールド */
export enum PreUserOrderField {
  /** 作成日時 */
  CreatedAt = 'CREATED_AT'
}

export type Query = {
  __typename?: 'Query';
  /**
   * 分析グラフ取得
   * 指定された分析グラフIDに紐づくグラフを取得します。
   */
  anGraph: AnGraph;
  /** 分析写真のアップロード情報 */
  anPictureUpload: MediaUpload;
  /** 分析写真一覧取得 */
  anPictures: AnPictureConnection;
  /**
   * 分析グラフ一覧取得
   *
   * 登録されている分析グラフ設定と指定期間の接客情報を元に、分析グラフの一覧を取得します。
   * 店舗が指定されていない場合は、カンパニーに紐づく全店舗が対象となります。
   */
  analysisGraphs: Array<AnalysisGraph>;
  /**
   * 一覧取得
   *
   * 認証済みユーザーが所属するカンパニーの分析項目一覧を取得します。
   */
  analyticalInfoConnection: AnalyticalInfoConnection;
  /** 分析項目種別一覧取得 */
  analyticalInfoTypes: AnalyticalInfoTypeConnection;
  /** アバター一覧取得 */
  avatars: AvatarConnection;
  /**
   * 支店アカウント一覧取得
   *
   * 認証済みユーザーが所属するカンパニーの BranchAccount 一覧を取得します
   * ただし、引数 company が指定されている場合では company に紐づく BranchAccount 一覧を取得します。
   */
  branchAccounts: BranchAccountConnection;
  /**
   * 支店一覧取得
   *
   * 認証済みユーザーが所属するカンパニーの支店一覧を取得します。
   * ただし、引数 company が指定されている場合では company に紐づく支店一覧を取得します。
   */
  branches: BranchConnection;
  /** カンパニー一覧取得 */
  companies: CompanyConnection;
  /**
   * カンパニー取得
   *
   * id または datastoreId のどちらかを指定してください。
   * 両方指定されている場合は id が優先されます。
   */
  company: Company;
  /** カンパニーに関する情報 */
  companyOverview: CompanyOverview;
  customScreens?: Maybe<CustomScreenConnection>;
  /** カスタム変数に対する値の取得 */
  customVariable: CustomVariable;
  /** カスタム変数一覧取得 */
  customVariables: CustomVariableConnection;
  /** 接客情報取得 */
  customerService: CustomerService;
  /**
   * CSV 出力用接客情報一覧取得
   *
   * 指定された期間の接客情報を元に CSV出力用接客情報 として一覧取得します。
   * 返却されるデータは、接客開始日時の昇順でソートされています。
   *
   * なお、返却されるデータ件数が閾値を超える場合はエラーを返しますので、期間を狭めて再取得を試みてください。
   */
  customerServiceForCsvList: Array<CustomerServiceForCsv>;
  /**
   * カンパニー接客情報サマリー一覧取得
   * 認証ユーザーが属するカンパニーのカンパニーIDを元に、カンパニー接客情報サマリーを取得します。
   */
  customerServiceMonthlyOverview: CustomerServiceMonthlyOverview;
  /**
   * 接客情報サマリー取得
   *
   * 指定された期間の接客情報を元に、接客情報サマリーを取得します。
   * 店舗およびユーザーが指定されない場合は、カンパニーに紐づく全ての接客情報が集計対象となります。
   */
  customerServiceSummary: CustomerServiceSummary;
  /** 接客音声アップロードURL取得 */
  customerServiceVoicePutURL: CustomerServiceVoicePutUrl;
  /**
   * 接客情報一覧取得
   *
   * 指定期間の接客情報一覧を取得します。
   */
  customerServices: CustomerServiceConnection;
  /**
   * 日別店舗接客情報一覧取得
   *
   * 指定された期間における接客情報から、日別・店舗別の接客情報一覧を取得します。
   */
  dailyShopCustomerServices: DailyShopCustomerServiceConnection;
  /**
   * 拡張アプリ 一覧取得
   *
   * 認証済みユーザーが所属するカンパニーの ExtensionApp 一覧を取得します
   * ただし、引数 company が指定されている場合は company に紐づく ExtensionApp 一覧を取得します
   */
  extensionApps: ExtensionAppConnection;
  /**
   * Frame 取得
   *
   * 以下のいずれか1つの指定された値に紐づく Frame を取得します
   * - pcId
   * - PCのdatastoreId
   * - FrameのdatastoreId
   * - BranchのdatastoreId とframeType
   */
  frame: Frame;
  /**
   * FrameType一覧取得
   *
   * 認証済みユーザーが所属するカンパニーの FrameType 一覧を取得します。
   * ただし、タイムリープユーザーによる当Queryの実行で、引数 company が指定されている場合は
   * 指定された company に紐づく FrameType 一覧を取得します。
   */
  frameTypes: FrameTypeConnection;
  /**
   * Frame一覧取得
   *
   * 認証済みユーザーが所属するカンパニーの Frame 一覧を取得します。
   * ただし、タイムリープユーザーによる当Queryの実行で、引数 company が指定されている場合は
   * 指定された company に紐づく Frame 一覧を取得します。
   */
  frames: FrameConnection;
  /**
   * 画像グループ一覧取得
   *
   * 認証済みユーザーが所属するカンパニーの画像グループ一覧を取得します。
   */
  imageGroups: ImageGroupConnection;
  /** 画像のアップロード情報 */
  imageUpload: MediaUpload;
  /**
   * 画像一覧取得
   *
   * 認証済みユーザーが所属するカンパニーの画像一覧を取得します。
   */
  images: ImageConnection;
  /** 通信許可IPアドレス 一覧取得 */
  ingressIPAddressList: IngressIpAddressConnection;
  /**
   * ログイン禁止リスト一覧取得
   *
   * ログイン禁止リスト一覧を取得します
   */
  loginBlacklists: LoginBlacklistConnection;
  /** ログインホワイトリスト一覧取得 */
  loginWhitelists: LoginWhitelistConnection;
  /** 認証者自身の情報を取得します。 */
  me: User;
  /** メモリ一覧取得 */
  memories: MemoryConnection;
  node?: Maybe<Node>;
  /** 通知一覧取得 */
  notifications: NotificationConnection;
  /** 指定された遠隔操作情報を取得します。 */
  operation: Operation;
  /**
   * 遠隔操作情報一覧
   *
   * 遠隔操作情報一覧を取得します
   */
  operations: OperationConnection;
  /**
   * PC 取得
   *
   * 指定された id もしくは datastoreId に紐づく PC を取得します。
   * id or datastoreId のどちらかを必ず指定してください。
   */
  pc: Pc;
  /**
   * PC 外部連携一覧取得
   *
   * 全カンパニーのPC外部連携を取得します。
   * 特定カンパニーのPC外部連携を取得する場合は company 引数を指定してください。
   */
  pcCooperationConnection: PcCooperationConnection;
  /**
   * PC 一覧取得
   *
   * 認証済みユーザーが所属するカンパニーの PC 一覧を取得します。
   * ただし、引数 company が指定されている場合は company に紐づく PC 一覧を取得します。
   */
  pcs: PcConnection;
  /** 仮ユーザーの一覧を取得します。 */
  preUsers: PreUserConnection;
  /** プロフィール画像のアップロード情報 */
  profileImageUpload: MediaUpload;
  /** 接客種別一覧取得 */
  receptionTypes: Array<ReceptionType>;
  /** 遠隔操作端末一覧取得 */
  remoteControllers: RemoteControllerConnection;
  /**
   * ルームグループ一覧
   *
   * 認証済みユーザーが所属するカンパニーのルームグループ一覧を取得します。
   * ただし、引数 company が指定されている場合は company に紐づくルームグループ一覧を取得します。
   */
  roomGroups: RoomGroupConnection;
  /**
   * ルーム一覧取得
   *
   * 認証済みユーザーが所属するカンパニーのルーム一覧を取得します。
   * ただし、引数 company が指定されている場合は company に紐づくルーム一覧を取得します。
   */
  rooms: RoomConnection;
  scenario: Scenario;
  /** シナリオビュー一覧取得 */
  scenarioViews: MasterScenarioViewConnection;
  /** シナリオ一覧取得 */
  scenarios: MasterScenarioConnection;
  /**
   * ユーザー接客回数一覧取得
   *
   * 指定期間におけるユーザー別の接客回数一覧を取得します。
   * 店舗が指定されていない場合は、カンパニーに紐づく全店舗の接客情報を対象に集計を行います。
   */
  servedCountByStaffs: Array<ServedCountByStaff>;
  /**
   * 店舗接客情報サマリー一覧取得
   *
   * 指定された期間の接客情報を元に、店舗別の接客情報サマリーの一覧を取得します。
   * ユーザーが指定されない場合は、カンパニーに紐づく全ての接客情報が集計対象となります。
   */
  shopCustomerServiceSummaries: Array<ShopCustomerServiceSummary>;
  /** サウンド一覧取得 */
  sounds: SoundConnection;
  /** スピーチのアップロード情報 */
  speechUpload: MediaUpload;
  /**
   * スピーチ一覧取得
   *
   * 認証済みユーザーが所属するカンパニーの画像一覧を取得します。
   */
  speeches: SpeechConnection;
  /**
   * 遠隔スタッフ分析一覧取得
   *
   * 指定期間における遠隔スタッフ分析の一覧を取得します。
   */
  staffAnalysisList: Array<StaffAnalysis>;
  /** RURA のお知らせを一覧取得します。 */
  systemNotifications: Array<SystemNotification>;
  /** テンプレート取得 */
  template: Template;
  /** テンプレート一覧取得 */
  templates: TemplateConnection;
  /**
   * 指定されたユーザーの情報を取得します。
   *
   * id もしくは userId のどちらかを指定してください。
   */
  user: User;
  /**
   * ユーザーグループ 一覧取得
   *
   * 認証済みユーザーが所属するカンパニーの ユーザーグループ 一覧を取得します。
   * ただし、引数 company が指定されている場合では company に紐づく ユーザーグループ 一覧を取得します。
   */
  userGroups: UserGroupConnection;
  /**
   * ユーザープロフィール一覧取得
   *
   * 自身が所属するカンパニーのユーザーに紐づく、プロフィール情報を一覧取得します。
   * 取得対象となるユーザーの種別は USER です。
   */
  userProfiles: UserProfileConnection;
  /**
   * スタッフ一覧取得
   *
   * 認証済みユーザーが所属するカンパニーの User 一覧を取得します
   * ただし、引数 company が指定されている場合は company に紐づくUser 一覧を取得します。
   */
  users: UserConnection;
  /**
   * 有効なトークンであるか
   *
   * 指定されたトークンが存在 & 有効期限内であれば true、それ以外は false を返します。
   */
  verificationToken: VerificationToken;
  /** 指定されたパスワードリセットトークンが存在し、有効期限内であれば、true、それ以外は false を返します。 */
  verifyPasswordResetToken: Scalars['Boolean'];
  /** トークンの検証を行います */
  verifyPreUser: Scalars['Boolean'];
  /**
   * 動画グループ一覧取得
   *
   * 認証済みユーザーが所属するカンパニーの動画グループ一覧を取得します。
   */
  videoGroups: VideoGroupConnection;
  /** 動画のアップロード情報 */
  videoUpload: MediaUpload;
  /**
   * 動画一覧取得
   *
   * 認証済みユーザーが所属するカンパニーの動画一覧を取得します。
   */
  videos: VideoConnection;
  /**
   * 勤務履歴サマリー
   *
   * 指定期間における勤務履歴のサマリーを取得します。
   * ユーザーが指定されていない場合は、カンパニーに紐づく全ての勤務履歴が集計対象となります。
   */
  workingTimeSummary: WorkingTimeSummary;
};


export type QueryAnGraphArgs = {
  id: Scalars['ID'];
};


export type QueryAnPictureUploadArgs = {
  name: Scalars['String'];
  pcId: Scalars['String'];
};


export type QueryAnPicturesArgs = {
  after?: InputMaybe<Scalars['String']>;
  company?: InputMaybe<Scalars['ID']>;
  first?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<AnPictureOrder>;
};


export type QueryAnalysisGraphsArgs = {
  from: Scalars['Time'];
  pcId?: InputMaybe<Scalars['String']>;
  to: Scalars['Time'];
};


export type QueryAnalyticalInfoConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
};


export type QueryAnalyticalInfoTypesArgs = {
  after?: InputMaybe<Scalars['String']>;
  company?: InputMaybe<Scalars['ID']>;
  first?: InputMaybe<Scalars['Int']>;
};


export type QueryAvatarsArgs = {
  after?: InputMaybe<Scalars['String']>;
  company?: InputMaybe<Scalars['ID']>;
  first?: InputMaybe<Scalars['Int']>;
  includeCommon?: InputMaybe<Scalars['Boolean']>;
};


export type QueryBranchAccountsArgs = {
  after?: InputMaybe<Scalars['String']>;
  company?: InputMaybe<Scalars['ID']>;
  first?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<BranchAccountOrder>;
};


export type QueryBranchesArgs = {
  after?: InputMaybe<Scalars['String']>;
  company?: InputMaybe<Scalars['ID']>;
  first?: InputMaybe<Scalars['Int']>;
};


export type QueryCompaniesArgs = {
  after?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
};


export type QueryCompanyArgs = {
  datastoreId?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['ID']>;
};


export type QueryCustomScreensArgs = {
  after?: InputMaybe<Scalars['String']>;
  company?: InputMaybe<Scalars['ID']>;
  first?: InputMaybe<Scalars['Int']>;
  uniqueIds?: InputMaybe<Array<Scalars['String']>>;
};


export type QueryCustomVariableArgs = {
  company?: InputMaybe<Scalars['ID']>;
  owner: Scalars['ID'];
  variable: Scalars['String'];
};


export type QueryCustomVariablesArgs = {
  after?: InputMaybe<Scalars['String']>;
  company?: InputMaybe<Scalars['ID']>;
  first?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<CustomVariableOrder>;
  owner?: InputMaybe<Scalars['ID']>;
  owners?: InputMaybe<Array<Scalars['ID']>>;
  variables?: InputMaybe<Array<Scalars['String']>>;
};


export type QueryCustomerServiceArgs = {
  id: Scalars['ID'];
};


export type QueryCustomerServiceForCsvListArgs = {
  from: Scalars['Time'];
  to: Scalars['Time'];
  userId?: InputMaybe<Scalars['String']>;
};


export type QueryCustomerServiceSummaryArgs = {
  from: Scalars['Time'];
  pcId?: InputMaybe<Scalars['String']>;
  to: Scalars['Time'];
  userId?: InputMaybe<Scalars['String']>;
};


export type QueryCustomerServiceVoicePutUrlArgs = {
  csid: Scalars['String'];
};


export type QueryCustomerServicesArgs = {
  after?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  from: Scalars['Time'];
  orderBy?: InputMaybe<CustomerServiceOrder>;
  pcIds?: InputMaybe<Array<Scalars['String']>>;
  to: Scalars['Time'];
  userIds?: InputMaybe<Array<Scalars['String']>>;
};


export type QueryDailyShopCustomerServicesArgs = {
  after?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  from: Scalars['Time'];
  to: Scalars['Time'];
};


export type QueryExtensionAppsArgs = {
  after?: InputMaybe<Scalars['String']>;
  company?: InputMaybe<Scalars['ID']>;
  first?: InputMaybe<Scalars['Int']>;
};


export type QueryFrameArgs = {
  branch?: InputMaybe<Scalars['ID']>;
  frame?: InputMaybe<Scalars['ID']>;
  frameType?: InputMaybe<Scalars['String']>;
  owner?: InputMaybe<Scalars['ID']>;
  pc?: InputMaybe<Scalars['ID']>;
  pcId?: InputMaybe<Scalars['String']>;
};


export type QueryFrameTypesArgs = {
  after?: InputMaybe<Scalars['String']>;
  company?: InputMaybe<Scalars['ID']>;
  first?: InputMaybe<Scalars['Int']>;
};


export type QueryFramesArgs = {
  after?: InputMaybe<Scalars['String']>;
  company?: InputMaybe<Scalars['ID']>;
  first?: InputMaybe<Scalars['Int']>;
};


export type QueryImageGroupsArgs = {
  after?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
};


export type QueryImageUploadArgs = {
  extension?: Scalars['String'];
  id?: InputMaybe<Scalars['String']>;
};


export type QueryImagesArgs = {
  after?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
};


export type QueryIngressIpAddressListArgs = {
  after?: InputMaybe<Scalars['String']>;
  company?: InputMaybe<Scalars['ID']>;
  first?: InputMaybe<Scalars['Int']>;
};


export type QueryLoginBlacklistsArgs = {
  after?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<LoginBlacklistOrder>;
};


export type QueryLoginWhitelistsArgs = {
  after?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
};


export type QueryMemoriesArgs = {
  after?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<MemoryOrder>;
};


export type QueryNodeArgs = {
  id: Scalars['ID'];
};


export type QueryNotificationsArgs = {
  after?: InputMaybe<Scalars['String']>;
  company?: InputMaybe<Scalars['ID']>;
  first?: InputMaybe<Scalars['Int']>;
};


export type QueryOperationArgs = {
  id?: InputMaybe<Scalars['ID']>;
  operationId?: InputMaybe<Scalars['Int']>;
  pcDatastoreId?: InputMaybe<Scalars['String']>;
};


export type QueryOperationsArgs = {
  after?: InputMaybe<Scalars['String']>;
  company?: InputMaybe<Scalars['ID']>;
  first?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<OperationOrder>;
};


export type QueryPcArgs = {
  company?: InputMaybe<Scalars['ID']>;
  datastoreId?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['ID']>;
};


export type QueryPcCooperationConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  company?: InputMaybe<Scalars['ID']>;
  first?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<PcCooperationOrder>;
};


export type QueryPcsArgs = {
  after?: InputMaybe<Scalars['String']>;
  applyStatus?: InputMaybe<PcApplyStatus>;
  company?: InputMaybe<Scalars['ID']>;
  first?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<PcOrder>;
};


export type QueryPreUsersArgs = {
  after?: InputMaybe<Scalars['String']>;
  company?: InputMaybe<Scalars['ID']>;
  first?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<PreUserOrder>;
};


export type QueryProfileImageUploadArgs = {
  extension?: Scalars['String'];
};


export type QueryRemoteControllersArgs = {
  after?: InputMaybe<Scalars['String']>;
  company?: InputMaybe<Scalars['ID']>;
  first?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Array<Scalars['ID']>>;
};


export type QueryRoomGroupsArgs = {
  after?: InputMaybe<Scalars['String']>;
  company?: InputMaybe<Scalars['ID']>;
  first?: InputMaybe<Scalars['Int']>;
};


export type QueryRoomsArgs = {
  after?: InputMaybe<Scalars['String']>;
  company?: InputMaybe<Scalars['ID']>;
  first?: InputMaybe<Scalars['Int']>;
};


export type QueryScenarioArgs = {
  id: Scalars['ID'];
};


export type QueryScenarioViewsArgs = {
  after?: InputMaybe<Scalars['String']>;
  company?: InputMaybe<Scalars['ID']>;
  first?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<ScenarioViewOrder>;
  scenario?: InputMaybe<Scalars['ID']>;
};


export type QueryScenariosArgs = {
  after?: InputMaybe<Scalars['String']>;
  company?: InputMaybe<Scalars['ID']>;
  first?: InputMaybe<Scalars['Int']>;
};


export type QueryServedCountByStaffsArgs = {
  first?: InputMaybe<Scalars['Int']>;
  from: Scalars['Time'];
  orderBy?: InputMaybe<ServedCountByStaffOrder>;
  pcId?: InputMaybe<Scalars['String']>;
  to: Scalars['Time'];
};


export type QueryShopCustomerServiceSummariesArgs = {
  from: Scalars['Time'];
  to: Scalars['Time'];
  userId?: InputMaybe<Scalars['String']>;
};


export type QuerySoundsArgs = {
  after?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
};


export type QuerySpeechUploadArgs = {
  extension?: Scalars['String'];
  id?: InputMaybe<Scalars['String']>;
};


export type QuerySpeechesArgs = {
  after?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
};


export type QueryStaffAnalysisListArgs = {
  from: Scalars['Time'];
  to: Scalars['Time'];
};


export type QuerySystemNotificationsArgs = {
  orderBy?: InputMaybe<SystemNotificationOrder>;
};


export type QueryTemplateArgs = {
  datastoreId?: InputMaybe<Scalars['UUID']>;
  id?: InputMaybe<Scalars['ID']>;
};


export type QueryTemplatesArgs = {
  after?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<TemplateOrder>;
};


export type QueryUserArgs = {
  id?: InputMaybe<Scalars['ID']>;
  userId?: InputMaybe<Scalars['String']>;
};


export type QueryUserGroupsArgs = {
  after?: InputMaybe<Scalars['String']>;
  company?: InputMaybe<Scalars['ID']>;
  first?: InputMaybe<Scalars['Int']>;
};


export type QueryUserProfilesArgs = {
  after?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
};


export type QueryUsersArgs = {
  after?: InputMaybe<Scalars['String']>;
  company?: InputMaybe<Scalars['ID']>;
  first?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<UserOrder>;
  types?: InputMaybe<Array<UserType>>;
};


export type QueryVerificationTokenArgs = {
  token: Scalars['String'];
};


export type QueryVerifyPasswordResetTokenArgs = {
  passwordResetToken: Scalars['String'];
};


export type QueryVerifyPreUserArgs = {
  token: Scalars['String'];
};


export type QueryVideoGroupsArgs = {
  after?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
};


export type QueryVideoUploadArgs = {
  extension?: Scalars['String'];
  id?: InputMaybe<Scalars['String']>;
};


export type QueryVideosArgs = {
  after?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
};


export type QueryWorkingTimeSummaryArgs = {
  from: Scalars['Time'];
  to: Scalars['Time'];
  userId?: InputMaybe<Scalars['String']>;
};

export type ReOrderScenarioViewButtonInput = {
  /** シナリオビューボタンの表示順 */
  priority: Scalars['Int'];
  /** シナリオビューボタンID */
  scenarioViewButton: Scalars['ID'];
};

export type ReOrderScenarioViewButtonsFailed = {
  __typename?: 'ReOrderScenarioViewButtonsFailed';
  reason: Scalars['String'];
};

export type ReOrderScenarioViewButtonsInput = {
  /** シナリオビューボタン配置対象シナリオビューID */
  scenarioView: Scalars['ID'];
  /** シナリオビューボタンの順序を持った配列 */
  scenarioViewButtons: Array<ReOrderScenarioViewButtonInput>;
};

export type ReOrderScenarioViewButtonsResult = ReOrderScenarioViewButtonsFailed | ReOrderScenarioViewButtonsSuccess;

export type ReOrderScenarioViewButtonsSuccess = {
  __typename?: 'ReOrderScenarioViewButtonsSuccess';
  scenario: Scenario;
};

export type ReadSystemNotificationResult = ReadSystemNotificationSuccess;

export type ReadSystemNotificationSuccess = {
  __typename?: 'ReadSystemNotificationSuccess';
  user: User;
};

/** 店舗ブラウザ再起動失敗 */
export type RebootBrowserFailed = {
  __typename?: 'RebootBrowserFailed';
  reason: Scalars['String'];
};

/** 店舗ブラウザ再起動インプット */
export type RebootBrowserInput = {
  /** ID */
  id?: InputMaybe<Scalars['ID']>;
  /** PC ID */
  pcId?: InputMaybe<Scalars['String']>;
};

/** 店舗ブラウザ再起動結果 */
export type RebootBrowserResult = RebootBrowserFailed | RebootBrowserSuccess;

/** 店舗ブラウザ再起動成功 */
export type RebootBrowserSuccess = {
  __typename?: 'RebootBrowserSuccess';
  message: Scalars['String'];
};

export type RebootPcFailure = {
  __typename?: 'RebootPcFailure';
  message: Scalars['String'];
};

/**
 * PC 再起動インプット
 *
 * id もしくは pcId のどちらかを指定してください。
 */
export type RebootPcInput = {
  id?: InputMaybe<Scalars['ID']>;
  pcId?: InputMaybe<Scalars['String']>;
};

export type RebootPcResult = RebootPcFailure | RebootPcSuccess;

export type RebootPcSuccess = {
  __typename?: 'RebootPcSuccess';
  message: Scalars['String'];
};

/** 接客種別 */
export type ReceptionType = Node & {
  __typename?: 'ReceptionType';
  /** データストアID */
  datastoreId: Scalars['Int'];
  /** オブジェクトID */
  id: Scalars['ID'];
  /** 顔出しか否か */
  isFace2face: Scalars['Boolean'];
  /** 全画面表示か否か */
  isFullscreen: Scalars['Boolean'];
  /** メディアの表示位置 */
  mediaPosition: MediaPosition;
  /** 接客種別名 */
  name: Scalars['String'];
  /** プラットフォーム */
  platform: Platform;
  /** 接客中および接客終了時に接客情報を送信するか否か */
  skipSendAnalysisInfo: Scalars['Boolean'];
};

export type RemoteController = Node & {
  __typename?: 'RemoteController';
  /** データストアID */
  datastoreId: Scalars['UUID'];
  /** デバイスID */
  deviceId: Scalars['String'];
  /** 動的IP */
  dynamicIpv4?: Maybe<Scalars['IPAddress']>;
  /** オブジェクトID */
  id: Scalars['ID'];
  /** 活性/非活性 */
  isActive: Scalars['Boolean'];
  /** 最終利用可能日時 */
  lastAvailableTime?: Maybe<Scalars['Time']>;
  /** 遠隔操作端末名 */
  name: Scalars['String'];
  /** 導入先店舗 */
  pc?: Maybe<Pc>;
  /** 固定IP */
  staticIpv4?: Maybe<Scalars['IPAddress']>;
  /** 使用可能ステータス */
  status: RemoteControllerStatus;
  /** 遠隔操作端末ブラウザ内でのシステムユーザー */
  systemUser?: Maybe<User>;
  /** バージョン */
  version?: Maybe<Scalars['String']>;
};

/** 遠隔操作端末コネクション */
export type RemoteControllerConnection = Connection & {
  __typename?: 'RemoteControllerConnection';
  /** エッジ一覧 */
  edges: Array<RemoteControllerEdge>;
  /** ノード一覧 */
  nodes: Array<RemoteController>;
  /** ページ情報 */
  pageInfo: PageInfo;
  /** 総件数 */
  totalCount: Scalars['Int'];
};

/** 遠隔操作端末エッジ */
export type RemoteControllerEdge = Edge & {
  __typename?: 'RemoteControllerEdge';
  /** カーソル */
  cursor: Scalars['String'];
  /** ノード */
  node: RemoteController;
};

/** 遠隔操作端末ステータス */
export enum RemoteControllerStatus {
  /** 使用可能 */
  Available = 'AVAILABLE',
  /** 使用不可 */
  OutOfService = 'OUT_OF_SERVICE'
}

/** ロール */
export enum Role {
  /** 管理者 */
  Admin = 'ADMIN',
  /** オーナー */
  Owner = 'OWNER',
  /** サポートユーザー */
  Supporter = 'SUPPORTER',
  /** 一般ユーザー */
  User = 'USER'
}

/**
 * ルーム
 *
 * 店舗をグルーピングするための概念です。
 * 単一の店舗を複数のルームに所属させることはできません。
 *
 * また、ルームを複数のルームグループに所属することはできません。
 */
export type Room = Node & {
  __typename?: 'Room';
  /** ルームが属するカンパニー */
  company: Company;
  /** データストアID */
  datastoreId: Scalars['UUID'];
  /** 連携外部サービス */
  externalServices?: Maybe<Array<ExternalService>>;
  /** オブジェクトID */
  id: Scalars['ID'];
  /**
   * 自由に接客開始可能であるか
   *
   * options に RoomOptionFreeReception.isFree = true を含むかを検証するショートカットです。
   * なお、契約種別が Standard の場合は一律で true となります。
   * options を確認する必要がなければ優先的にこちらを使用してください。
   */
  isFreeReception: Scalars['Boolean'];
  /** ルーム名 */
  name: Scalars['String'];
  /** オプション一覧 */
  options?: Maybe<Array<RoomOption>>;
  /** PC 一覧 */
  pcs?: Maybe<Array<Pc>>;
  /** 契約タイプ */
  planType: PlanType;
  /** 備考 */
  remark?: Maybe<Scalars['String']>;
  /** ルームが属するルームグループ */
  roomGroup?: Maybe<RoomGroup>;
  /** ルームNo */
  roomNo?: Maybe<Scalars['Int']>;
};

/** ルームコネクション */
export type RoomConnection = Connection & {
  __typename?: 'RoomConnection';
  /** エッジ一覧 */
  edges: Array<RoomEdge>;
  /** ノード一覧 */
  nodes: Array<Room>;
  /** ページ情報 */
  pageInfo: PageInfo;
  /** 総件数 */
  totalCount: Scalars['Int'];
};

/** ルームエッジ */
export type RoomEdge = Edge & {
  __typename?: 'RoomEdge';
  /** カーソル */
  cursor: Scalars['String'];
  /** ノード */
  node: Room;
};

/**
 * ルームグループ
 *
 * ルームをグルーピングするための概念です。
 * 単一のルームを、複数のルームグループに所属させることはできません。
 */
export type RoomGroup = Node & {
  __typename?: 'RoomGroup';
  /** ルームグループが属するカンパニー */
  company: Company;
  /** データストアID */
  datastoreId: Scalars['UUID'];
  /** オブジェクトID */
  id: Scalars['ID'];
  /** ルームグループ名 */
  name: Scalars['String'];
  /** 備考 */
  remark?: Maybe<Scalars['String']>;
  /** ルーム一覧 */
  rooms?: Maybe<Array<Room>>;
};

/** ルームグループコネクション */
export type RoomGroupConnection = Connection & {
  __typename?: 'RoomGroupConnection';
  /** エッジ一覧 */
  edges: Array<RoomGroupEdge>;
  /** ノード一覧 */
  nodes: Array<RoomGroup>;
  /** ページ情報 */
  pageInfo: PageInfo;
  /** 総件数 */
  totalCount: Scalars['Int'];
};

/** ルームグループエッジ */
export type RoomGroupEdge = Edge & {
  __typename?: 'RoomGroupEdge';
  /** カーソル */
  cursor: Scalars['String'];
  /** ノード */
  node: RoomGroup;
};

/** ルームオプション */
export type RoomOption = RoomOptionFreeReception;

/** 自由接客ルームオプション */
export type RoomOptionFreeReception = Node & {
  __typename?: 'RoomOptionFreeReception';
  /** データストアID */
  datastoreId: Scalars['Int'];
  /** オブジェクトID */
  id: Scalars['ID'];
  /** 自由接客可能であるか */
  isFree: Scalars['Boolean'];
};

/** RURA PC Setting */
export type RuraPcSetting = Node & {
  __typename?: 'RuraPcSetting';
  /** データストアID */
  datastoreId: Scalars['UUID'];
  /** EMMA接続先情報 */
  emmaHost: Scalars['URL'];
  /** オブジェクトID */
  id: Scalars['ID'];
  /** マイクのスレッド */
  micThresholdMultiple: Scalars['Int'];
  /** カメラのチャンネル */
  motionDetectChannel: Scalars['Int'];
  /** 非認識箇所の設定 */
  motionDetectMasking: Array<Scalars['Int']>;
  /** 認識サイズ */
  motionDetectMaxArea: Scalars['Int'];
  /** 動態検知のカメラ指定 */
  motionDetectSaturationLine: Scalars['Float'];
  /** USBカメラでのモーションディテクト機能 */
  motionDetectThread: Scalars['Boolean'];
  /** 動態検知のカメラタイプ */
  motionDetectType: MotionDetectType;
  /** 動態検知を表示するかの指定 */
  motionDetectViewFlg: Scalars['Boolean'];
  /** ネットワークカメラの定期撮影機能 */
  networkCameraThread: Scalars['Boolean'];
  /** ネットワークカメラのタイミング */
  networkCameraTiming: NetWorkCameraTiming;
  /** ネットワークカメラの画像保存ディレクトリ */
  networkCameraTimingSaveDir: Scalars['String'];
  /** 強制マイクサウンドセット機能 */
  threadForceSetMicAudio: Scalars['Boolean'];
  /** 物理ボタン認識スレッド */
  threadPhysicalButton: Scalars['Boolean'];
  /** 自動ダウンロード */
  updaterDownload: Scalars['Boolean'];
  /** 自動インストール */
  updaterInstall: Scalars['Boolean'];
  /** アップデート開始時刻(hh:mm形式) */
  updaterTime: Scalars['Time'];
};

/** シナリオ */
export type Scenario = {
  /** データストアID */
  datastoreId: Scalars['UUID'];
  /** オブジェクトID */
  id: Scalars['ID'];
  /** シナリオ機能使用先PCモニタにおける表示向き */
  monitorOrientation: MonitorOrientation;
  /** シナリオ名 */
  name: Scalars['String'];
  /** 通知リスト */
  notifications?: Maybe<Array<Notification>>;
  /** 使用中の店舗 */
  pcs?: Maybe<Array<Pc>>;
  /** 備考 */
  remark?: Maybe<Scalars['String']>;
  /** 先頭シナリオビューID */
  rootScenarioViewID?: Maybe<Scalars['ID']>;
  /** シナリオビューボタンリスト */
  scenarioViewButtons?: Maybe<Array<ScenarioViewButton>>;
  /** シナリオビューリスト */
  scenarioViews?: Maybe<Array<ScenarioView>>;
};

/** シナリオビュー */
export type ScenarioView = {
  /** 背景メディア */
  backGroundMedia?: Maybe<BackGroundMedia>;
  /** ボタン配置 */
  buttonsPosition: ButtonsPosition;
  /** ボタン表示時の列数 */
  colsButtonsArrangement: ColsButtonsArrangement;
  /** 作成日時 */
  createdAt: Scalars['Time'];
  /** データストアID */
  datastoreId: Scalars['UUID'];
  /** 固定ボタン一覧 */
  fixedButtons: Array<ScenarioViewFixedButton>;
  /** オブジェクトID */
  id: Scalars['ID'];
  /** タイムアウトを動画と同じ長さにする */
  isAdjustmentVideoPlaytime: Scalars['Boolean'];
  /** シナリオビュー名 */
  name: Scalars['String'];
  /** 人検知時の遷移先シナリオビュー */
  nextScenarioViewIDOnDetection?: Maybe<Scalars['ID']>;
  /** タイムアウト時の遷移先シナリオビュー */
  nextScenarioViewIDOnTimeout?: Maybe<Scalars['ID']>;
  /** シナリオID */
  scenarioId: Scalars['ID'];
  /** シナリオビューボタン */
  scenarioViewButtons?: Maybe<Array<ScenarioViewButton>>;
  /** タイムアウト時間(秒) */
  timeoutSec?: Maybe<Scalars['Int']>;
};

export type ScenarioViewButton = {
  /** シナリオボタン種別 */
  buttonType: ScenarioViewButtonType;
  /** ボタンカラー */
  color: ScenarioViewButtonColor;
  /** データストアID */
  datastoreId: Scalars['UUID'];
  /** ボタン内テキスト */
  displayText: Scalars['String'];
  /** 背景塗り */
  fill: ScenarioViewButtonFill;
  /** オブジェクトID */
  id: Scalars['ID'];
  /**
   * シナリオボタンとしての名前
   * @deprecated displayText に統合されました
   */
  name: Scalars['String'];
  /** 押下時のシナリオビュー */
  nextScenarioViewID?: Maybe<Scalars['ID']>;
  /** ボタン押下時の通知 */
  notification?: Maybe<Notification>;
  /** シナリオビューにおける表示順 */
  priority: Scalars['Int'];
  /**
   * ボタンサイズ
   * @deprecated サイズは固定となりました
   */
  size: ScenarioViewButtonSize;
};

/** シナリオボタンのベースカラー */
export enum ScenarioViewButtonColor {
  /** 黒 */
  Black = 'BLACK',
  /** 青 */
  Blue = 'BLUE',
  /** 緑 */
  Green = 'GREEN',
  /** 赤 */
  Red = 'RED'
}

/** シナリオボタンの背景色 */
export enum ScenarioViewButtonFill {
  /** 背景が白抜き、輪郭線およびボタンのテキストがScenarioViewButtonColorにて指定の色 */
  Outline = 'OUTLINE',
  /** ScenarioViewButtonColor にて指定の色が背景色となり、テキストが白 */
  Solid = 'SOLID'
}

/** シナリオボタンサイズ */
export enum ScenarioViewButtonSize {
  /** 大 */
  Large = 'LARGE',
  /** 中 */
  Medium = 'MEDIUM',
  /** 小 */
  Small = 'SMALL'
}

/** シナリオビューボタン種別 */
export enum ScenarioViewButtonType {
  /** 画面ボタン */
  Normal = 'NORMAL',
  /** 外部連携ボタン */
  PcCooperation = 'PC_COOPERATION',
  /** 物理ボタン */
  Physical = 'PHYSICAL'
}

/** シナリオビュー固定ボタン */
export type ScenarioViewFixedButton = Node & {
  __typename?: 'ScenarioViewFixedButton';
  /** ボタン種別 */
  buttonType: ScenarioViewFixedButtonType;
  /** 色 */
  color: ScenarioViewButtonColor;
  /** データストアID */
  datastoreId: Scalars['UUID'];
  /** 表示名 */
  displayText: Scalars['String'];
  /** 塗りつぶし */
  fill: ScenarioViewButtonFill;
  /** オブジェクトID */
  id: Scalars['ID'];
  /** 遷移先シナリオビューID */
  nextScenarioViewID?: Maybe<Scalars['ID']>;
  /** ボタン押下時の通知 */
  notification?: Maybe<Notification>;
  /** ボタンを表示するか */
  show: Scalars['Boolean'];
};

/** シナリオビュー固定ボタン種別 */
export enum ScenarioViewFixedButtonType {
  /**
   * 戻る
   *
   * 直前に表示していたシナリオビューへ戻るためのボタン種別
   */
  Back = 'BACK',
  /**
   * スタッフ呼び出し
   *
   * スタッフへの通知を行うためのボタン種別
   */
  CallStaff = 'CALL_STAFF',
  /**
   * ホームへ
   *
   * ルートシナリオビューに遷移するためのボタン種別
   */
  GoHome = 'GO_HOME'
}

/** シナリオビューのソート条件 */
export type ScenarioViewOrder = {
  /** ソート順 */
  direction: OrderDirection;
  /** ソート対象フィールド */
  field: ScenarioViewOrderField;
};

/** シナリオビューのソート可能フィールド */
export enum ScenarioViewOrderField {
  /** 作成日時 */
  CreatedAt = 'CREATED_AT',
  /** データストアID */
  DatastoreId = 'DATASTORE_ID'
}

export type SendNotificationFailed = {
  __typename?: 'SendNotificationFailed';
  reason: Scalars['String'];
};

export type SendNotificationInput = {
  notificationId: Scalars['String'];
  pcId: Scalars['String'];
  roomId: Scalars['String'];
};

export type SendNotificationResult = SendNotificationFailed | SendNotificationSuccess;

export type SendNotificationSuccess = {
  __typename?: 'SendNotificationSuccess';
  notification: Notification;
  pc: Pc;
  room: Room;
  sentMessaage: Scalars['String'];
};

export type SendRemoteControllerInfoFailed = {
  __typename?: 'SendRemoteControllerInfoFailed';
  reason: Scalars['String'];
};

/**
 * リモコンブラウザから遠隔操作情報について送信するためのMutation のインプット
 * id または deviceIdのどちらかに値を必ず指定すること
 */
export type SendRemoteControllerInfoInput = {
  /** 遠隔操作端末のデバイスID */
  deviceId?: InputMaybe<Scalars['String']>;
  /** 動的IP */
  dynamicIpv4?: InputMaybe<Scalars['IPAddress']>;
  /** 遠隔操作端末のID */
  id?: InputMaybe<Scalars['ID']>;
  /** 遠隔操作端末ステータス */
  status?: InputMaybe<RemoteControllerStatus>;
  /** バージョン */
  version?: InputMaybe<Scalars['String']>;
};

export type SendRemoteControllerInfoResult = SendRemoteControllerInfoFailed | SendRemoteControllerInfoSuccess;

export type SendRemoteControllerInfoSuccess = {
  __typename?: 'SendRemoteControllerInfoSuccess';
  remoteController: RemoteController;
};

/**
 * ユーザー接客回数
 *
 * 指定期間におけるユーザーの接客回数情報
 */
export type ServedCountByStaff = {
  __typename?: 'ServedCountByStaff';
  /** 接客回数 */
  servedCount: Scalars['Int'];
  /** ユーザー */
  user: User;
};

/** ユーザー接客回数のソート可能フィールド */
export enum ServedCountByStaffField {
  /** 接客回数 */
  ServedCount = 'SERVED_COUNT'
}

/** ユーザー接客回数のソート条件 */
export type ServedCountByStaffOrder = {
  /** ソート順 */
  direction: OrderDirection;
  /** ソート対象フィールド */
  field: ServedCountByStaffField;
};

export type ShopCountByApplyStatus = {
  __typename?: 'ShopCountByApplyStatus';
  applied: Scalars['Int'];
  applying: Scalars['Int'];
  notApplied: Scalars['Int'];
  notSet: Scalars['Int'];
};

/**
 * 店舗接客情報サマリー
 *
 * 指定期間における特定店舗の接客情報のサマリーを表します。
 */
export type ShopCustomerServiceSummary = {
  __typename?: 'ShopCustomerServiceSummary';
  /** 店舗 */
  pc: Pc;
  /** 接客情報サマリー */
  summary: CustomerServiceSummary;
};

export type SigninAsBranchAccountFailed = {
  __typename?: 'SigninAsBranchAccountFailed';
  reason: Scalars['String'];
};

/** ログイン失敗回数が規定を超えたことによる凍結状態 */
export type SigninAsBranchAccountFrozen = {
  __typename?: 'SigninAsBranchAccountFrozen';
  reason: Scalars['String'];
};

/**
 * 支店アカウントログインインプット
 *
 * 固定IPが登録されている支店であれば、branchUniqueIdとcompanyのみの指定でログインか可能です。
 * そうでない場合は、パスワードを与える必要があります。
 */
export type SigninAsBranchAccountInput = {
  /**
   * カンパニー内で支店ごとにユニークなID
   *
   * e.g) 店舗番号
   */
  branchUniqueId: Scalars['String'];
  /** カンパニーID */
  company: Scalars['ID'];
  /** パスワード */
  password?: InputMaybe<Scalars['String']>;
};

/** 制限によってログイン拒否 */
export type SigninAsBranchAccountRejection = {
  __typename?: 'SigninAsBranchAccountRejection';
  reason: Scalars['String'];
};

export type SigninAsBranchAccountResult = SigninAsBranchAccountFailed | SigninAsBranchAccountFrozen | SigninAsBranchAccountRejection | SigninAsBranchAccountSuccess;

export type SigninAsBranchAccountSuccess = {
  __typename?: 'SigninAsBranchAccountSuccess';
  /** ログインに成功した支店アカウントの情報 */
  branchAccount: BranchAccount;
  /** 認証トークン */
  token: Scalars['String'];
};

/** ログイン失敗 */
export type SigninFailed = {
  __typename?: 'SigninFailed';
  message?: Maybe<Scalars['String']>;
};

/** ログイン失敗回数が規定を超えたことによる凍結状態 */
export type SigninFrozen = {
  __typename?: 'SigninFrozen';
  message?: Maybe<Scalars['String']>;
};

export type SigninInput = {
  /** ツールによって生成されたパスワードなども受け付ける必要があるので、@password directive はつけない */
  password: Scalars['String'];
  userId: Scalars['String'];
};

/** 制限によってログイン拒否 */
export type SigninRejection = {
  __typename?: 'SigninRejection';
  message?: Maybe<Scalars['String']>;
};

export type SigninResult = SigninFailed | SigninFrozen | SigninRejection | SigninSuccess;

/** ログイン成功 */
export type SigninSuccess = {
  __typename?: 'SigninSuccess';
  /** 認証したユーザーのロール */
  role: Role;
  /** 認証トークン */
  token: Scalars['String'];
};

export type SignupFailed = {
  __typename?: 'SignupFailed';
  reason?: Maybe<Scalars['String']>;
};

export type SignupInput = {
  /** ユーザー名 */
  name: Scalars['String'];
  /**
   * パスワード
   * - 1文字以上のa-z
   * - 1文字以上のA-Z
   * - 1文字以上の0-9
   * - a-zA-Z0-9の文字で8文字以上20文字以内
   */
  password: Scalars['String'];
  /** プレユーザートークン */
  token: Scalars['String'];
  /** ユーザーID */
  userId: Scalars['String'];
};

export type SignupResult = SignupFailed | SignupSuccess;

export type SignupSuccess = {
  __typename?: 'SignupSuccess';
  user: User;
};

/**
 * スナップショット・シナリオ
 *
 * ある時点における MasterScenario のスナップショットを表します。
 */
export type SnapshotScenario = Node & Scenario & {
  __typename?: 'SnapshotScenario';
  /**
   * データストアID
   *
   * スナップショット取得元となった MasterScenario の datastoreId と同値です。
   */
  datastoreId: Scalars['UUID'];
  /**
   * オブジェクトID
   *
   * スナップショット取得元となった MasterScenario の id と同値です。
   */
  id: Scalars['ID'];
  /** シナリオ機能使用先PCモニタにおける表示向き */
  monitorOrientation: MonitorOrientation;
  /** シナリオ名 */
  name: Scalars['String'];
  /** 通知リスト */
  notifications?: Maybe<Array<Notification>>;
  /** 使用中の店舗 */
  pcs?: Maybe<Array<Pc>>;
  /** 備考 */
  remark?: Maybe<Scalars['String']>;
  /** 先頭シナリオビューID */
  rootScenarioViewID?: Maybe<Scalars['ID']>;
  /** シナリオビューボタンリスト */
  scenarioViewButtons?: Maybe<Array<ScenarioViewButton>>;
  /** シナリオビューリスト */
  scenarioViews?: Maybe<Array<ScenarioView>>;
};

/**
 * スナップショット・シナリオビュー
 *
 * ある時点における MasterScenarioView のスナップショットを表します。
 */
export type SnapshotScenarioView = Node & ScenarioView & {
  __typename?: 'SnapshotScenarioView';
  /** 背景メディア */
  backGroundMedia?: Maybe<BackGroundMedia>;
  /** ボタン配置 */
  buttonsPosition: ButtonsPosition;
  /** ボタン表示時の列数 */
  colsButtonsArrangement: ColsButtonsArrangement;
  /** 作成日時 */
  createdAt: Scalars['Time'];
  /**
   * データストアID
   *
   * スナップショット取得元となった MasterScenario の datastoreId と同値です。
   */
  datastoreId: Scalars['UUID'];
  /** 固定ボタン一覧 */
  fixedButtons: Array<ScenarioViewFixedButton>;
  /**
   * オブジェクトID
   *
   * スナップショットの取得元となった MasterScenarioView の id と同値です。
   */
  id: Scalars['ID'];
  /** タイムアウトを動画と同じ長さにする */
  isAdjustmentVideoPlaytime: Scalars['Boolean'];
  /** シナリオビュー名 */
  name: Scalars['String'];
  /** 動体検知時の遷移先シナリオビュー */
  nextScenarioViewIDOnDetection?: Maybe<Scalars['ID']>;
  /** タイムアウト時の遷移先シナリオビュー */
  nextScenarioViewIDOnTimeout?: Maybe<Scalars['ID']>;
  /** シナリオID */
  scenarioId: Scalars['ID'];
  /** シナリオビューボタン */
  scenarioViewButtons?: Maybe<Array<ScenarioViewButton>>;
  /** タイムアウト時間(秒) */
  timeoutSec?: Maybe<Scalars['Int']>;
};

/**
 * スナップショット・シナリオビューボタン
 *
 * ある時点における MasterScenarioViewButton のスナップショットを表します。
 */
export type SnapshotScenarioViewButton = Node & ScenarioViewButton & {
  __typename?: 'SnapshotScenarioViewButton';
  /** シナリオボタン種別 */
  buttonType: ScenarioViewButtonType;
  /** ボタンカラー */
  color: ScenarioViewButtonColor;
  /**
   * データストアID
   *
   * スナップショット取得元となった MasterScenarioViewButton の datastoreId と同値です。
   */
  datastoreId: Scalars['UUID'];
  /** ボタン内テキスト */
  displayText: Scalars['String'];
  /** 背景塗り */
  fill: ScenarioViewButtonFill;
  /**
   * オブジェクトID
   *
   * スナップショット取得元となった MasterScenarioViewButton の id と同値です。
   */
  id: Scalars['ID'];
  /**
   * シナリオボタンとしての名前
   * @deprecated displayText に統合されました
   */
  name: Scalars['String'];
  /** 押下時のシナリオビュー */
  nextScenarioViewID?: Maybe<Scalars['ID']>;
  /** ボタン押下時の通知 */
  notification?: Maybe<Notification>;
  /** シナリオビューにおける表示順 */
  priority: Scalars['Int'];
  /**
   * ボタンサイズ
   * @deprecated サイズは固定となりました
   */
  size: ScenarioViewButtonSize;
};

/** サウンド */
export type Sound = Node & {
  __typename?: 'Sound';
  /**
   * カンパニー
   *
   * カンパニーが未設定の場合、全カンパニーで共通のサウンドです。
   */
  company?: Maybe<Company>;
  /** データストアID */
  datastoreId: Scalars['UUID'];
  /** オブジェクトID */
  id: Scalars['ID'];
  /** サウンド名 */
  name: Scalars['String'];
  /** 署名付きURL */
  presignedUrl?: Maybe<Scalars['URL']>;
  /** サウンドURL */
  src: Scalars['URL'];
};

/** サウンドコネクション */
export type SoundConnection = Connection & {
  __typename?: 'SoundConnection';
  /** エッジ一覧 */
  edges: Array<SoundEdge>;
  /** ノード一覧 */
  nodes: Array<Sound>;
  /** ページ情報 */
  pageInfo: PageInfo;
  /** 総件数 */
  totalCount: Scalars['Int'];
};

/** サウンドエッジ */
export type SoundEdge = Edge & {
  __typename?: 'SoundEdge';
  /** カーソル */
  cursor: Scalars['String'];
  /** ノード */
  node: Sound;
};

/** サウンド・イベント */
export type SoundEvent = Node & {
  __typename?: 'SoundEvent';
  /** イベント種別 */
  eventType: SoundEventType;
  /** オブジェクトID */
  id: Scalars['ID'];
  /** サウンドイベントの所有者 */
  owner: Pc;
  /**
   * リピート回数
   *
   * null の場合は無限リピートを表します。
   */
  repeat?: Maybe<Scalars['Int']>;
  /** サウンド */
  sound: Sound;
};

/** サウンド・イベント種別 */
export enum SoundEventType {
  /** 物理ボタンによる呼び出し */
  Calling = 'CALLING',
  /** 動体検知 */
  MotionDetection = 'MOTION_DETECTION',
  /** 接客開始 */
  StartReception = 'START_RECEPTION'
}

/** 音声 */
export type Speech = Node & {
  __typename?: 'Speech';
  /** カンパニー */
  company: Company;
  /** データストアID */
  datastoreId: Scalars['String'];
  /** オブジェクトID */
  id: Scalars['ID'];
  /** スピーチ名 */
  name: Scalars['String'];
  /** 再生時間（秒） */
  playTime?: Maybe<Scalars['Int']>;
  /** 署名付きURL */
  presignedUrl?: Maybe<Scalars['URL']>;
  /** 優先度 */
  priority: Scalars['Int'];
  /** 備考 */
  remark?: Maybe<Scalars['String']>;
  /** 所属するスピーチグループ */
  speechGroup?: Maybe<SpeechGroup>;
  /** 音声URL */
  src: Scalars['URL'];
  value: Scalars['String'];
};

export type SpeechConnection = Connection & {
  __typename?: 'SpeechConnection';
  /** エッジ一覧 */
  edges: Array<SpeechEdge>;
  /** ノード一覧 */
  nodes: Array<Speech>;
  /** ページ情報 */
  pageInfo: PageInfo;
  /** 総件数 */
  totalCount: Scalars['Int'];
};

export type SpeechEdge = Edge & {
  __typename?: 'SpeechEdge';
  /** カーソル */
  cursor: Scalars['String'];
  /** ノード */
  node: Speech;
};

/** 音声グループ */
export type SpeechGroup = Node & {
  __typename?: 'SpeechGroup';
  /** データストアID */
  datastoreId: Scalars['String'];
  /** オブジェクトID */
  id: Scalars['ID'];
  /** 音声グループ名 */
  name: Scalars['String'];
  /** 音声グループの所有者 */
  owner: Company;
  /** 優先度 */
  priority: Scalars['Int'];
  /** グループに属する音声一覧 */
  speeches?: Maybe<Array<Speech>>;
};

/**
 * 遠隔スタッフ分析
 *
 * 指定期間におけるスタッフの勤務
 */
export type StaffAnalysis = {
  __typename?: 'StaffAnalysis';
  /** 休憩秒数 */
  restSeconds: Scalars['Int'];
  /** 接客回数 */
  servedCount: Scalars['Int'];
  /** 接客秒数 */
  servedSeconds: Scalars['Int'];
  /** ユーザー */
  user: User;
  /** 勤務回数 */
  workedCount: Scalars['Int'];
  /** 勤務秒数 */
  workedSeconds: Scalars['Int'];
};

export type StartBreakFailed = {
  __typename?: 'StartBreakFailed';
  reason?: Maybe<Scalars['String']>;
};

export type StartBreakResult = StartBreakFailed | StartBreakSuccess;

export type StartBreakSuccess = {
  __typename?: 'StartBreakSuccess';
  startTime: Scalars['Time'];
};

export type StartWorkingFailed = {
  __typename?: 'StartWorkingFailed';
  reason?: Maybe<Scalars['String']>;
};

export type StartWorkingResult = StartWorkingFailed | StartWorkingSuccess;

export type StartWorkingSuccess = {
  __typename?: 'StartWorkingSuccess';
  startTime: Scalars['Time'];
};

export type SyncAssociatedResourcesForPcFailed = {
  __typename?: 'SyncAssociatedResourcesForPcFailed';
  reason: Scalars['String'];
};

export type SyncAssociatedResourcesForPcInput = {
  /** コピー元PC */
  base: Scalars['ID'];
  /** コピー先PC */
  targets: Array<Scalars['ID']>;
};

export type SyncAssociatedResourcesForPcResult = SyncAssociatedResourcesForPcFailed | SyncAssociatedResourcesForPcSuccess;

export type SyncAssociatedResourcesForPcSuccess = {
  __typename?: 'SyncAssociatedResourcesForPcSuccess';
  /** コピー元PC */
  basePc: Pc;
  /** 反映先PC の ID 一覧 */
  targetIds: Array<Scalars['ID']>;
};

/** お知らせ */
export type SystemNotification = Node & {
  __typename?: 'SystemNotification';
  /** データストアID */
  datastoreId: Scalars['String'];
  /** 詳細 */
  detail?: Maybe<Scalars['String']>;
  /** オブジェクトID */
  id: Scalars['ID'];
  /** 通知日時 */
  notificationAt: Scalars['Time'];
  /** タイトル */
  title: Scalars['String'];
  /** 外部リンク */
  url?: Maybe<Scalars['URL']>;
};

export enum SystemNotificationField {
  /** 通知日時 */
  NotificationAt = 'NOTIFICATION_AT'
}

/** お知らせソート条件 */
export type SystemNotificationOrder = {
  /** ソート順 */
  direction: OrderDirection;
  /** ソート対象フィールド */
  field: SystemNotificationField;
};

/** テンプレート */
export type Template = Node & {
  __typename?: 'Template';
  /** 作成日時 */
  createdAt: Scalars['Time'];
  /** データストアID */
  datastoreId: Scalars['UUID'];
  /** 画面サイズ_高さ */
  displaySizeHeight: Scalars['Int'];
  /** 画面サイズ_幅 */
  displaySizeWidth: Scalars['Int'];
  /** オブジェクトID */
  id: Scalars['ID'];
  /** メディアイベント一覧 */
  mediaEvents: Array<MediaEvent>;
  /** テンプレート名 */
  name: Scalars['String'];
  /** 使用中店舗 */
  pcs: Array<Pc>;
  /** 備考 */
  remark?: Maybe<Scalars['String']>;
  /** ステータス */
  status: TemplateStatus;
  /** 更新日時 */
  updatedAt: Scalars['Time'];
  /** 更新者 */
  updatedBy?: Maybe<User>;
};

/** テンプレートコンクション */
export type TemplateConnection = Connection & {
  __typename?: 'TemplateConnection';
  /** エッジ一覧 */
  edges: Array<TemplateEdge>;
  /** ノード一覧 */
  nodes: Array<Template>;
  /** ページ情報 */
  pageInfo: PageInfo;
  /** 総件数 */
  totalCount: Scalars['Int'];
};

/** テンプレートエッジ */
export type TemplateEdge = Edge & {
  __typename?: 'TemplateEdge';
  /** カーソル */
  cursor: Scalars['String'];
  /** ノード */
  node: Template;
};

/** テンプレートのソート条件 */
export type TemplateOrder = {
  /** ソート順 */
  direction: OrderDirection;
  /** ソート対象フィールド */
  field: TemplateOrderField;
};

/** テンプレートのソート可能フィールド */
export enum TemplateOrderField {
  /** 作成日時 */
  CreatedAt = 'CREATED_AT'
}

/**
 * テンプレートステータス
 *
 * テンプレートのステータスを表す
 */
export enum TemplateStatus {
  /** 未使用 */
  NotUse = 'NOT_USE',
  /** 使用中 */
  Use = 'USE'
}

/** 分析グラフ設定更新結果 */
export type UpdateAnGraphFailed = {
  __typename?: 'UpdateAnGraphFailed';
  /** 失敗結果 */
  reason: Scalars['String'];
};

/** 分析グラフ設定更新インプット */
export type UpdateAnGraphInput = {
  /** 分析項目一覧 */
  analyticalInfoList?: InputMaybe<Array<Scalars['ID']>>;
  /** 分析項目種別 */
  analyticalInfoType?: InputMaybe<Scalars['ID']>;
  /** 分析グラフ設定ID */
  id: Scalars['ID'];
  /** グラフ種別 */
  type?: InputMaybe<AnGraphType>;
};

/** 分析グラフ設定更新結果 */
export type UpdateAnGraphResult = UpdateAnGraphFailed | UpdateAnGraphSuccess;

/** 分析グラフ設定更新結果 */
export type UpdateAnGraphSuccess = {
  __typename?: 'UpdateAnGraphSuccess';
  /** 分析グラフ設定 */
  anGraph: AnGraph;
};

export type UpdateAnalyticalInfoFailed = {
  __typename?: 'UpdateAnalyticalInfoFailed';
  reason: Scalars['String'];
};

export type UpdateAnalyticalInfoForPc = {
  /** 分析項目ID */
  id: Scalars['ID'];
  /** 優先度 */
  priority?: InputMaybe<Scalars['Int']>;
};

export type UpdateAnalyticalInfoInput = {
  /** 分析項目種別 */
  analyticalInfoType?: InputMaybe<Scalars['ID']>;
  /** 分析種別 */
  analyticalType?: InputMaybe<AnalyticalType>;
  /** アイコン名 */
  icon?: InputMaybe<Scalars['String']>;
  /** 更新対象分析情報ID */
  id: Scalars['ID'];
  /** 分析項目名 */
  name?: InputMaybe<Scalars['String']>;
  /** 備考 */
  remark?: InputMaybe<Scalars['String']>;
  /** 分析タイミング */
  timing?: InputMaybe<AnalyticalTiming>;
  /** 分析項目値 */
  value?: InputMaybe<Scalars['String']>;
};

export type UpdateAnalyticalInfoListForPcFailed = {
  __typename?: 'UpdateAnalyticalInfoListForPcFailed';
  reason: Scalars['String'];
};

export type UpdateAnalyticalInfoListForPcInput = {
  list: Array<UpdateAnalyticalInfoForPc>;
  pc: Scalars['ID'];
};

export type UpdateAnalyticalInfoListForPcResult = UpdateAnalyticalInfoListForPcFailed | UpdateAnalyticalInfoListForPcSuccess;

export type UpdateAnalyticalInfoListForPcSuccess = {
  __typename?: 'UpdateAnalyticalInfoListForPcSuccess';
  pc: Pc;
};

export type UpdateAnalyticalInfoResult = UpdateAnalyticalInfoFailed | UpdateAnalyticalInfoSuccess;

export type UpdateAnalyticalInfoSuccess = {
  __typename?: 'UpdateAnalyticalInfoSuccess';
  analyticalInfo: AnalyticalInfo;
};

export type UpdateBranchAccountFailed = {
  __typename?: 'UpdateBranchAccountFailed';
  reason: Scalars['String'];
};

export type UpdateBranchAccountInput = {
  /**
   * 原則として認証ユーザーが属するカンパニーの支店アカウントを更新可能ですが、
   * 当引数で指定されたカンパニーの支店アカウントを更新対象とします。
   */
  company?: InputMaybe<Scalars['ID']>;
  /** 支店アカウントID */
  id: Scalars['ID'];
  /**
   * お客様のLANのIPアドレス一覧
   *
   * 未指定の場合は、既存のIPアドレスを維持します。
   * 空配列が指定された場合、明示的な破棄と見做します。
   */
  ipAddresses?: InputMaybe<Array<Scalars['IPAddress']>>;
  /** 支店アカウント名 */
  name?: InputMaybe<Scalars['String']>;
  /** パスワード */
  password?: InputMaybe<Scalars['String']>;
  /** 備考 */
  remark?: InputMaybe<Scalars['String']>;
};

export type UpdateBranchAccountResult = UpdateBranchAccountFailed | UpdateBranchAccountSuccess;

export type UpdateBranchAccountSuccess = {
  __typename?: 'UpdateBranchAccountSuccess';
  branchAccount: BranchAccount;
};

export type UpdateBranchFailed = {
  __typename?: 'UpdateBranchFailed';
  reason: Scalars['String'];
};

export type UpdateBranchInput = {
  /** 住所 */
  address?: InputMaybe<Scalars['Address']>;
  /** 対象の支店 */
  branch: Scalars['ID'];
  /**
   * 支店が属するカンパニー
   *
   * 原則として認証ユーザーが属するカンパニーの支店のみを更新可能ですが、
   * 当引数で指定されたカンパニーの支店を更新対象とします。
   */
  company?: InputMaybe<Scalars['ID']>;
  /** 支店名 */
  name?: InputMaybe<Scalars['String']>;
  /** 郵便番号 */
  postalCode?: InputMaybe<Scalars['PostalCode']>;
  /** 電話番号 */
  tel?: InputMaybe<Scalars['String']>;
};

export type UpdateBranchResult = UpdateBranchFailed | UpdateBranchSuccess;

export type UpdateBranchSuccess = {
  __typename?: 'UpdateBranchSuccess';
  branch: Branch;
};

export type UpdateCompanyFailed = {
  __typename?: 'UpdateCompanyFailed';
  /** 失敗理由 */
  reason: Scalars['String'];
};

export type UpdateCompanyInput = {
  /**
   * 機能トグル一覧
   *
   * 設定の ON/OFF を制御したい機能を一覧で指定してください。
   * 未指定の機能は無視されます。
   */
  featureToggles?: InputMaybe<Array<FeatureToggleInput>>;
  /** カンパニーのID */
  id: Scalars['ID'];
  /**
   * IP アドレスの制限がかかっているか
   *
   * true の場合、特定 IP からのリクエストしか許可しません。
   */
  isIPRestraint?: InputMaybe<Scalars['Boolean']>;
  /** カンパニー名 */
  name?: InputMaybe<Scalars['String']>;
  /**
   * レコードフラグ
   * @deprecated featureToggles で指定してください
   */
  recordFlg?: InputMaybe<Scalars['Boolean']>;
};

export type UpdateCompanyResult = UpdateCompanyFailed | UpdateCompanySuccess;

export type UpdateCompanySuccess = {
  __typename?: 'UpdateCompanySuccess';
  /** カンパニー */
  company: Company;
};

export type UpdateCustomScreenFailed = {
  __typename?: 'UpdateCustomScreenFailed';
  reason: Scalars['String'];
};

export type UpdateCustomScreenInput = {
  /**
   * 更新対象カスタムスクリーン所属カンパニー
   *
   * 原則として認証ユーザーが属するカンパニーのカスタム画面のみ操作可能ですが、
   * 当引数で指定されたカンパニーのカスタム画面を操作対象とします。
   */
  company?: InputMaybe<Scalars['ID']>;
  /** 更新対象カスタムスクリーンID */
  id: Scalars['ID'];
  /** カスタムスクリーン名 */
  name?: InputMaybe<Scalars['String']>;
  /** カンパニー内で一意となる、任意の画面識別子 */
  uniqueId?: InputMaybe<Scalars['String']>;
};

export type UpdateCustomScreenResult = UpdateCustomScreenFailed | UpdateCustomScreenSuccess;

export type UpdateCustomScreenSuccess = {
  __typename?: 'UpdateCustomScreenSuccess';
  customScreen: CustomScreen;
};

/** カスタム変数更新失敗 */
export type UpdateCustomVariableFailed = {
  __typename?: 'UpdateCustomVariableFailed';
  /** 結果 */
  reason: Scalars['String'];
};

/** カスタム変数更新インプット */
export type UpdateCustomVariableInput = {
  /**
   * 更新対象カンパニーID
   *
   * 原則として認証ユーザーが属するカンパニーのカスタム変数のみ変更可能ですが、
   * 当引数で指定されたカンパニーのカスタム変数を変更対象とします。
   */
  company?: InputMaybe<Scalars['ID']>;
  /** カスタム変数ID */
  id: Scalars['ID'];
  /** 所有者 */
  owner?: InputMaybe<Scalars['ID']>;
  /** 値 */
  value?: InputMaybe<Scalars['String']>;
  /** 変数名 */
  variable?: InputMaybe<Scalars['String']>;
};

/** カスタム変数更新結果 */
export type UpdateCustomVariableResult = UpdateCustomVariableFailed | UpdateCustomVariableSuccess;

/** カスタム変数更新成功 */
export type UpdateCustomVariableSuccess = {
  __typename?: 'UpdateCustomVariableSuccess';
  /** 変更後カスタム変数 */
  customVariable: CustomVariable;
};

export type UpdateExtensionWebAppFailed = {
  __typename?: 'UpdateExtensionWebAppFailed';
  reason: Scalars['String'];
};

export type UpdateExtensionWebAppInput = {
  /**
   * 有効な拡張アプリであるか
   *
   * 有効な拡張アプリは RURA の接客画面で表示対象となります。
   */
  active?: InputMaybe<Scalars['Boolean']>;
  /**
   * 表示名
   *
   * RURA接客画面におけるタブなどで使用
   */
  displayName?: InputMaybe<Scalars['String']>;
  /** 更新対象拡張アプリ */
  id: Scalars['ID'];
  /** 拡張アプリ名 */
  name?: InputMaybe<Scalars['String']>;
  /** iframeのsrc属性に指定するURL */
  url?: InputMaybe<Scalars['URL']>;
};

export type UpdateExtensionWebAppResult = UpdateExtensionWebAppFailed | UpdateExtensionWebAppSuccess;

export type UpdateExtensionWebAppSuccess = {
  __typename?: 'UpdateExtensionWebAppSuccess';
  extensionApp: ExtensionApp;
};

export type UpdateFrameAndPcFailed = {
  __typename?: 'UpdateFrameAndPcFailed';
  reason: Scalars['String'];
};

/** フレーム更新に付随する、PC の情報更新用インプット */
export type UpdateFrameAndPcForPcInput = {
  /** Frameとして識別するための名称 */
  name?: InputMaybe<Scalars['String']>;
};

export type UpdateFrameAndPcInput = {
  /**
   * 更新対象Frameの所属カンパニー
   * 原則として認証ユーザーが属するカンパニーの Frame のみアクセス可能ですが、
   * 当引数で指定されたカンパニーの Frame を更新対象とします。
   */
  company?: InputMaybe<Scalars['ID']>;
  /** 更新対象 */
  id: Scalars['ID'];
  /** 一度接客したらWebRTCを切断するかどうか */
  onceReception?: InputMaybe<Scalars['Boolean']>;
  /** Frameに紐づくPC更新時インプット */
  pc: UpdateFrameAndPcForPcInput;
  /** Frameを使用する環境 */
  platform?: InputMaybe<FramePlatform>;
  /**
   * 起動時の通知先
   *
   * nullが指定された場合: 未設定へ変更
   * 設定を変更したくない場合、同じIDを指定すること
   */
  startNotice?: InputMaybe<Scalars['ID']>;
  /** メディア使用フラグ */
  useMedia?: InputMaybe<Scalars['Boolean']>;
  /**
   * スタッフ映像取得フラグ
   * 店舗側が自身の映像を送るかどうか
   */
  useVideo?: InputMaybe<Scalars['Boolean']>;
  /**
   * メディア表示フラグ
   * 店舗側でスタッフのカメラ映像を表示させるかどうか
   */
  viewStaffVideo?: InputMaybe<Scalars['Boolean']>;
};

/** フレーム（とPC）更新結果 */
export type UpdateFrameAndPcResult = UpdateFrameAndPcFailed | UpdateFrameAndPcSuccess;

export type UpdateFrameAndPcSuccess = {
  __typename?: 'UpdateFrameAndPcSuccess';
  frame: Frame;
};

export type UpdateImageFailed = {
  __typename?: 'UpdateImageFailed';
  reason: Scalars['String'];
};

export type UpdateImageForPcInput = {
  id: Scalars['ID'];
  priority?: InputMaybe<Scalars['Int']>;
};

export type UpdateImageGroupFailed = {
  __typename?: 'UpdateImageGroupFailed';
  reason?: Maybe<Scalars['String']>;
};

export type UpdateImageGroupInput = {
  id: Scalars['ID'];
  /** グループ名 */
  name?: InputMaybe<Scalars['String']>;
  /** 優先度 */
  priority?: InputMaybe<Scalars['Int']>;
};

export type UpdateImageGroupResult = UpdateImageGroupFailed | UpdateImageGroupSuccess;

export type UpdateImageGroupSuccess = {
  __typename?: 'UpdateImageGroupSuccess';
  imageGroup: ImageGroup;
};

export type UpdateImageInput = {
  /** 更新対象画像 */
  id: Scalars['ID'];
  /** 画像名 */
  name?: InputMaybe<Scalars['String']>;
};

export type UpdateImageResult = UpdateImageFailed | UpdateImageSuccess;

export type UpdateImageSuccess = {
  __typename?: 'UpdateImageSuccess';
  image: Image;
};

export type UpdateImagesForPcFailed = {
  __typename?: 'UpdateImagesForPcFailed';
  reason: Scalars['String'];
};

export type UpdateImagesForPcInput = {
  images: Array<UpdateImageForPcInput>;
  pc: Scalars['ID'];
};

export type UpdateImagesForPcResult = UpdateImagesForPcFailed | UpdateImagesForPcSuccess;

export type UpdateImagesForPcSuccess = {
  __typename?: 'UpdateImagesForPcSuccess';
  pc: Pc;
};

export type UpdateIngressIpAddressFailed = {
  __typename?: 'UpdateIngressIPAddressFailed';
  reason: Scalars['String'];
};

export type UpdateIngressIpAddressInput = {
  /** 通信許可IPアドレスID */
  id: Scalars['ID'];
  /** IP アドレス */
  ipAddress?: InputMaybe<Scalars['IPAddress']>;
  /** 通信許可IPアドレス設定名 */
  name?: InputMaybe<Scalars['String']>;
};

export type UpdateIngressIpAddressResult = UpdateIngressIpAddressFailed | UpdateIngressIpAddressSuccess;

export type UpdateIngressIpAddressSuccess = {
  __typename?: 'UpdateIngressIPAddressSuccess';
  ingressIPAddress: IngressIpAddress;
};

export type UpdateLoginWhitelistFailed = {
  __typename?: 'UpdateLoginWhitelistFailed';
  reason: Scalars['String'];
};

export type UpdateLoginWhitelistInput = {
  /** ログインホワイトリストID */
  id: Scalars['ID'];
  /** 無制限にログインが許可されている IP アドレス */
  ipAddress?: InputMaybe<Scalars['IPAddress']>;
  /** ログインホワイトリスト名 */
  name?: InputMaybe<Scalars['String']>;
};

export type UpdateLoginWhitelistResult = UpdateLoginWhitelistFailed | UpdateLoginWhitelistSuccess;

export type UpdateLoginWhitelistSuccess = {
  __typename?: 'UpdateLoginWhitelistSuccess';
  /** 更新後ログインホワイトリスト */
  loginWhitelist: LoginWhitelist;
};

/** 自己更新失敗 */
export type UpdateMeFailed = {
  __typename?: 'UpdateMeFailed';
  /** 失敗理由 */
  reason?: Maybe<Scalars['String']>;
};

/** 自己更新インプット */
export type UpdateMeInput = {
  /** ユーザー名 */
  name?: InputMaybe<Scalars['String']>;
};

/** 自己更新結果 */
export type UpdateMeResult = UpdateMeFailed | UpdateMeSuccess;

/** 自己更新成功 */
export type UpdateMeSuccess = {
  __typename?: 'UpdateMeSuccess';
  /** 更新後の自身の情報 */
  me: User;
};

export type UpdateMemoFailed = {
  __typename?: 'UpdateMemoFailed';
  reason: Scalars['String'];
};

export type UpdateMemoForPcInput = {
  /** メモID */
  id: Scalars['ID'];
  /** 優先度 */
  priority: Scalars['Int'];
};

export type UpdateMemoInput = {
  /** 内容 */
  description?: InputMaybe<Scalars['String']>;
  id: Scalars['ID'];
  /** メモ名 */
  name?: InputMaybe<Scalars['String']>;
  /** 備考 */
  remark?: InputMaybe<Scalars['String']>;
};

export type UpdateMemoResult = UpdateMemoFailed | UpdateMemoSuccess;

export type UpdateMemoSuccess = {
  __typename?: 'UpdateMemoSuccess';
  memo: Memo;
};

/** メモリ更新失敗 */
export type UpdateMemoryFailed = {
  __typename?: 'UpdateMemoryFailed';
  /** 理由 */
  reason: Scalars['String'];
};

/** メモリ更新インプット */
export type UpdateMemoryInput = {
  /** メモリ */
  id: Scalars['ID'];
  /** 値 */
  value?: InputMaybe<Scalars['String']>;
};

/** メモリ更新結果 */
export type UpdateMemoryResult = UpdateMemoryFailed | UpdateMemorySuccess;

/** メモリ更新成功 */
export type UpdateMemorySuccess = {
  __typename?: 'UpdateMemorySuccess';
  /** 更新後のメモリ */
  memory: Memory;
};

export type UpdateMemosForPcFailed = {
  __typename?: 'UpdateMemosForPcFailed';
  reason: Scalars['String'];
};

export type UpdateMemosForPcInput = {
  memos: Array<UpdateMemoForPcInput>;
  pc: Scalars['ID'];
};

export type UpdateMemosForPcResult = UpdateMemosForPcFailed | UpdateMemosForPcSuccess;

export type UpdateMemosForPcSuccess = {
  __typename?: 'UpdateMemosForPcSuccess';
  pc: Pc;
};

/** 通知更新失敗 */
export type UpdateNotificationFailed = {
  __typename?: 'UpdateNotificationFailed';
  /** 理由 */
  reason: Scalars['String'];
};

/** 通知更新インプット */
export type UpdateNotificationInput = {
  /** 通知種別 */
  buttonType?: InputMaybe<Scalars['Int']>;
  /** 更新対象の通知ID */
  id: Scalars['ID'];
  /** 呼出を行うキーコード文字列 */
  keyText?: InputMaybe<Scalars['String']>;
  /**
   * 対象通知を保有するカンパニー
   *
   * 原則として認証ユーザが属するカンパニーの通知のみを更新対象とすることができますが、
   * 他カンパニーの通知を更新対象とする場合は当フィールドを指定してください。
   */
  owner?: InputMaybe<Scalars['ID']>;
  /** 備考 */
  remark?: InputMaybe<Scalars['String']>;
  /** 通知タイミング */
  timing?: InputMaybe<Array<MediaEventType>>;
  /** 通知先のユーザーグループ一覧 */
  userGroups?: InputMaybe<Array<Scalars['ID']>>;
  /** 待機画面向けの呼出中表示テキスト */
  value?: InputMaybe<Scalars['String']>;
  /** 通知の表示名 */
  viewData?: InputMaybe<Scalars['String']>;
  /** Web Hooks のテキスト */
  webHookText?: InputMaybe<Scalars['String']>;
  /** Web Hook の URL */
  webHookUrl?: InputMaybe<Scalars['URL']>;
};

/** 通知更新結果 */
export type UpdateNotificationResult = UpdateNotificationFailed | UpdateNotificationSuccess;

/** 通知更新成功 */
export type UpdateNotificationSuccess = {
  __typename?: 'UpdateNotificationSuccess';
  /** 更新後の通知 */
  notification: Notification;
};

/** 遠隔操作情報の更新失敗 */
export type UpdateOperationFailed = {
  __typename?: 'UpdateOperationFailed';
  reason: Scalars['String'];
};

export type UpdateOperationInput = {
  /** RURAブラウザ状態 */
  browserStatus?: InputMaybe<BrowserStatus>;
  /** RURAブラウザ 終了時間(hh:mm) */
  finishTime?: InputMaybe<Scalars['Time']>;
  id: Scalars['ID'];
  /** ローカルサーバー状態 */
  localServerStatus?: InputMaybe<LocalServerStatus>;
  /** PCへの命令および状態 */
  pcStatus?: InputMaybe<PcStatus>;
  /** 備考 */
  remark?: InputMaybe<Scalars['String']>;
  /** RURAブラウザ 開始時間(hh:mm) */
  startTime?: InputMaybe<Scalars['Time']>;
  /** 曜日指定 */
  weekDays?: InputMaybe<Array<WeekDay>>;
};

export type UpdateOperationResult = UpdateOperationFailed | UpdateOperationSuccess;

/** 遠隔操作情報の更新成功 */
export type UpdateOperationSuccess = {
  __typename?: 'UpdateOperationSuccess';
  /** 更新後の遠隔操作情報 */
  operation: Operation;
};

/** PC 外部連携更新失敗 */
export type UpdatePcCooperationFailed = {
  __typename?: 'UpdatePcCooperationFailed';
  /** 失敗理由 */
  reason: Scalars['String'];
};

/** PC 外部連携更新インプット */
export type UpdatePcCooperationInput = {
  /** 更新対象のPC外部連携ID */
  id: Scalars['ID'];
  /** 外部連携名 */
  name?: InputMaybe<Scalars['String']>;
  /** 連携対象PC */
  pc?: InputMaybe<Scalars['ID']>;
  /** パーミッション */
  permission?: InputMaybe<PcCooperationPermission>;
  /** トークン */
  token?: InputMaybe<Scalars['UUID']>;
};

/** PC 外部連携更新結果 */
export type UpdatePcCooperationResult = UpdatePcCooperationFailed | UpdatePcCooperationSuccess;

/** PC 外部連携更新成功 */
export type UpdatePcCooperationSuccess = {
  __typename?: 'UpdatePcCooperationSuccess';
  /** 更新済みのPC外部連携 */
  pcCooperation: PcCooperation;
};

export type UpdatePcFailed = {
  __typename?: 'UpdatePcFailed';
  reason?: Maybe<Scalars['String']>;
};

/** PC 更新インプット */
export type UpdatePcInput = {
  /** バーコード有無 */
  barcodeFlg?: InputMaybe<Scalars['Boolean']>;
  /** カメラリスト */
  cameraList?: InputMaybe<Array<Scalars['String']>>;
  /** 表示オプション */
  displayOption?: InputMaybe<DisplayOption>;
  /**
   * 機能トグル一覧
   *
   * 設定を変更したい機能トグルを一覧で指定してください。
   * 未指定の機能は無視されます。
   */
  featureToggles?: InputMaybe<Array<FeatureToggleInput>>;
  /** 更新対象の PC */
  id: Scalars['ID'];
  /** IP アドレス */
  ipAddress?: InputMaybe<Scalars['IPAddress']>;
  /** PC 名 */
  name?: InputMaybe<Scalars['String']>;
  /**
   * 対象 PC を保有するカンパニー
   *
   * 原則として認証ユーザが属するカンパニーの PC のみを更新対象とすることができますが、
   * 他カンパニーの PC を更新対象とする場合は当フィールドを指定してください。
   */
  owner?: InputMaybe<Scalars['ID']>;
  /** プラン種別 */
  planType?: InputMaybe<PlanType>;
  /** 接客種別 */
  receptionType?: InputMaybe<Scalars['ID']>;
  /**
   * 遠隔操作機器の IP アドレス一覧
   *
   * 原則として IPv4 形式の IP アドレスを指定してください。
   * ただし 遠隔操作機器が Android 端末の場合は "android" という文字列を指定する必要があります。
   */
  remoteIPList?: InputMaybe<Array<Scalars['String']>>;
  /** PC が属するルーム */
  room?: InputMaybe<Scalars['ID']>;
  /** 表示名 */
  viewName?: InputMaybe<Scalars['String']>;
};

export type UpdatePcResult = UpdatePcFailed | UpdatePcSuccess;

export type UpdatePcSuccess = {
  __typename?: 'UpdatePcSuccess';
  pc: Pc;
};

export type UpdatePcsForBranchFailed = {
  __typename?: 'UpdatePcsForBranchFailed';
  reason: Scalars['String'];
};

export type UpdatePcsForBranchInput = {
  /** 対象の支店 */
  branch: Scalars['ID'];
  /**
   * 支店が属するカンパニー
   *
   * 原則として認証ユーザーが属するカンパニーの支店のPC一覧のみを更新可能ですが、
   * 当引数で指定されたカンパニーの支店のPC一覧を更新対象とします。
   */
  company?: InputMaybe<Scalars['ID']>;
  /**
   * 支店管理下としたいPC一覧
   * 支店とPCとの関連を一度全削除し、与えられたPCの各々で関連を作成します
   */
  pcs?: InputMaybe<Array<Scalars['ID']>>;
};

export type UpdatePcsForBranchResult = UpdatePcsForBranchFailed | UpdatePcsForBranchSuccess;

export type UpdatePcsForBranchSuccess = {
  __typename?: 'UpdatePcsForBranchSuccess';
  /** 支店管理下から外れたPC一覧 */
  pcs?: Maybe<Array<Scalars['ID']>>;
};

/** プロフィール更新失敗 */
export type UpdateProfileFailed = {
  __typename?: 'UpdateProfileFailed';
  reason?: Maybe<Scalars['String']>;
};

/** プロフィール更新インプット */
export type UpdateProfileInput = {
  /** 接客時のアバター */
  avatar?: InputMaybe<Scalars['ID']>;
  /** アイコン画像URL */
  icon?: InputMaybe<Scalars['URL']>;
  /** Eメールアドレス */
  mail?: InputMaybe<Scalars['Email']>;
  /** ユーザー個別の設定情報 */
  setting?: InputMaybe<Scalars['JSON']>;
};

/** プロフィール更新結果 */
export type UpdateProfileResult = UpdateProfileFailed | UpdateProfileSuccess;

/** プロフィール更新成功 */
export type UpdateProfileSuccess = {
  __typename?: 'UpdateProfileSuccess';
  profile: UserProfile;
};

/**
 * 遠隔操作端末更新失敗 - 固定IPの重複
 *
 * 店舗に紐づいている他の遠隔操作端末に同じ固定IPが設定されていた場合のエラー
 */
export type UpdateRemoteControllerDuplicateStaticIpv4InShop = {
  __typename?: 'UpdateRemoteControllerDuplicateStaticIpv4InShop';
  /** 店舗の datastoreId */
  pcDatastoreId: Scalars['String'];
  /** 店舗名 */
  pcName: Scalars['String'];
};

/** 遠隔操作端末更新失敗 */
export type UpdateRemoteControllerFailed = {
  __typename?: 'UpdateRemoteControllerFailed';
  /** 理由 */
  reason: Scalars['String'];
};

export type UpdateRemoteControllerInput = {
  /** カンパニー */
  company?: InputMaybe<Scalars['ID']>;
  /** 遠隔操作端末ID */
  id: Scalars['ID'];
  /** 接客画面への表示 */
  isActive?: InputMaybe<Scalars['Boolean']>;
  /** 端末名 */
  name?: InputMaybe<Scalars['String']>;
  /** 使用店舗 */
  pc?: InputMaybe<Scalars['ID']>;
  /** 固定IP */
  staticIpv4?: InputMaybe<Scalars['IPAddress']>;
};

/** 遠隔操作端末更新結果 */
export type UpdateRemoteControllerResult = UpdateRemoteControllerDuplicateStaticIpv4InShop | UpdateRemoteControllerFailed | UpdateRemoteControllerSuccess;

/** 遠隔操作端末更新成功 */
export type UpdateRemoteControllerSuccess = {
  __typename?: 'UpdateRemoteControllerSuccess';
  /** 更新後の遠隔操作端末 */
  remoteController: RemoteController;
};

/** ルーム更新失敗 */
export type UpdateRoomFailed = {
  __typename?: 'UpdateRoomFailed';
  reason: Scalars['String'];
};

/** ルームグループ更新失敗 */
export type UpdateRoomGroupFailed = {
  __typename?: 'UpdateRoomGroupFailed';
  reason: Scalars['String'];
};

/** ルームグループ更新インプット */
export type UpdateRoomGroupInput = {
  /** ルームグループのID */
  id: Scalars['ID'];
  /** ルームグループ名 */
  name?: InputMaybe<Scalars['String']>;
  /**
   * ルームグループを所有するカンパニー
   *
   * 原則として認証ユーザが属するカンパニーのルームグループのみを更新対象とすることができますが、
   * 他カンパニーのルームグループを更新対象とする場合は当フィールドを指定してください。
   */
  owner?: InputMaybe<Scalars['ID']>;
  /** 備考 */
  remark?: InputMaybe<Scalars['String']>;
  /**
   * ルーム一覧
   *
   * 指定されたルームを当ルームグループに所属させます。
   * なお、他のルームグループに属している場合は当ルームグループに移動します。
   *
   * また、ルームとの紐付きを一括解除した場合は空配列を指定してください。
   */
  rooms?: InputMaybe<Array<Scalars['ID']>>;
};

/** ルームグループ更新結果 */
export type UpdateRoomGroupResult = UpdateRoomGroupFailed | UpdateRoomGroupSuccess;

/** ルームグループ更新成功 */
export type UpdateRoomGroupSuccess = {
  __typename?: 'UpdateRoomGroupSuccess';
  roomGroup: RoomGroup;
};

/** ルーム更新インプット */
export type UpdateRoomInput = {
  /** 連携外部サービス */
  externalServices?: InputMaybe<Array<ExternalService>>;
  /** ルームのID */
  id: Scalars['ID'];
  /** 自由に接客開始可能であるか */
  isFreeReception?: InputMaybe<Scalars['Boolean']>;
  /** ルーム名 */
  name?: InputMaybe<Scalars['String']>;
  /**
   * ルームを所有するカンパニー
   *
   * 原則として認証ユーザが属するカンパニーのルームのみを更新対象とすることができますが、
   * 他カンパニーのルームを更新対象とする場合は当フィールドを指定してください。
   */
  owner?: InputMaybe<Scalars['ID']>;
  /** PC 一覧 */
  pcList?: InputMaybe<Array<Scalars['ID']>>;
  /** 契約タイプ */
  planType?: InputMaybe<PlanType>;
  /** 備考 */
  remark?: InputMaybe<Scalars['String']>;
  /** ルームNo */
  roomNo?: InputMaybe<Scalars['Int']>;
};

/** ルーム更新結果 */
export type UpdateRoomResult = UpdateRoomFailed | UpdateRoomSuccess;

/** ルーム更新成功 */
export type UpdateRoomSuccess = {
  __typename?: 'UpdateRoomSuccess';
  room: Room;
};

export type UpdateRuraPcSettingFailed = {
  __typename?: 'UpdateRuraPcSettingFailed';
  reason: Scalars['String'];
};

export type UpdateRuraPcSettingInput = {
  /**
   * 更新対象のRURA PC Settingの所属カンパニー
   *
   * 原則として認証ユーザーが属するカンパニーのRURA PC Settingのみアクセス可能ですが、
   * 当引数で指定されたカンパニーのRURA PC Settingを取得対象とします。
   */
  company?: InputMaybe<Scalars['ID']>;
  /** マイクのスレッド */
  micThresholdMultiple?: InputMaybe<Scalars['Int']>;
  /** カメラのチャンネル */
  motionDetectChannel?: InputMaybe<Scalars['Int']>;
  /** 非認識箇所の設定 */
  motionDetectMasking?: InputMaybe<Array<Scalars['Int']>>;
  /** 認識サイズ */
  motionDetectMaxArea?: InputMaybe<Scalars['Int']>;
  /** 動態検知のカメラ指定 */
  motionDetectSaturationLine?: InputMaybe<Scalars['Float']>;
  /** USBカメラでのモーションディテクト機能 */
  motionDetectThread?: InputMaybe<Scalars['Boolean']>;
  /** 動態検知のカメラタイプ */
  motionDetectType?: InputMaybe<MotionDetectType>;
  /** 動態検知を表示するかの指定 */
  motionDetectViewFlg?: InputMaybe<Scalars['Boolean']>;
  /** ネットワークカメラの定期撮影機能 */
  networkCameraThread?: InputMaybe<Scalars['Boolean']>;
  /** ネットワークカメラのタイミング */
  networkCameraTiming?: InputMaybe<NetWorkCameraTiming>;
  /** ネットワークカメラの画像保存ディレクトリ */
  networkCameraTimingSaveDir?: InputMaybe<Scalars['String']>;
  /** 更新対象のRURA PC Settingが紐づいているPC */
  pc?: InputMaybe<Scalars['ID']>;
  /** 更新対象のRURA PC Setting */
  setting?: InputMaybe<Scalars['ID']>;
  /** 強制マイクサウンドセット機能 */
  threadForceSetMicAudio?: InputMaybe<Scalars['Boolean']>;
  /** 物理ボタン認識スレッド */
  threadPhysicalButton?: InputMaybe<Scalars['Boolean']>;
  /** 自動ダウンロード */
  updaterDownload?: InputMaybe<Scalars['Boolean']>;
  /** 自動インストール */
  updaterInstall?: InputMaybe<Scalars['Boolean']>;
  /** アップデート開始時刻(hh:mm形式) */
  updaterTime?: InputMaybe<Scalars['Time']>;
};

export type UpdateRuraPcSettingResult = UpdateRuraPcSettingFailed | UpdateRuraPcSettingSuccess;

export type UpdateRuraPcSettingSuccess = {
  __typename?: 'UpdateRuraPcSettingSuccess';
  ruraPcSetting: RuraPcSetting;
};

export type UpdateScenarioFailed = {
  __typename?: 'UpdateScenarioFailed';
  reason: Scalars['String'];
};

export type UpdateScenarioInput = {
  /**
   * 更新対象カンパニー
   *
   * 原則として認証ユーザーが属するカンパニーのシナリオを更新可能ですが、
   * 当引数で指定されたカンパニーのシナリオを更新対象とします。
   */
  company?: InputMaybe<Scalars['ID']>;
  /** シナリオ機能使用先PCモニタにおける表示向き */
  monitorOrientation?: InputMaybe<MonitorOrientation>;
  /** シナリオ名 */
  name?: InputMaybe<Scalars['String']>;
  /** 備考 */
  remark?: InputMaybe<Scalars['String']>;
  /** 先頭シナリオビュー(nullを指定したとき、または更新対象のシナリオにすでに先頭シナリオビューが設定済みであるとき無視されます) */
  rootScenarioView?: InputMaybe<Scalars['ID']>;
  /** 更新対象のシナリオID */
  scenario: Scalars['ID'];
};

export type UpdateScenarioResult = UpdateScenarioFailed | UpdateScenarioSuccess;

export type UpdateScenarioSuccess = {
  __typename?: 'UpdateScenarioSuccess';
  scenario: Scenario;
};

export type UpdateScenarioViewButtonFailed = {
  __typename?: 'UpdateScenarioViewButtonFailed';
  reason: Scalars['String'];
};

export type UpdateScenarioViewButtonInput = {
  /** シナリオボタン種別 */
  buttonType: ScenarioViewButtonType;
  /** 色 */
  color?: InputMaybe<ScenarioViewButtonColor>;
  /**
   * 更新対象カンパニー
   *
   * 原則として認証ユーザーが属するカンパニーのシナリオビューボタンを更新可能ですが、
   * 当引数で指定されたカンパニーのシナリオビューボタンを更新対象とします。
   */
  company?: InputMaybe<Scalars['ID']>;
  /** ボタン表示 */
  displayText?: InputMaybe<Scalars['String']>;
  /** Fill */
  fill?: InputMaybe<ScenarioViewButtonFill>;
  /**
   * ボタン名
   * @deprecated displayText に統合されました
   */
  name?: InputMaybe<Scalars['String']>;
  /** 遷移先シナリオビュー */
  nextScenarioView?: InputMaybe<Scalars['ID']>;
  /** 通知ID */
  notification?: InputMaybe<Scalars['ID']>;
  /** 更新対象ボタン配置先シナリオビューID */
  scenarioView: Scalars['ID'];
  /** 更新対象シナリオビューボタンID */
  scenarioViewButton: Scalars['ID'];
  /**
   * サイズ
   * @deprecated サイズは固定になったため変更不可です
   */
  size?: InputMaybe<ScenarioViewButtonSize>;
};

export type UpdateScenarioViewButtonResult = UpdateScenarioViewButtonFailed | UpdateScenarioViewButtonSuccess;

export type UpdateScenarioViewButtonSuccess = {
  __typename?: 'UpdateScenarioViewButtonSuccess';
  /** 更新後シナリオビューボタン */
  scenarioViewButton: ScenarioViewButton;
};

export type UpdateScenarioViewFailed = {
  __typename?: 'UpdateScenarioViewFailed';
  reason: Scalars['String'];
};

/** シナリオビュー固定ボタン更新インプット */
export type UpdateScenarioViewFixedButtonInput = {
  /** 色 */
  color?: InputMaybe<ScenarioViewButtonColor>;
  /** 表示名 */
  displayText?: InputMaybe<Scalars['String']>;
  /** 塗りつぶし */
  fill?: InputMaybe<ScenarioViewButtonFill>;
  /** 更新対象のシナリオビュー固定ボタン */
  id: Scalars['ID'];
  /**
   * 遷移先シナリオビューID
   *
   * 未指定の場合は、遷移先を未設定に更新します。
   * 未設定に更新されたくない場合は、更新前と同じシナリオビューIDを指定してください。
   */
  nextScenarioViewID?: InputMaybe<Scalars['ID']>;
  /**
   * ボタン押下時の通知
   *
   * 未指定の場合は、通知を未設定に更新します。
   * 未設定に更新されたくない場合は、更新前と同じ通知を指定してください。
   */
  notification?: InputMaybe<Scalars['ID']>;
  /** ボタンを表示するか */
  show?: InputMaybe<Scalars['Boolean']>;
};

export type UpdateScenarioViewInput = {
  /**
   * 背景 画像/動画
   *
   * 変更したくない場合、同じIDを設定すること
   * null値を渡したとき、背景メディアが未設定となります
   */
  backGroundMedia?: InputMaybe<Scalars['ID']>;
  /** ボタン配置 */
  buttonsPosition?: InputMaybe<ButtonsPosition>;
  /** ボタン表示時の列数 */
  colsButtonsArrangement?: InputMaybe<ColsButtonsArrangement>;
  /**
   * 更新対象カンパニー
   *
   * 原則として認証ユーザーが属するカンパニーのシナリオビューを更新可能ですが、
   * 当引数で指定されたカンパニーのシナリオビューを更新対象とします。
   */
  company?: InputMaybe<Scalars['ID']>;
  /** 固定ボタン一覧 */
  fixedButtons?: InputMaybe<Array<UpdateScenarioViewFixedButtonInput>>;
  /** タイムアウトを動画と同じ長さにする */
  isAdjustmentVideoPlaytime?: InputMaybe<Scalars['Boolean']>;
  /** シナリオビュー名 */
  name?: InputMaybe<Scalars['String']>;
  /**
   * 更新対象シナリオビューID
   *
   * シナリオビューとシナリオボタンの紐付きの意図しない変更を防止するためのものです
   * 毎回シナリオビューボタンが配置されているシナリオビューIDを指定してください。
   */
  scenarioView: Scalars['ID'];
  /**
   * 人検知遷移先シナリオビュー
   *
   * 変更したくない場合は、更新前と同じシナリオビューを指定してください。
   * 未指定の場合は、遷移先を未設定に更新します。
   */
  scenarioViewOnDetection?: InputMaybe<Scalars['ID']>;
  /**
   * タイムアウト時遷移先シナリオビュー
   *
   * 変更したくない場合は、更新前と同じシナリオビューを指定してください。
   * 未指定の場合は、遷移先を未設定に更新します。
   */
  scenarioViewOnTimeout?: InputMaybe<Scalars['ID']>;
  /** タイムアウト秒数 */
  timeoutSeconds?: InputMaybe<Scalars['Int']>;
};

export type UpdateScenarioViewResult = UpdateScenarioViewFailed | UpdateScenarioViewSuccess;

export type UpdateScenarioViewSuccess = {
  __typename?: 'UpdateScenarioViewSuccess';
  scenarioView: ScenarioView;
};

/** スピーチ更新失敗 */
export type UpdateSpeechFailed = {
  __typename?: 'UpdateSpeechFailed';
  reason?: Maybe<Scalars['String']>;
};

export type UpdateSpeechForPcInput = {
  id: Scalars['ID'];
  /** 優先度 */
  priority?: InputMaybe<Scalars['Int']>;
};

export type UpdateSpeechGroupFailed = {
  __typename?: 'UpdateSpeechGroupFailed';
  reason?: Maybe<Scalars['String']>;
};

export type UpdateSpeechGroupInput = {
  id: Scalars['ID'];
  /** グループ名 */
  name?: InputMaybe<Scalars['String']>;
  /** 優先度 */
  priority?: InputMaybe<Scalars['Int']>;
};

export type UpdateSpeechGroupResult = UpdateSpeechGroupFailed | UpdateSpeechGroupSuccess;

export type UpdateSpeechGroupSuccess = {
  __typename?: 'UpdateSpeechGroupSuccess';
  speechGroup: SpeechGroup;
};

/** スピーチ更新インプット */
export type UpdateSpeechInput = {
  /** 更新対象スピーチ */
  id: Scalars['ID'];
  /** スピーチ名 */
  name?: InputMaybe<Scalars['String']>;
  /** 備考 */
  remark?: InputMaybe<Scalars['String']>;
  /** スピーチVal */
  value?: InputMaybe<Scalars['String']>;
};

/** スピーチ更新結果 */
export type UpdateSpeechResult = UpdateSpeechFailed | UpdateSpeechSuccess;

/** スピーチ更新成功 */
export type UpdateSpeechSuccess = {
  __typename?: 'UpdateSpeechSuccess';
  speech: Speech;
};

export type UpdateSpeechesForPcFailed = {
  __typename?: 'UpdateSpeechesForPcFailed';
  reason: Scalars['String'];
};

export type UpdateSpeechesForPcInput = {
  pc: Scalars['ID'];
  speeches: Array<UpdateSpeechForPcInput>;
};

export type UpdateSpeechesForPcResult = UpdateSpeechesForPcFailed | UpdateSpeechesForPcSuccess;

export type UpdateSpeechesForPcSuccess = {
  __typename?: 'UpdateSpeechesForPcSuccess';
  pc: Pc;
};

export type UpdateSystemNotificationFailed = {
  __typename?: 'UpdateSystemNotificationFailed';
  reason: Scalars['String'];
};

export type UpdateSystemNotificationInput = {
  /** 詳細 */
  detail?: InputMaybe<Scalars['String']>;
  /** システム通知ID */
  id: Scalars['ID'];
  /** 通知日時 */
  notificationAt?: InputMaybe<Scalars['Time']>;
  /** タイトル */
  title?: InputMaybe<Scalars['String']>;
  /** リンク先 */
  url?: InputMaybe<Scalars['URL']>;
};

export type UpdateSystemNotificationResult = UpdateSystemNotificationFailed | UpdateSystemNotificationSuccess;

export type UpdateSystemNotificationSuccess = {
  __typename?: 'UpdateSystemNotificationSuccess';
  systemNotification: SystemNotification;
};

export type UpdateSystemUserFailed = {
  __typename?: 'UpdateSystemUserFailed';
  reason: Scalars['String'];
};

/** システムユーザー更新インプット */
export type UpdateSystemUserInput = {
  /**
   * システムユーザーが属するカンパニー
   *
   * 原則として認証ユーザーのカンパニーにシステムユーザーが作成されます。
   * ただし、タイムリープユーザーの場合はカンパニーに指定が可能です。
   */
  company?: InputMaybe<Scalars['ID']>;
  /** システムユーザー名 */
  name?: InputMaybe<Scalars['String']>;
  /** パスワード */
  password?: InputMaybe<Scalars['String']>;
  /** 備考 */
  remark?: InputMaybe<Scalars['String']>;
  /** ロール */
  role?: InputMaybe<Role>;
};

export type UpdateSystemUserResult = UpdateSystemUserFailed | UpdateSystemUserSuccess;

export type UpdateSystemUserSuccess = {
  __typename?: 'UpdateSystemUserSuccess';
  user: User;
};

/** テンプレート更新失敗 */
export type UpdateTemplateFailed = {
  __typename?: 'UpdateTemplateFailed';
  reason: Scalars['String'];
};

/** テンプレート更新インプット */
export type UpdateTemplateInput = {
  /** 画面サイズ 高さ */
  displaySizeHeight?: InputMaybe<Scalars['Int']>;
  /** 画面サイズ 幅 */
  displaySizeWidth?: InputMaybe<Scalars['Int']>;
  /** テンプレートID */
  id: Scalars['ID'];
  /** テンプレート名 */
  name?: InputMaybe<Scalars['String']>;
  /**
   * 使用中店舗
   *
   * - 未指定: 店舗とのひも付きは更新されません。
   * - 空配列: 店舗とのひも付きを全て解除します。
   * - それ以外: 指定された店舗と紐づきを更新します。
   */
  pcs?: InputMaybe<Array<Scalars['ID']>>;
  /** 備考 */
  remark?: InputMaybe<Scalars['String']>;
};

/** テンプレート更新結果 */
export type UpdateTemplateResult = UpdateTemplateFailed | UpdateTemplateSuccess;

/** テンプレート更新成功 */
export type UpdateTemplateSuccess = {
  __typename?: 'UpdateTemplateSuccess';
  template: Template;
};

export type UpdateUserFailed = {
  __typename?: 'UpdateUserFailed';
  reason?: Maybe<Scalars['String']>;
};

export type UpdateUserGroupFailed = {
  __typename?: 'UpdateUserGroupFailed';
  reason: Scalars['String'];
};

export type UpdateUserGroupInput = {
  /**
   * 更新対象カンパニー
   *
   * 原則、認証ユーザーが属するカンパニーのユーザー・グループを更新しますが、
   * 他カンパニーのユーザー・グループを更新する場合は当フィールドを指定してください。
   */
  company?: InputMaybe<Scalars['ID']>;
  /** ユーザーグループID */
  id: Scalars['ID'];
  /** 変更後ユーザーグループ名 */
  name?: InputMaybe<Scalars['String']>;
  /** 変更後ユーザーグループで管理する対象ユーザー */
  users?: InputMaybe<Array<Scalars['ID']>>;
};

export type UpdateUserGroupResult = UpdateUserGroupFailed | UpdateUserGroupSuccess;

export type UpdateUserGroupSuccess = {
  __typename?: 'UpdateUserGroupSuccess';
  userGroup: UserGroup;
};

export type UpdateUserInput = {
  /**
   * システムユーザーが属するカンパニー
   *
   * 原則として認証ユーザーのカンパニーにシステムユーザーが作成されます。
   * ただし、タイムリープユーザーの場合はカンパニーに指定が可能です。
   */
  company?: InputMaybe<Scalars['ID']>;
  /** 更新対象ユーザー */
  id: Scalars['ID'];
  /** ユーザー名 */
  name?: InputMaybe<Scalars['String']>;
  /** パスワード */
  password?: InputMaybe<Scalars['String']>;
  /** 備考 */
  remark?: InputMaybe<Scalars['String']>;
  /** ロール */
  role?: InputMaybe<Role>;
  /** ルームグループ */
  roomGroup?: InputMaybe<Scalars['ID']>;
};

export type UpdateUserResult = UpdateUserFailed | UpdateUserSuccess;

export type UpdateUserSuccess = {
  __typename?: 'UpdateUserSuccess';
  user: User;
};

/** 動画更新失敗 */
export type UpdateVideoFailed = {
  __typename?: 'UpdateVideoFailed';
  reason: Scalars['String'];
};

export type UpdateVideoForPcInput = {
  id: Scalars['ID'];
  priority?: InputMaybe<Scalars['Int']>;
};

/** 動画更新インプット */
export type UpdateVideoInput = {
  /** 更新対象動画 */
  id: Scalars['ID'];
  /** 動画名 */
  name?: InputMaybe<Scalars['String']>;
  /** 備考 */
  remark?: InputMaybe<Scalars['String']>;
  /** 動画Val */
  value?: InputMaybe<Scalars['String']>;
};

/** 動画更新結果 */
export type UpdateVideoResult = UpdateVideoFailed | UpdateVideoSuccess;

/** 動画更新成功 */
export type UpdateVideoSuccess = {
  __typename?: 'UpdateVideoSuccess';
  video: Video;
};

export type UpdateVideosForPcFailed = {
  __typename?: 'UpdateVideosForPcFailed';
  reason?: Maybe<Scalars['String']>;
};

export type UpdateVideosForPcInput = {
  pcId: Scalars['ID'];
  videos: Array<UpdateVideoForPcInput>;
};

export type UpdateVideosForPcResult = UpdateVideosForPcFailed | UpdateVideosForPcSuccess;

export type UpdateVideosForPcSuccess = {
  __typename?: 'UpdateVideosForPcSuccess';
  videos: Array<Video>;
};

/** 分析写真アップロード失敗 */
export type UploadAnPictureFailed = {
  __typename?: 'UploadAnPictureFailed';
  /** 失敗理由 */
  reason?: Maybe<Scalars['String']>;
};

/** 分析写真アップロードパラメータ */
export type UploadAnPictureInput = {
  /** カメラID */
  cameraId?: InputMaybe<Scalars['String']>;
  /** カンパニーID */
  companyId: Scalars['String'];
  /** ファイルパス */
  fileName: Scalars['URL'];
  /** PC ID */
  pcId: Scalars['String'];
};

/** 分析写真アップロード結果 */
export type UploadAnPictureResult = UploadAnPictureFailed | UploadAnPictureSuccess;

/** 分析写真アップロード成功 */
export type UploadAnPictureSuccess = {
  __typename?: 'UploadAnPictureSuccess';
  /** 結果 */
  ok: Scalars['Boolean'];
};

/** ユーザー */
export type User = Node & {
  __typename?: 'User';
  /** 背景画像No */
  backgroundImageNo?: Maybe<Scalars['Int']>;
  /** ユーザーが所属するカンパニー */
  company: Company;
  /** データストアID */
  datastoreId: Scalars['String'];
  /** オブジェクトID */
  id: Scalars['ID'];
  /** ユーザー名 */
  name: Scalars['String'];
  /** システム通知を最後に確認した日時 */
  notificationTimestamp?: Maybe<Scalars['Time']>;
  /** パスワードのハッシュ値 */
  password: Scalars['String'];
  /** プロフィール */
  profile: UserProfile;
  /** 備考 */
  remark?: Maybe<Scalars['String']>;
  /** ユーザータイプがリモコンであるときの、遠隔操作端末 */
  remoteControllers?: Maybe<Array<RemoteController>>;
  /** ロール */
  role: Role;
  /** ルームグループ */
  roomGroup?: Maybe<RoomGroup>;
  /** 認証用トークン */
  token: Scalars['UUID'];
  /** 認証用トークンの有効期限 */
  tokenExpiration?: Maybe<Scalars['Time']>;
  /** 自身が属するユーザーグループ一覧 */
  userGroups?: Maybe<Array<UserGroup>>;
  /** ユーザー種別 */
  userType: UserType;
  /**
   * UUID
   *
   * ユーザーを一意に識別するためのユニークな値です
   */
  uuid: Scalars['UUID'];
};

/** User コネクション */
export type UserConnection = Connection & {
  __typename?: 'UserConnection';
  /** エッジ一覧 */
  edges: Array<UserEdge>;
  /** ノード一覧 */
  nodes: Array<User>;
  /** ページ情報 */
  pageInfo: PageInfo;
  /** 総件数 */
  totalCount: Scalars['Int'];
};

/** User エッジ */
export type UserEdge = Edge & {
  __typename?: 'UserEdge';
  /** カーソル */
  cursor: Scalars['String'];
  /** ノード */
  node: User;
};

/** ユーザーグループ */
export type UserGroup = Node & {
  __typename?: 'UserGroup';
  /** グループ所有カンパニー */
  company: Company;
  /** データストアID */
  datastoreId: Scalars['Int'];
  /** オブジェクトID */
  id: Scalars['ID'];
  /** グループ名 */
  name: Scalars['String'];
  /** 通知一覧 */
  notifications?: Maybe<Array<Notification>>;
  /** ユーザー一覧 */
  users?: Maybe<Array<User>>;
};

/** Frameコネクション */
export type UserGroupConnection = Connection & {
  __typename?: 'UserGroupConnection';
  /** エッジ一覧 */
  edges: Array<UserGroupEdge>;
  /** ノード一覧 */
  nodes: Array<UserGroup>;
  /** ページ情報 */
  pageInfo: PageInfo;
  /** 総件数 */
  totalCount: Scalars['Int'];
};

/** UserGroupエッジ */
export type UserGroupEdge = Edge & {
  __typename?: 'UserGroupEdge';
  /** カーソル */
  cursor: Scalars['String'];
  /** ノード */
  node: UserGroup;
};

/** ユーザーのソート条件 */
export type UserOrder = {
  /** ソート順 */
  direction: OrderDirection;
  /** ソート対象フィールド */
  field: UserOrderField;
};

/** ユーザーのソート可能フィールド */
export enum UserOrderField {
  /** ユーザーID */
  UserId = 'USER_ID'
}

/** ユーザーのプロフィール */
export type UserProfile = Node & {
  __typename?: 'UserProfile';
  /** 接客時のアバター */
  avatar?: Maybe<Avatar>;
  /** データストアID */
  datastoreId: Scalars['UUID'];
  /** アイコン画像URL */
  icon?: Maybe<Scalars['URL']>;
  /** オブジェクトID */
  id: Scalars['ID'];
  /** Eメールアドレス */
  mail?: Maybe<Scalars['Email']>;
  /** アイコン画像URL（署名付きURL） */
  presignedIcon?: Maybe<Scalars['URL']>;
  /** ユーザー個別の設定情報 */
  setting?: Maybe<Scalars['JSON']>;
  /** プロフィールを保有する User の datastoreId */
  userDatastoreId: Scalars['String'];
};

export type UserProfileConnection = Connection & {
  __typename?: 'UserProfileConnection';
  /** プロフィール一覧 */
  edges: Array<UserProfileEdge>;
  /** ノード一覧 */
  nodes: Array<UserProfile>;
  /** ページング情報 */
  pageInfo: PageInfo;
  /** 総件数 */
  totalCount: Scalars['Int'];
};

export type UserProfileEdge = Edge & {
  __typename?: 'UserProfileEdge';
  /** カーソル */
  cursor: Scalars['String'];
  /** プロフィール */
  node: UserProfile;
};

/** ユーザー種別 */
export enum UserType {
  /** リモコン */
  RemoteController = 'REMOTE_CONTROLLER',
  /** システム */
  System = 'SYSTEM',
  /** ユーザー */
  User = 'USER'
}

/** トークンの検証結果 */
export type VerificationToken = {
  __typename?: 'VerificationToken';
  /**
   * トークンの有効期限
   *
   * isValid が true の場合のみ設定されます
   */
  expiration?: Maybe<Scalars['Time']>;
  /** 有効なトークンであるか */
  isValid: Scalars['Boolean'];
};

/** Eメールアドレス変更処理成功 */
export type VerifyChangeEmailFailed = {
  __typename?: 'VerifyChangeEmailFailed';
  reason?: Maybe<Scalars['String']>;
};

/** Eメールアドレス変更処理インプット */
export type VerifyChangeEmailInput = {
  token: Scalars['String'];
};

/** Eメールアドレス変更処理結果 */
export type VerifyChangeEmailResult = VerifyChangeEmailFailed | VerifyChangeEmailSuccess;

/** Eメールアドレス変更処理成功 */
export type VerifyChangeEmailSuccess = {
  __typename?: 'VerifyChangeEmailSuccess';
  message?: Maybe<Scalars['String']>;
};

/** 動画 */
export type Video = Node & {
  __typename?: 'Video';
  /** カンパニー */
  company: Company;
  /** データストアID */
  datastoreId: Scalars['String'];
  /** オブジェクトID */
  id: Scalars['ID'];
  /** 動画名 */
  name: Scalars['String'];
  /** 再生時間（秒） */
  playTime?: Maybe<Scalars['Int']>;
  /** サムネイル画像のURL（署名付きURL） */
  presignedThumbnail?: Maybe<Scalars['URL']>;
  /** 署名付きURL */
  presignedUrl?: Maybe<Scalars['URL']>;
  /** 優先度 */
  priority: Scalars['Int'];
  /** 備考 */
  remark?: Maybe<Scalars['String']>;
  /** 動画URL */
  src: Scalars['URL'];
  /** サムネイル画像のURL */
  thumbnail?: Maybe<Scalars['URL']>;
  /** 動画Val */
  value: Scalars['String'];
  /** 所属する動画グループ */
  videoGroup?: Maybe<VideoGroup>;
};

/** 動画コネクション */
export type VideoConnection = Connection & {
  __typename?: 'VideoConnection';
  /** エッジ一覧 */
  edges: Array<VideoEdge>;
  /** ノード一覧 */
  nodes: Array<Video>;
  /** ページ情報 */
  pageInfo: PageInfo;
  /** 総件数 */
  totalCount: Scalars['Int'];
};

/** 動画エッジ */
export type VideoEdge = Edge & {
  __typename?: 'VideoEdge';
  /** カーソル */
  cursor: Scalars['String'];
  /** ノード */
  node: Video;
};

/** 動画グループ */
export type VideoGroup = Node & {
  __typename?: 'VideoGroup';
  /** データストアID */
  datastoreId: Scalars['String'];
  /** オブジェクトID */
  id: Scalars['ID'];
  /** 動画グループ名 */
  name: Scalars['String'];
  /** 動画グループ所有者 */
  owner: Company;
  /** 優先度 */
  priority: Scalars['Int'];
  /** グループに属する動画一覧 */
  videos?: Maybe<Array<Video>>;
};

/** 動画グループコネクション */
export type VideoGroupConnection = Connection & {
  __typename?: 'VideoGroupConnection';
  /** エッジ一覧 */
  edges: Array<VideoGroupEdge>;
  /** ノード一覧 */
  nodes: Array<VideoGroup>;
  /** ページ情報 */
  pageInfo: PageInfo;
  /** 総件数 */
  totalCount: Scalars['Int'];
};

/** 動画グループエッジ */
export type VideoGroupEdge = Edge & {
  __typename?: 'VideoGroupEdge';
  /** カーソル */
  cursor: Scalars['String'];
  /** ノード */
  node: VideoGroup;
};

/** 曜日 */
export enum WeekDay {
  /** 金曜日 */
  Friday = 'FRIDAY',
  /** 月曜日 */
  Monday = 'MONDAY',
  /** 土曜日 */
  Saturday = 'SATURDAY',
  /** 日曜日 */
  Sunday = 'SUNDAY',
  /** 木曜日 */
  Thursday = 'THURSDAY',
  /** 火曜日 */
  Tuesday = 'TUESDAY',
  /** 水曜日 */
  Wednesday = 'WEDNESDAY'
}

/** 作業ステータス */
export enum WorkingStatus {
  /** ログイン / ログアウト */
  Log = 'LOG',
  /** 休憩開始 / 休憩終了 */
  Rest = 'REST'
}

/** ワーカー勤務履歴 */
export type WorkingTime = Node & {
  __typename?: 'WorkingTime';
  /** カンパニーID */
  companyId: Scalars['String'];
  /** データストアID */
  datastoreId: Scalars['String'];
  /** 終了日時 */
  finishTimestamp?: Maybe<Scalars['Time']>;
  /** オブジェクトID */
  id: Scalars['ID'];
  /** 開始日時 */
  startTimestamp?: Maybe<Scalars['Time']>;
  /** ユーザーID */
  userId: Scalars['String'];
  /** 作業ステータス */
  workStatus: WorkingStatus;
};

/**
 * 勤務履歴サマリー
 *
 * 指定期間における勤務履歴のサマリーを表します。
 */
export type WorkingTimeSummary = {
  __typename?: 'WorkingTimeSummary';
  /** 休憩秒数 */
  restSeconds: Scalars['Int'];
  /** 接客秒数 */
  servedSeconds: Scalars['Int'];
  /** 勤務開始数 */
  startedWorkingCount: Scalars['Int'];
  /**
   * 合計秒数
   *
   * 「待機秒数」「接客秒数」「休憩秒数」の合計値
   */
  totalSeconds: Scalars['Int'];
  /** 待機秒数 */
  waitSeconds: Scalars['Int'];
};

export type GetCustomVariableQueryVariables = Exact<{
  variable: Scalars['String'];
  owner: Scalars['ID'];
}>;


export type GetCustomVariableQuery = { __typename?: 'Query', customVariable: { __typename?: 'CustomVariable', value: string } };

export type MeRoomFieldFragment = { __typename?: 'Room', id: string, datastoreId: any, name: string };

export type MeFieldFragment = { __typename?: 'User', id: string, datastoreId: string, name: string, profile: { __typename?: 'UserProfile', presignedIcon?: string | null }, roomGroup?: { __typename?: 'RoomGroup', rooms?: Array<{ __typename?: 'Room', id: string, datastoreId: any, name: string }> | null } | null, company: { __typename?: 'Company', id: string, datastoreId: string, name: string } };

export type MeQueryVariables = Exact<{ [key: string]: never; }>;


export type MeQuery = { __typename?: 'Query', me: { __typename?: 'User', id: string, datastoreId: string, name: string, profile: { __typename?: 'UserProfile', presignedIcon?: string | null }, roomGroup?: { __typename?: 'RoomGroup', rooms?: Array<{ __typename?: 'Room', id: string, datastoreId: any, name: string }> | null } | null, company: { __typename?: 'Company', id: string, datastoreId: string, name: string } } };

export type SigninMutationVariables = Exact<{
  userId: Scalars['String'];
  password: Scalars['String'];
}>;


export type SigninMutation = { __typename?: 'Mutation', signin: { __typename: 'SigninFailed', message?: string | null } | { __typename: 'SigninFrozen', message?: string | null } | { __typename: 'SigninRejection', message?: string | null } | { __typename: 'SigninSuccess', token: string } };

export const MeRoomFieldFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"MeRoomField"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Room"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"datastoreId"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]} as unknown as DocumentNode<MeRoomFieldFragment, unknown>;
export const MeFieldFragmentDoc = {"kind":"Document", "definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"MeField"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"User"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"datastoreId"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"profile"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"presignedIcon"}}]}},{"kind":"Field","name":{"kind":"Name","value":"roomGroup"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"rooms"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"MeRoomField"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"company"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"datastoreId"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},...MeRoomFieldFragmentDoc.definitions]} as unknown as DocumentNode<MeFieldFragment, unknown>;
export const GetCustomVariableDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetCustomVariable"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"variable"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"owner"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"customVariable"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"variable"},"value":{"kind":"Variable","name":{"kind":"Name","value":"variable"}}},{"kind":"Argument","name":{"kind":"Name","value":"owner"},"value":{"kind":"Variable","name":{"kind":"Name","value":"owner"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}}]} as unknown as DocumentNode<GetCustomVariableQuery, GetCustomVariableQueryVariables>;
export const MeDocument = {"kind":"Document", "definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"me"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"me"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"MeField"}}]}}]}},...MeFieldFragmentDoc.definitions]} as unknown as DocumentNode<MeQuery, MeQueryVariables>;
export const SigninDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"Signin"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"userId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"password"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"signin"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"userId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userId"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"password"},"value":{"kind":"Variable","name":{"kind":"Name","value":"password"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"SigninSuccess"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"token"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"SigninFailed"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"message"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"SigninFrozen"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"message"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"SigninRejection"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]}}]} as unknown as DocumentNode<SigninMutation, SigninMutationVariables>;


export function useGetCustomVariableQuery(options: Omit<Urql.UseQueryArgs<GetCustomVariableQueryVariables>, 'query'>) {
  return Urql.useQuery<GetCustomVariableQuery, GetCustomVariableQueryVariables>({ query: GetCustomVariableDocument, ...options });
};

export function useMeQuery(options?: Omit<Urql.UseQueryArgs<MeQueryVariables>, 'query'>) {
  return Urql.useQuery<MeQuery, MeQueryVariables>({ query: MeDocument, ...options });
};

export function useSigninMutation() {
  return Urql.useMutation<SigninMutation, SigninMutationVariables>(SigninDocument);
};